/* KiekkoKingi filter module: traditional collection route. Generated from kk-native-filters.js. */
(function () {
  var USED_DISCS_COLLECTION_HANDLE = 'used-discs';
  var WEIGHT_FILTER_PARAM = 'filter.p.m.my_fields.paino';
  var RANGE_NO_MATCH_PARAM = 'kk_native_range_no_match';

  function getCollectionHandle() {
    var root = document.querySelector('[data-kk-collection-handle]');
    var pathMatch;

    if (root && root.getAttribute('data-kk-collection-handle')) {
      return root.getAttribute('data-kk-collection-handle');
    }

    pathMatch = window.location.pathname.match(/\/collections\/([^/?#]+)/i);
    return pathMatch ? decodeURIComponent(pathMatch[1]) : '';
  }

  function isWeightFilterEnabled() {
    var root = document.querySelector('[data-kk-collection-handle]');

    if (root && root.hasAttribute('data-kk-native-weight-filter-enabled')) {
      return root.getAttribute('data-kk-native-weight-filter-enabled') === 'true';
    }

    return getCollectionHandle() === USED_DISCS_COLLECTION_HANDLE;
  }

  function isWeightRangeMarker(value) {
    var parsed;
    var facetKey;

    try {
      parsed = JSON.parse(String(value || ''));
    } catch (error) {
      return false;
    }

    if (!Array.isArray(parsed) || !parsed.length) return false;

    facetKey = String(parsed[0] || '').replace(/^filter\.p\.m\./, '');
    return facetKey === 'my_fields.paino';
  }

  function removeDisallowedWeightState() {
    var url;
    var markerValues;
    var keptMarkerValues;
    var changed = false;

    if (isWeightFilterEnabled()) return false;

    url = new URL(window.location.href);
    Array.from(url.searchParams.keys()).forEach(function (name) {
      if (name === WEIGHT_FILTER_PARAM || name.indexOf(WEIGHT_FILTER_PARAM + '.') === 0) {
        url.searchParams.delete(name);
        changed = true;
      }
    });

    markerValues = url.searchParams.getAll(RANGE_NO_MATCH_PARAM);
    keptMarkerValues = markerValues.filter(function (value) {
      return !isWeightRangeMarker(value);
    });

    if (keptMarkerValues.length !== markerValues.length) {
      url.searchParams.delete(RANGE_NO_MATCH_PARAM);
      keptMarkerValues.forEach(function (value) {
        url.searchParams.append(RANGE_NO_MATCH_PARAM, value);
      });
      changed = true;
    }

    if (changed) {
      window.location.replace(url.pathname + url.search + url.hash);
    }

    return changed;
  }

  removeDisallowedWeightState();
}());
(function () {
  var KK_NATIVE_RANGE_NO_MATCH_PARAM = 'kk_native_range_no_match';

  function deferCollectionPriorityImages(markup) {
    return String(markup || '').replace(/<img\b[^>]*\bdata-kk-collection-lcp-image(?![\w-])[^>]*>/gi, function (tag) {
      return tag
        .replace(/\sloading=(["'])eager\1/i, ' loading="lazy"')
        .replace(/\sfetchpriority=(["'])high\1/i, '')
        .replace(/\sdata-kk-collection-lcp-image(?![\w-])(?:=(["'])[^"']*\1)?/i, '');
    });
  }

  function parseCollectionResponseHtml(markup) {
    return new DOMParser().parseFromString(deferCollectionPriorityImages(markup), 'text/html');
  }

  function kkNativeRangeNumber(value, fallback) {
    var parsed = parseFloat(String(value).replace(',', '.'));

    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function kkNativeRangeValue(value) {
    return Number.isInteger(value) ? String(value) : String(value).replace(/\.0$/, '');
  }

  function kkNativeRangeParamName(root) {
    var option = root && root.querySelector('[data-kk-native-range-option][name]');

    return option && option.name ? option.name : '';
  }

  function kkNativeRangeFacetKey(root) {
    return kkNativeRangeParamName(root).replace(/^filter\.p\.m\./, '');
  }

  function kkParseNativeRangeNoMatchValue(value) {
    var parsed;
    var lower;
    var upper;

    try {
      parsed = JSON.parse(String(value || ''));
    } catch (error) {
      return null;
    }

    if (!Array.isArray(parsed) || parsed.length !== 3 || !parsed[0]) {
      return null;
    }

    lower = kkNativeRangeNumber(parsed[1], null);
    upper = kkNativeRangeNumber(parsed[2], null);

    if (lower === null || upper === null || lower > upper) {
      return null;
    }

    return {
      facetKey: String(parsed[0]),
      lower: lower,
      upper: upper,
      serialized: JSON.stringify([
        String(parsed[0]),
        kkNativeRangeValue(lower),
        kkNativeRangeValue(upper)
      ])
    };
  }

  function kkNativeRangeNoMatchEntries(query) {
    var source = String(query || '');
    var questionMark = source.indexOf('?');
    var params;

    if (questionMark > -1) source = source.slice(questionMark + 1);
    source = source.replace(/^\?/, '').split('#')[0];
    params = new URLSearchParams(source);

    return params.getAll(KK_NATIVE_RANGE_NO_MATCH_PARAM).map(function (value) {
      return kkParseNativeRangeNoMatchValue(value);
    }).filter(Boolean);
  }

  function kkGetNativeRangeNoMatch(root) {
    var marker = root && root.querySelector('[data-kk-native-range-no-match-marker]');
    var parsed = marker ? kkParseNativeRangeNoMatchValue(marker.value) : null;

    if (!parsed || parsed.facetKey !== kkNativeRangeFacetKey(root)) {
      return null;
    }

    return parsed;
  }

  function kkSetNativeRangeNoMatch(root, lower, upper) {
    var facetKey = kkNativeRangeFacetKey(root);
    var serialized;
    var marker;
    var changed;

    if (!root || !facetKey || !Number.isFinite(lower) || !Number.isFinite(upper) || lower > upper) {
      return false;
    }

    serialized = JSON.stringify([facetKey, kkNativeRangeValue(lower), kkNativeRangeValue(upper)]);
    marker = root.querySelector('[data-kk-native-range-no-match-marker]');
    changed = !marker || marker.value !== serialized;

    if (!marker) {
      marker = root.ownerDocument.createElement('input');
      marker.type = 'hidden';
      marker.name = KK_NATIVE_RANGE_NO_MATCH_PARAM;
      marker.setAttribute('data-kk-native-range-no-match-marker', '');
      root.appendChild(marker);
    }

    marker.value = serialized;
    marker.setAttribute('value', serialized);
    root.setAttribute('data-kk-native-range-no-match', 'true');
    return changed;
  }

  function kkClearNativeRangeNoMatch(root) {
    var marker = root && root.querySelector('[data-kk-native-range-no-match-marker]');
    var changed = Boolean(marker || (root && root.hasAttribute('data-kk-native-range-no-match')));

    if (marker) marker.remove();
    if (root) root.removeAttribute('data-kk-native-range-no-match');
    return changed;
  }

  function kkRestoreNativeRangeNoMatches(scope, query, clearMissing) {
    var entries = new Map();

    if (!scope || !scope.querySelectorAll) return;

    kkNativeRangeNoMatchEntries(query).forEach(function (entry) {
      entries.set(entry.facetKey, entry);
    });

    scope.querySelectorAll('[data-kk-native-range]').forEach(function (root) {
      var entry = entries.get(kkNativeRangeFacetKey(root));
      var lower;
      var upper;
      var minInput;
      var maxInput;

      if (!entry) {
        if (clearMissing) kkClearNativeRangeNoMatch(root);
        return;
      }

      root.querySelectorAll('[data-kk-native-range-option]').forEach(function (option) {
        option.checked = false;
      });
      kkSetNativeRangeNoMatch(root, entry.lower, entry.upper);

      lower = root.querySelector('[data-kk-range-lower]');
      upper = root.querySelector('[data-kk-range-upper]');
      minInput = root.querySelector('[data-kk-range-min-input]');
      maxInput = root.querySelector('[data-kk-range-max-input]');
      if (lower) lower.value = kkNativeRangeValue(entry.lower);
      if (upper) upper.value = kkNativeRangeValue(entry.upper);
      if (minInput) minInput.value = kkNativeRangeValue(entry.lower);
      if (maxInput) maxInput.value = kkNativeRangeValue(entry.upper);
      root.dispatchEvent(new Event('kk:sync-native-range-ui', { bubbles: true }));
    });
  }

  function kkStripNativeRangeNoMatches(query) {
    var source = String(query || '');
    var questionMark = source.indexOf('?');
    var params;

    if (questionMark > -1) source = source.slice(questionMark + 1);
    params = new URLSearchParams(source.replace(/^\?/, '').split('#')[0]);

    params.delete(KK_NATIVE_RANGE_NO_MATCH_PARAM);
    return params.toString();
  }

  function kkHasNativeRangeNoMatch(query) {
    return kkNativeRangeNoMatchEntries(query).length > 0;
  }

  function kkNativeRangeQueryParts(source) {
    var value = String(source || '');
    var questionMark = value.indexOf('?');
    var prefix = questionMark > -1 ? value.slice(0, questionMark) : '';
    var query = questionMark > -1 ? value.slice(questionMark + 1) : value;

    return {
      prefix: prefix,
      params: new URLSearchParams(query.split('#')[0])
    };
  }

  function kkNativeRangeJoinQuery(parts) {
    var query = parts.params.toString();

    return parts.prefix ? parts.prefix + (query ? '?' + query : '') : query;
  }

  function kkNativeRangeRootForFacet(scope, facetKey) {
    if (!scope || !scope.querySelectorAll) return null;

    return Array.prototype.find.call(scope.querySelectorAll('[data-kk-native-range]'), function (root) {
      return kkNativeRangeFacetKey(root) === facetKey;
    }) || null;
  }

  function kkNativeRangeFreshOptionAvailable(option) {
    var item;
    var countNode;
    var countMatch;

    if (!option || option.disabled || option.getAttribute('aria-disabled') === 'true') return false;

    item = option.closest && option.closest('[data-filter-item]');
    countNode = item && item.querySelector('.kk-facet__count');
    countMatch = countNode && countNode.textContent.match(/\d+/);

    return !countMatch || parseInt(countMatch[0], 10) > 0;
  }

  function kkResolveNativeRangeNoMatches(freshScope, query) {
    var parts = kkNativeRangeQueryParts(query);
    var rawMarkers = parts.params.getAll(KK_NATIVE_RANGE_NO_MATCH_PARAM);
    var remainingMarkers = rawMarkers.slice();
    var resolved = [];

    rawMarkers.forEach(function (rawMarker) {
      var marker = kkParseNativeRangeNoMatchValue(rawMarker);
      var freshRoot;
      var matchingOptions;
      var paramName;
      var seen = Object.create(null);
      var fieldValues = [];

      if (!marker) return;

      freshRoot = kkNativeRangeRootForFacet(freshScope, marker.facetKey);
      if (!freshRoot) return;

      matchingOptions = Array.prototype.filter.call(
        freshRoot.querySelectorAll('[data-kk-native-range-option][name]'),
        function (option) {
          var value = kkNativeRangeNumber(option.getAttribute('data-kk-range-value'), null);

          return value !== null &&
            value >= marker.lower &&
            value <= marker.upper &&
            kkNativeRangeFreshOptionAvailable(option);
        }
      );

      if (!matchingOptions.length) return;

      paramName = matchingOptions[0].name;
      matchingOptions.forEach(function (option) {
        if (option.name !== paramName || seen[option.value]) return;
        seen[option.value] = true;
        fieldValues.push(option.value);
      });
      if (!paramName || !fieldValues.length) return;

      remainingMarkers = remainingMarkers.filter(function (value) {
        var entry = kkParseNativeRangeNoMatchValue(value);
        return !entry || entry.serialized !== marker.serialized;
      });
      parts.params.delete(paramName);
      fieldValues.forEach(function (value) {
        parts.params.append(paramName, value);
      });
      resolved.push({
        marker: marker,
        paramName: paramName,
        fieldValues: fieldValues
      });
    });

    parts.params.delete(KK_NATIVE_RANGE_NO_MATCH_PARAM);
    remainingMarkers.forEach(function (value) {
      parts.params.append(KK_NATIVE_RANGE_NO_MATCH_PARAM, value);
    });

    return {
      changed: resolved.length > 0,
      query: kkNativeRangeJoinQuery(parts),
      resolved: resolved,
      remaining: remainingMarkers.map(kkParseNativeRangeNoMatchValue).filter(Boolean)
    };
  }

  function kkApplyNativeRangeResolutions(scope, resolutions) {
    if (!scope || !resolutions || !resolutions.length) return false;

    resolutions.forEach(function (resolution) {
      var root = kkNativeRangeRootForFacet(scope, resolution.marker.facetKey);
      var lower;
      var upper;
      var minInput;
      var maxInput;

      if (!root) return;

      root.querySelectorAll('[data-kk-native-range-option][name]').forEach(function (option) {
        var checked = option.name === resolution.paramName &&
          resolution.fieldValues.indexOf(option.value) > -1;
        var item = option.closest && option.closest('[data-filter-item]');

        option.checked = checked;
        if (checked) option.disabled = false;
        if (item) {
          item.classList.toggle('filter-item--active', checked);
          item.classList.toggle('filter-item--inactive', !checked);
        }
      });
      kkClearNativeRangeNoMatch(root);

      lower = root.querySelector('[data-kk-range-lower]');
      upper = root.querySelector('[data-kk-range-upper]');
      minInput = root.querySelector('[data-kk-range-min-input]');
      maxInput = root.querySelector('[data-kk-range-max-input]');
      if (lower) lower.value = kkNativeRangeValue(resolution.marker.lower);
      if (upper) upper.value = kkNativeRangeValue(resolution.marker.upper);
      if (minInput) minInput.value = kkNativeRangeValue(resolution.marker.lower);
      if (maxInput) maxInput.value = kkNativeRangeValue(resolution.marker.upper);
      root.dispatchEvent(new Event('kk:sync-native-range-ui', { bubbles: true }));
    });

    return true;
  }

  function kkNativeRangeRequestUrl(query) {
    var parts = kkNativeRangeQueryParts(query);

    parts.params.delete(KK_NATIVE_RANGE_NO_MATCH_PARAM);
    return kkNativeRangeJoinQuery(parts);
  }

  function kkNoResultsText() {
    var language = String(document.documentElement.lang || '').toLowerCase();

    if (language.indexOf('fi') === 0) return 'Hakuasi vastaavia tuotteita ei löytynyt';
    if (language.indexOf('sv') === 0) return 'Det finns inga produkter som matchar din sökning';
    return 'There are no products matching your search';
  }

  function kkRemoveNativeRangeNoMatchValue(query, serialized) {
    var source = String(query || '');
    var questionMark = source.indexOf('?');
    var params;

    if (questionMark > -1) source = source.slice(questionMark + 1);
    params = new URLSearchParams(source.replace(/^\?/, '').split('#')[0]);
    var remaining = params.getAll(KK_NATIVE_RANGE_NO_MATCH_PARAM).filter(function (value) {
      var entry = kkParseNativeRangeNoMatchValue(value);
      return !entry || entry.serialized !== serialized;
    });

    params.delete(KK_NATIVE_RANGE_NO_MATCH_PARAM);
    remaining.forEach(function (value) {
      params.append(KK_NATIVE_RANGE_NO_MATCH_PARAM, value);
    });
    return params.toString();
  }

  function kkEnsureNativeRangeNoMatchChips(scope, query) {
    var markers = kkNativeRangeNoMatchEntries(query);
    var results = scope && scope.querySelector ? scope.querySelector('[data-results-container]') : null;
    var wrapper;
    var list;
    var utility;
    var trigger;
    var triggerText;
    var activeCount;
    var language;
    var triggerLabel;

    if (!results) return;

    wrapper = results.querySelector('.productgrid--filters');
    list = wrapper && wrapper.querySelector('.filter-group--grid');
    if (!markers.length && !list) return;
    if (!list) {
      wrapper = scope.ownerDocument ? scope.ownerDocument.createElement('div') : document.createElement('div');
      wrapper.className = 'productgrid--filters';
      wrapper.setAttribute('data-kk-native-range-no-match-wrapper', '');
      list = wrapper.ownerDocument.createElement('ul');
      list.className = 'filter-group--grid';
      wrapper.appendChild(list);
      utility = results.querySelector('.productgrid--utils');
      results.insertBefore(wrapper, utility || results.firstChild);
    }

    list.querySelectorAll('[data-kk-native-range-no-match-active]').forEach(function (item) {
      item.remove();
    });

    if (!markers.length) {
      if (wrapper.hasAttribute('data-kk-native-range-no-match-wrapper') && !list.children.length) {
        wrapper.remove();
      }
      return;
    }

    markers.forEach(function (marker) {
      var root = Array.prototype.find.call(scope.querySelectorAll('[data-kk-native-range]'), function (candidate) {
        return kkNativeRangeFacetKey(candidate) === marker.facetKey;
      });
      var facet = root && root.closest('[data-kk-facet]');
      var titleNode = facet && facet.querySelector('.kk-facet__title');
      var unit = root && root.getAttribute('data-kk-range-unit') || '';
      var title = titleNode ? titleNode.textContent.replace(/\s+/g, ' ').trim() : marker.facetKey;
      var item = list.ownerDocument.createElement('li');
      var link = list.ownerDocument.createElement('a');
      var text = list.ownerDocument.createElement('span');
      var icon = list.ownerDocument.createElement('span');
      var removeQuery = kkRemoveNativeRangeNoMatchValue(query, marker.serialized);

      if (unit) title = title.replace(new RegExp('\\s*\\(' + unit + '\\)\\s*$', 'i'), '');
      item.className = 'filter-item--grid';
      item.setAttribute('data-kk-native-range-no-match-active', '');
      link.href = window.location.pathname + (removeQuery ? '?' + removeQuery : '');
      link.setAttribute('data-filter-remove', '');
      link.setAttribute('data-kk-native-range-no-match-link', '');
      text.className = 'filter-text';
      text.textContent = title + ': ' + kkNativeRangeValue(marker.lower) + ' - ' +
        kkNativeRangeValue(marker.upper) + (unit ? ' ' + unit : '');
      icon.className = 'filter-icon--remove';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM3.96967 5.03033L6.93934 8L3.96967 10.9697L5.03033 12.0303L8 9.06066L10.9697 12.0303L12.0303 10.9697L9.06066 8L12.0303 5.03033L10.9697 3.96967L8 6.93934L5.03033 3.96967L3.96967 5.03033Z" /></svg>';
      link.appendChild(text);
      link.appendChild(icon);
      item.appendChild(link);
      list.insertBefore(item, list.querySelector('.filter-item--grid-simple'));
    });

    list.querySelectorAll('a[data-filter-remove]:not([data-kk-native-range-no-match-link])').forEach(function (link) {
      var href;
      var url;

      if (link.closest('.filter-item--grid-simple') || link.closest('[data-kk-native-range-no-match-active]')) return;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }
      markers.forEach(function (marker) {
        if (url.searchParams.getAll(KK_NATIVE_RANGE_NO_MATCH_PARAM).indexOf(marker.serialized) === -1) {
          url.searchParams.append(KK_NATIVE_RANGE_NO_MATCH_PARAM, marker.serialized);
        }
      });
      href = url.pathname + url.search;
      link.setAttribute('href', href);
    });

    activeCount = list.querySelectorAll('.filter-item--grid').length;
    trigger = results.querySelector('[data-productgrid-trigger-filters]');
    triggerText = trigger && trigger.querySelector('.utils-filter-text');
    if (trigger && activeCount > 0) {
      language = String(document.documentElement.lang || '').toLowerCase();
      triggerLabel = language.indexOf('fi') === 0 ? 'Suodattimet (' + activeCount + ')' :
        (language.indexOf('sv') === 0 ? 'Filter (' + activeCount + ')' : 'Filters (' + activeCount + ')');
      trigger.setAttribute('aria-label', triggerLabel);
      if (triggerText) triggerText.textContent = triggerLabel;
    }
  }

  function kkApplyNativeRangeNoMatchResponse(scope, query) {
    var results;
    var grid;
    var empty;

    if (!kkHasNativeRangeNoMatch(query) || !scope || !scope.querySelector) return false;

    kkRestoreNativeRangeNoMatches(scope, query, true);
    results = scope.querySelector('[data-results-container]');
    if (!results) return false;

    results.setAttribute('data-product-count', '0');
    grid = results.querySelector('[data-product-grid]');
    empty = results.querySelector('.productgrid--no-results');

    if (!empty) {
      empty = results.ownerDocument.createElement('div');
      empty.className = 'productgrid--no-results';
      empty.setAttribute('data-kk-native-range-no-match-empty', '');
      empty.innerHTML = '<h2 class="productgrid--no-results-title"></h2>';
      empty.querySelector('h2').textContent = kkNoResultsText();
      if (grid) {
        grid.parentNode.replaceChild(empty, grid);
      } else {
        results.appendChild(empty);
      }
    } else if (grid) {
      grid.remove();
    }

    results.querySelectorAll('[data-pagination-wrapper], [data-click-to-load], [data-infinite-scroll]').forEach(function (node) {
      node.remove();
    });
    kkEnsureNativeRangeNoMatchChips(scope, query);
    return true;
  }

(function () {
  var contextualPriceMaxCache = {};
  var contextualPriceMaxPendingRoots = {};
  var contextualPriceMaxRequests = {};
  var JUDGE_ME_PENDING_BADGE_SELECTOR = '.productgrid--item .jdgm-preview-badge:not(.jdgm--done-setup)';
  var JUDGE_ME_REFRESH_DELAY = 250;
  var JUDGE_ME_REFRESH_MAX_ATTEMPTS = 20;
  var JUDGE_ME_BASE_SCRIPT_PATH = 'widget/base.js';
  var JUDGE_ME_COMMON_SCRIPT_PATH = 'widget/common.js';
  var JUDGE_ME_BADGE_SCRIPT_PATH = 'widget/main.js';
  var JUDGE_ME_LEGACY_SCRIPT_PATH = 'shopify_v2.js';
  var judgeMeRefreshTimer = null;
  var judgeMeRefreshAttempts = 0;
  var judgeMeDoneSetupListening = false;
  var nativeNoMatchHistoryState = kkHasNativeRangeNoMatch(window.location.search);
  var nativeNoMatchCanonicalizingQuery = '';

  function hasPendingJudgeMeCollectionBadges() {
    return Boolean(document.querySelector(JUDGE_ME_PENDING_BADGE_SELECTOR));
  }

  function stopJudgeMeCollectionRefresh() {
    if (judgeMeRefreshTimer) {
      window.clearTimeout(judgeMeRefreshTimer);
      judgeMeRefreshTimer = null;
    }

    if (judgeMeDoneSetupListening) {
      document.removeEventListener('jdgm.doneSetup', handleJudgeMeCollectionDoneSetup);
      judgeMeDoneSetupListening = false;
    }

    judgeMeRefreshAttempts = 0;
  }

  function isJudgeMeScriptRequested(jdgm, path) {
    var requestedUrls = jdgm && jdgm.loadScript && jdgm.loadScript.requestedUrls;
    var normalizedPath = String(path || '').replace(/^\/+/, '');
    var flattenedPath = normalizedPath.replace(/\//g, '_');

    if (!Array.isArray(requestedUrls) || !normalizedPath) return false;

    return requestedUrls.some(function (url) {
      var cleanUrl = String(url || '').split(/[?#]/)[0];
      return cleanUrl.slice(-normalizedPath.length) === normalizedPath
        || cleanUrl.slice(-flattenedPath.length) === flattenedPath;
    });
  }

  function requestJudgeMeScript(jdgm, path, useFullCdnUrl) {
    var cdnHost;
    var source;

    if (!jdgm || typeof jdgm.loadScript !== 'function' || isJudgeMeScriptRequested(jdgm, path)) {
      return false;
    }

    cdnHost = String(jdgm.CDN_HOST || 'https://cdn.judge.me/').replace(/\/?$/, '/');
    source = useFullCdnUrl ? cdnHost + String(path || '') : path;

    try {
      jdgm.loadScript(source);
      return true;
    } catch (error) {
      return false;
    }
  }

  function ensureJudgeMeCollectionBadgeRuntime() {
    var jdgm = window.jdgm;
    var settings = window.jdgmSettings || {};

    if (!jdgm || typeof jdgm.loadScript !== 'function') return false;
    if (typeof jdgm.customizeBadges === 'function') return true;

    if (!settings.widget_load_with_code_splitting) {
      requestJudgeMeScript(jdgm, JUDGE_ME_LEGACY_SCRIPT_PATH, true);
      return true;
    }

    // Mirror Judge.me's own code-split dependency order, but only after an
    // Ajax response has actually introduced a pending collection badge.
    if (typeof jdgm.initializeWidgets === 'function') {
      requestJudgeMeScript(jdgm, JUDGE_ME_BADGE_SCRIPT_PATH, true);
      return true;
    }

    if (typeof jdgm.$ === 'function') {
      requestJudgeMeScript(jdgm, JUDGE_ME_COMMON_SCRIPT_PATH, false);
      return true;
    }

    requestJudgeMeScript(jdgm, JUDGE_ME_BASE_SCRIPT_PATH, false);
    return true;
  }

  function runJudgeMeCollectionRefresh() {
    var jdgm = window.jdgm;

    if (!hasPendingJudgeMeCollectionBadges()) {
      return true;
    }

    if (!jdgm || typeof jdgm.customizeBadges !== 'function') {
      ensureJudgeMeCollectionBadgeRuntime();
      return false;
    }

    try {
      jdgm.customizeBadges();
    } catch (error) {
      return false;
    }

    return !hasPendingJudgeMeCollectionBadges();
  }

  function scheduleJudgeMeCollectionRefresh() {
    judgeMeRefreshTimer = null;

    if (runJudgeMeCollectionRefresh()) {
      stopJudgeMeCollectionRefresh();
      return;
    }

    judgeMeRefreshAttempts += 1;
    if (judgeMeRefreshAttempts >= JUDGE_ME_REFRESH_MAX_ATTEMPTS) {
      stopJudgeMeCollectionRefresh();
      return;
    }

    judgeMeRefreshTimer = window.setTimeout(scheduleJudgeMeCollectionRefresh, JUDGE_ME_REFRESH_DELAY);
  }

  function handleJudgeMeCollectionDoneSetup() {
    if (judgeMeRefreshTimer) {
      window.clearTimeout(judgeMeRefreshTimer);
      judgeMeRefreshTimer = null;
    }
    scheduleJudgeMeCollectionRefresh();
  }

  function refreshJudgeMeCollectionBadges() {
    stopJudgeMeCollectionRefresh();

    if (!hasPendingJudgeMeCollectionBadges()) {
      return;
    }

    document.addEventListener('jdgm.doneSetup', handleJudgeMeCollectionDoneSetup);
    judgeMeDoneSetupListening = true;
    scheduleJudgeMeCollectionRefresh();
  }

  document.addEventListener('kk:collection-search-complete', refreshJudgeMeCollectionBadges);
  window.addEventListener('pagehide', stopJudgeMeCollectionRefresh);

  function toNumber(value, fallback) {
    var parsed = parseFloat(String(value).replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function setFieldValue(input, value) {
    var formatted;

    if (!input) return;
    formatted = Number.isInteger(value) ? String(value) : String(value).replace(/\.0$/, '');
    input.value = formatted;
    input.setAttribute('value', formatted);
  }

  function clearFieldValue(input) {
    if (!input) return;
    input.value = '';
    input.removeAttribute('value');
  }

  function getFormattedRangeValue(value) {
    return Number.isInteger(value) ? String(value) : String(value).replace(/\.0$/, '');
  }

  function isAtRangeStart(value, min) {
    return value <= min || Math.abs(value - min) < 0.0001;
  }

  function isAtRangeEnd(value, max) {
    return value >= max || Math.abs(value - max) < 0.0001;
  }

  function setRangeFieldValues(root, parts, lower, upper) {
    var isPriceRange = root.hasAttribute('data-kk-price-range');

    if (!isPriceRange) {
      setFieldValue(parts.minInput, lower);
      setFieldValue(parts.maxInput, upper);
      return;
    }

    if (parts.minInput) {
      if (isAtRangeStart(lower, parts.min)) {
        clearFieldValue(parts.minInput);
      } else {
        setFieldValue(parts.minInput, lower);
      }
    }

    if (parts.maxInput) {
      if (isAtRangeEnd(upper, parts.max)) {
        clearFieldValue(parts.maxInput);
      } else {
        setFieldValue(parts.maxInput, upper);
      }
    }
  }

  function getRangeParts(root) {
    return {
      min: toNumber(root.dataset.kkRangeMin, 0),
      max: toNumber(root.dataset.kkRangeMax, 0),
      lower: root.querySelector('[data-kk-range-lower]'),
      upper: root.querySelector('[data-kk-range-upper]'),
      minInput: root.querySelector('[data-kk-range-min-input]'),
      maxInput: root.querySelector('[data-kk-range-max-input]')
    };
  }

  function getPriceParamNames(root) {
    var parts = getRangeParts(root);

    return {
      min: parts.minInput && parts.minInput.name ? parts.minInput.name : 'filter.v.price.gte',
      max: parts.maxInput && parts.maxInput.name ? parts.maxInput.name : 'filter.v.price.lte'
    };
  }

  function buildContextualPriceMaxUrl(root) {
    var form = root.closest('[data-filter-form]');
    var paramsToRefresh = {};
    var priceParams = getPriceParamNames(root);
    var url;

    try {
      url = new URL(window.location.href);
    } catch (error) {
      return '';
    }

    url.searchParams.delete('page');
    url.searchParams.delete('view');
    url.searchParams.delete(KK_NATIVE_RANGE_NO_MATCH_PARAM);
    url.searchParams.delete(priceParams.min);
    url.searchParams.delete(priceParams.max);

    if (form) {
      Array.prototype.forEach.call(form.elements, function (field) {
        if (field && field.name) {
          paramsToRefresh[field.name] = true;
        }
      });

      Object.keys(paramsToRefresh).forEach(function (name) {
        url.searchParams.delete(name);
      });

      new URLSearchParams(new FormData(form)).forEach(function (value, name) {
        if (
          name === priceParams.min ||
          name === priceParams.max ||
          name === KK_NATIVE_RANGE_NO_MATCH_PARAM ||
          String(value || '') === ''
        ) {
          return;
        }

        url.searchParams.append(name, value);
      });
    }

    url.searchParams.set('sort_by', 'price-descending');

    return url.pathname + url.search;
  }

  function buildContextualPriceMaxUrlFromUrl(sourceUrl) {
    var url;

    try {
      url = new URL(sourceUrl || window.location.href, window.location.origin);
    } catch (error) {
      return '';
    }

    url.searchParams.delete('page');
    url.searchParams.delete('view');
    url.searchParams.delete(KK_NATIVE_RANGE_NO_MATCH_PARAM);
    url.searchParams.delete('filter.v.price.gte');
    url.searchParams.delete('filter.v.price.lte');
    url.searchParams.set('sort_by', 'price-descending');

    return url.pathname + url.search;
  }

  function getExplicitPriceSelection(root, sourceUrl) {
    var priceParams = getPriceParamNames(root);
    var url;

    try {
      url = new URL(window.location.href, window.location.origin);
    } catch (error) {
      url = null;
    }

    if (!url) {
      return {
        min: false,
        max: false
      };
    }

    return {
      min: String(url.searchParams.get(priceParams.min) || '') !== '',
      max: String(url.searchParams.get(priceParams.max) || '') !== ''
    };
  }

  function forEachProductPriceInScope(scope, callback) {
    var cards;

    if (!scope || !scope.querySelectorAll || typeof callback !== 'function') {
      return;
    }

    cards = scope.querySelectorAll('[data-product-item][data-product-price]');

    if (cards.length) {
      cards.forEach(function (card) {
        var price = toNumber(card.getAttribute('data-product-price'), 0);
        var priceMax = toNumber(card.getAttribute('data-product-price-max'), price);

        callback(price, priceMax);
      });
      return;
    }

    // Backwards-compatible fallback for cached or app-provided card markup.
    scope.querySelectorAll('script[data-product-data]').forEach(function (script) {
      var product;
      var price;
      var priceMax;

      try {
        product = JSON.parse(script.textContent || '{}');
      } catch (error) {
        product = {};
      }

      price = toNumber(product.price || 0, 0);
      priceMax = toNumber(product.price_max || product.price || 0, price);
      callback(price, priceMax);
    });
  }

  function readMaxProductPriceFromScope(scope) {
    var maxPrice = 0;

    forEachProductPriceInScope(scope, function (price, priceMax) {
      if (priceMax > maxPrice) {
        maxPrice = priceMax;
      }
    });

    return maxPrice;
  }

  function readMinProductPriceFromScope(scope) {
    var minPrice = null;

    forEachProductPriceInScope(scope, function (price) {
      if (price <= 0) return;
      if (minPrice === null || price < minPrice) {
        minPrice = price;
      }
    });

    return minPrice === null ? 0 : minPrice;
  }

  function readMaxProductPriceFromHtml(markup) {
    var doc = parseCollectionResponseHtml(markup);

    return readMaxProductPriceFromScope(doc);
  }

  function setMaxAttribute(input, value) {
    if (input) {
      input.setAttribute('max', getFormattedRangeValue(value));
    }
  }

  function formatNumberForPriceTag(value, sample) {
    var numericValue = Math.round(toNumber(value, 0) * 100) / 100;
    var sampleText = String(sample || '');
    var firstDigit = sampleText.search(/\d/);
    var lastDigit = Math.max(
      sampleText.lastIndexOf('0'),
      sampleText.lastIndexOf('1'),
      sampleText.lastIndexOf('2'),
      sampleText.lastIndexOf('3'),
      sampleText.lastIndexOf('4'),
      sampleText.lastIndexOf('5'),
      sampleText.lastIndexOf('6'),
      sampleText.lastIndexOf('7'),
      sampleText.lastIndexOf('8'),
      sampleText.lastIndexOf('9')
    );
    var prefix = firstDigit > -1 ? sampleText.slice(0, firstDigit) : '';
    var suffix = lastDigit > -1 ? sampleText.slice(lastDigit + 1) : '';
    var decimalSeparator = sampleText.lastIndexOf(',') > sampleText.lastIndexOf('.') ? ',' : '.';
    var thousandsSeparator = decimalSeparator === ',' ? '.' : ',';
    var fixed = numericValue.toFixed(2).split('.');
    var integerPart = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);

    return prefix + integerPart + decimalSeparator + fixed[1] + suffix;
  }

  function updateActivePriceFilterTags(root, contextualMax, sourceUrl) {
    var explicitPriceSelection = getExplicitPriceSelection(root, sourceUrl);
    var doc = root && root.ownerDocument ? root.ownerDocument : document;

    if (explicitPriceSelection.max) {
      return;
    }

    doc.querySelectorAll('[data-kk-active-price-filter]').forEach(function (link) {
      var text = link.querySelector('.filter-text');
      var parts;
      var maxText;

      if (!text || link.getAttribute('data-kk-active-price-has-max') === 'true') {
        return;
      }

      parts = text.textContent.split(/\s+-\s+/);

      if (parts.length < 2) {
        return;
      }

      maxText = formatNumberForPriceTag(contextualMax, parts[1]);
      text.textContent = parts[0] + ' - ' + maxText;
    });
  }

  function applyContextualPriceMax(root, maxPriceCents, sourceUrl) {
    var contextualMax = Math.ceil(toNumber(maxPriceCents, 0) / 100);
    var parts;
    var oldMax;
    var currentLower;
    var currentUpper;
    var currentMaxInput;
    var explicitPriceSelection;
    var wasAtOldMax;
    var bounds;

    if (!root || !root.hasAttribute('data-kk-price-range') || contextualMax <= 0) {
      return;
    }

    parts = getRangeParts(root);
    oldMax = parts.max;
    contextualMax = Math.max(contextualMax, parts.min);

    currentLower = toNumber(parts.lower && parts.lower.value, parts.min);
    currentUpper = toNumber(parts.upper && parts.upper.value, oldMax);
    currentMaxInput = parts.maxInput && parts.maxInput.value !== '' ?
      toNumber(parts.maxInput.value, null) :
      null;
    explicitPriceSelection = getExplicitPriceSelection(root, sourceUrl);
    wasAtOldMax = !explicitPriceSelection.max ||
      currentMaxInput === null ||
      isAtRangeEnd(currentUpper, oldMax) ||
      isAtRangeEnd(currentMaxInput, oldMax);

    root.dataset.kkRangeMax = getFormattedRangeValue(contextualMax);

    setMaxAttribute(parts.minInput, contextualMax);
    setMaxAttribute(parts.maxInput, contextualMax);
    setMaxAttribute(parts.lower, contextualMax);
    setMaxAttribute(parts.upper, contextualMax);

    if (parts.maxInput) {
      parts.maxInput.placeholder = getFormattedRangeValue(contextualMax);
      parts.maxInput.setAttribute('placeholder', getFormattedRangeValue(contextualMax));
      if (wasAtOldMax) {
        clearFieldValue(parts.maxInput);
      } else if (currentMaxInput !== null && currentMaxInput > contextualMax) {
        setFieldValue(parts.maxInput, contextualMax);
      }
    }

    if (!explicitPriceSelection.min) {
      clearFieldValue(parts.minInput);
      if (parts.lower) {
        setFieldValue(parts.lower, parts.min);
      }
    } else if (parts.minInput && toNumber(parts.minInput.value, parts.min) > contextualMax) {
      setFieldValue(parts.minInput, contextualMax);
    }

    if (parts.lower && currentLower > contextualMax) {
      setFieldValue(parts.lower, contextualMax);
    }

    if (parts.upper && (wasAtOldMax || currentUpper > contextualMax)) {
      setFieldValue(parts.upper, contextualMax);
    }

    bounds = root.querySelector('.kk-range-filter__bounds span:last-child');
    if (bounds) {
      bounds.textContent = getFormattedRangeValue(contextualMax);
    }

    updateActivePriceFilterTags(root, contextualMax, sourceUrl);
    paintRange(root);
  }

  function flushContextualPriceMax(url, maxPriceCents) {
    var roots = contextualPriceMaxPendingRoots[url] || [];

    roots.forEach(function (root) {
      if (document.documentElement.contains(root)) {
        applyContextualPriceMax(root, maxPriceCents, url);
      }
    });

    contextualPriceMaxPendingRoots[url] = [];
  }

  function clearContextualPriceMaxPending(url) {
    contextualPriceMaxPendingRoots[url] = [];
  }

  function requestContextualPriceMax(url) {
    if (!url) {
      return Promise.resolve(0);
    }

    // This marker is a browser-only zero-result state. Normalize before the
    // cache lookup as well as fetch so it can never reach Shopify and cannot
    // split the contextual-price cache into marked and unmarked variants.
    url = kkNativeRangeRequestUrl(url);

    if (contextualPriceMaxCache[url]) {
      return Promise.resolve(contextualPriceMaxCache[url]);
    }

    if (contextualPriceMaxRequests[url]) {
      return contextualPriceMaxRequests[url];
    }

    contextualPriceMaxRequests[url] = fetch(url, {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Contextual price max request failed');
      }

      return response.text();
    }).then(function (markup) {
      var maxPriceCents = readMaxProductPriceFromHtml(markup);

      if (maxPriceCents > 0) {
        contextualPriceMaxCache[url] = maxPriceCents;
      }

      return maxPriceCents;
    }).catch(function () {
      return 0;
    }).then(function (maxPriceCents) {
      delete contextualPriceMaxRequests[url];
      return maxPriceCents;
    });

    return contextualPriceMaxRequests[url];
  }

  function primeContextualPriceMaxForUrl(sourceUrl) {
    return requestContextualPriceMax(buildContextualPriceMaxUrlFromUrl(sourceUrl));
  }

  function applyContextualPriceMaxToScope(scope, maxPriceCents, sourceUrl) {
    if (!scope || !scope.querySelectorAll || !maxPriceCents) {
      return;
    }

    scope.querySelectorAll('[data-kk-price-range]').forEach(function (root) {
      applyContextualPriceMax(root, maxPriceCents, sourceUrl);
    });
  }

  function updateContextualPriceMax(root) {
    var url;
    var visibleMaxPriceCents;

    if (!root || !root.hasAttribute('data-kk-price-range')) {
      return;
    }

    url = buildContextualPriceMaxUrl(root);

    if (!url) {
      return;
    }

    visibleMaxPriceCents = readMaxProductPriceFromScope(document);
    if (visibleMaxPriceCents > getRangeParts(root).max * 100) {
      applyContextualPriceMax(root, visibleMaxPriceCents, url);
    }

    if (contextualPriceMaxCache[url]) {
      applyContextualPriceMax(root, contextualPriceMaxCache[url], url);
      return;
    }

    if (!contextualPriceMaxPendingRoots[url]) {
      contextualPriceMaxPendingRoots[url] = [];
    }

    contextualPriceMaxPendingRoots[url].push(root);

    requestContextualPriceMax(url).then(function (maxPriceCents) {
      if (maxPriceCents > 0) {
        flushContextualPriceMax(url, maxPriceCents);
      } else {
        clearContextualPriceMaxPending(url);
      }
    });
  }

  function readRange(root) {
    var parts = getRangeParts(root);
    var lower = toNumber(parts.lower && parts.lower.value, parts.min);
    var upper = toNumber(parts.upper && parts.upper.value, parts.max);

    lower = clamp(lower, parts.min, parts.max);
    upper = clamp(upper, parts.min, parts.max);

    if (lower > upper) {
      if (document.activeElement === parts.lower || document.activeElement === parts.minInput) {
        upper = lower;
      } else {
        lower = upper;
      }
    }

    return {
      parts: parts,
      lower: lower,
      upper: upper
    };
  }

  function paintRange(root) {
    var range = readRange(root);
    var parts = range.parts;

    if (parts.lower) setFieldValue(parts.lower, range.lower);
    if (parts.upper) setFieldValue(parts.upper, range.upper);
    setRangeFieldValues(root, parts, range.lower, range.upper);
    updateRangeTooltips(root);
  }

  function updateRangeTooltips(root) {
    if (!root) return;
    var slider = root.querySelector('[data-kk-range-track]') || root.querySelector('.kk-range-filter__slider');
    if (!slider) return;

    var prefix = slider.getAttribute('data-kk-tooltip-prefix') || '';
    var suffix = slider.getAttribute('data-kk-tooltip-suffix') || '';
    var lower = slider.querySelector('[data-kk-range-lower]');
    var upper = slider.querySelector('[data-kk-range-upper]');
    var tooltipLower = slider.querySelector('[data-kk-range-tooltip="lower"]');
    var tooltipUpper = slider.querySelector('[data-kk-range-tooltip="upper"]');

    function update(input, tooltip) {
      if (!input || !tooltip) return;
      var inputMin = toNumber(input.min, 0);
      var inputMax = toNumber(input.max, 100);
      var value = toNumber(input.value, inputMin);
      var span = inputMax - inputMin;
      var percent = span > 0 ? ((value - inputMin) / span * 100) : 0;
      var thumbHalf = 13;
      var offset = thumbHalf * (1 - percent / 50);
      tooltip.style.left = 'calc(' + percent + '% + ' + offset.toFixed(2) + 'px)';
      tooltip.textContent = prefix + value + suffix;
    }

    update(lower, tooltipLower);
    update(upper, tooltipUpper);
  }

  function syncSliderFromFields(root) {
    var parts = getRangeParts(root);
    var lower = toNumber(parts.minInput && parts.minInput.value, parts.min);
    var upper = toNumber(parts.maxInput && parts.maxInput.value, parts.max);

    lower = clamp(lower, parts.min, parts.max);
    upper = clamp(upper, parts.min, parts.max);

    if (lower > upper) {
      if (document.activeElement === parts.minInput) {
        upper = lower;
      } else {
        lower = upper;
      }
    }

    if (parts.lower) setFieldValue(parts.lower, lower);
    if (parts.upper) setFieldValue(parts.upper, upper);
    paintRange(root);
  }

  function dispatchNativeChange(input) {
    if (!input) return;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function commitNativeRange(root) {
    var range = readRange(root);
    var options = root.querySelectorAll('[data-kk-native-range-option]');
    var fullRange = range.lower <= range.parts.min && range.upper >= range.parts.max;
    var changed = false;
    var matchingOptions = 0;
    var markerChanged;
    var eventTarget = null;

    options.forEach(function (option) {
      var value = toNumber(option.dataset.kkRangeValue, range.parts.min);
      var shouldCheck = !fullRange && value >= range.lower && value <= range.upper && !option.disabled;

      if (shouldCheck) matchingOptions += 1;

      if (option.checked !== shouldCheck) {
        option.checked = shouldCheck;
        changed = true;
        if (!eventTarget) eventTarget = option;
      }
    });

    markerChanged = !fullRange && matchingOptions === 0 ?
      kkSetNativeRangeNoMatch(root, range.lower, range.upper) :
      kkClearNativeRangeNoMatch(root);

    paintRange(root);

    if (changed || markerChanged) {
      dispatchNativeChange(eventTarget || options[0]);
    }
  }

  function commitPriceRange(root) {
    var range = readRange(root);
    var minInput = range.parts.minInput;
    var maxInput = range.parts.maxInput;
    var changeTarget;

    setRangeFieldValues(root, range.parts, range.lower, range.upper);
    changeTarget = minInput && minInput.value !== '' ? minInput : maxInput || minInput;
    dispatchNativeChange(changeTarget);
  }

  function handleRangeInput(event) {
    var target = event.target;
    var root = target.closest('[data-kk-native-range], [data-kk-price-range]');

    if (!root) return;

    if (target.matches('[data-kk-range-min-input], [data-kk-range-max-input]')) {
      syncSliderFromFields(root);
    } else {
      paintRange(root);
    }
  }

  function handleRangeChange(event) {
    var target = event.target;
    var root = target.closest('[data-kk-native-range], [data-kk-price-range]');

    if (!root) return;

    if (target.matches('[data-kk-range-min-input], [data-kk-range-max-input]')) {
      syncSliderFromFields(root);
    } else {
      paintRange(root);
    }

    if (root.hasAttribute('data-kk-native-range')) {
      commitNativeRange(root);
    } else if (target.matches('[data-kk-range-lower], [data-kk-range-upper]')) {
      commitPriceRange(root);
    }
  }

  function handleFacetSearch(event) {
    var input = event.target.closest('[data-kk-filter-search]');
    if (!input) return;

    var facet = input.closest('[data-kk-facet]');
    var term = input.value.trim().toLowerCase();
    var options = facet ? facet.querySelectorAll('[data-kk-filter-option]') : [];
    var toggle = facet ? facet.querySelector('[data-filter-toggle]') : null;
    var filterGroup = facet ? facet.querySelector('[data-kk-filter-list]') : null;
    var expanded = toggle && toggle.getAttribute('data-filter-toggle') === 'true';

    options.forEach(function (option) {
      var text = (option.getAttribute('data-kk-filter-search-text') || option.textContent || '').trim().toLowerCase();
      var unavailable = option.hasAttribute('data-kk-scoped-zero-option');
      var matches = !unavailable && (!term || text.indexOf(term) !== -1);

      option.hidden = !matches;
      option.classList.toggle('kk-filter-option--search-hidden', !matches);

      if (term) {
        option.classList.remove('filter-item--hidden');
      } else if (option.hasAttribute('data-hidden-default')) {
        option.classList.toggle('filter-item--hidden', !expanded);
      } else {
        option.classList.remove('filter-item--hidden');
      }
    });

    if (toggle) {
      var toggleItem = toggle.closest('.filter-item');

      if (toggleItem) {
        toggleItem.hidden = Boolean(term) || toggleItem.hasAttribute('data-kk-no-eligible-overflow');
        toggleItem.classList.toggle('kk-filter-option--search-hidden', Boolean(term));
      }
    }

    if (filterGroup) {
      filterGroup.classList.toggle('kk-facet__list--expanded', Boolean(term) || Boolean(expanded));
    }
  }

  function shouldPrimeContextualPriceMax(target) {
    return Boolean(
      target &&
      !target.closest('[data-kk-price-range]') &&
      target.closest('[data-filter-form]') &&
      target.closest(
        '[data-filter-checkbox], [data-filter-range], [data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]'
      )
    );
  }

  function primeContextualPriceMax(target) {
    var form = target && target.closest('[data-filter-form]');
    var priceRange = form && form.querySelector('[data-kk-price-range]');

    if (!shouldPrimeContextualPriceMax(target) || !priceRange) {
      return;
    }

    updateContextualPriceMax(priceRange);
  }

  function initializeRanges(root) {
    root.querySelectorAll('[data-kk-native-range], [data-kk-price-range]').forEach(function (range) {
      if (range.hasAttribute('data-kk-price-range')) {
        updateContextualPriceMax(range);
      }

      paintRange(range);
    });
    syncStaticSearchRangeFacets(root);
  }

  function syncStaticSearchRangeFacets(root) {
    var ranges = [];

    if (root.matches && root.matches('[data-kk-search-sidebar-filters] [data-kk-native-range]')) {
      ranges.push(root);
    }

    root.querySelectorAll('[data-kk-search-sidebar-filters] [data-kk-native-range]').forEach(function (range) {
      ranges.push(range);
    });

    ranges.forEach(function (range) {
      var min = toNumber(range.dataset.kkRangeMin, null);
      var max = toNumber(range.dataset.kkRangeMax, null);
      var facet = range.closest('[data-kk-facet]');

      if (!facet || min === null || max === null) return;

      facet.hidden = min === max;
    });
  }

  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]')) {
      handleRangeInput(event);
    }

    handleFacetSearch(event);
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]')) {
      handleRangeChange(event);
    }

    primeContextualPriceMax(event.target);
  });

  document.addEventListener('kk:sync-native-range-ui', function (event) {
    var target = event.target;
    var root = target && target.closest ?
      target.closest('[data-kk-native-range], [data-kk-price-range]') :
      null;

    if (root) {
      paintRange(root);
    }
  });

  function handleFilterToggleClick(event) {
    var toggle = event.target.closest && event.target.closest('[data-filter-toggle]');
    if (!toggle) return;

    event.preventDefault();
    event.stopPropagation();

    var siblingsVisible = toggle.getAttribute('data-filter-toggle') === 'true';
    var filterGroup = toggle.closest('.filter-group, [data-filter-group], ul');
    var hiddenFilters = filterGroup ? filterGroup.querySelectorAll('[data-hidden-default]') : [];
    var seeMoreText =
      toggle.getAttribute('data-kk-see-more-text') ||
      (window.Theme && window.Theme.language && window.Theme.language.see_more) ||
      'See more';
    var seeLessText =
      toggle.getAttribute('data-kk-see-less-text') ||
      (window.Theme && window.Theme.language && window.Theme.language.see_less) ||
      'See less';

    hiddenFilters.forEach(function (filter) {
      if (siblingsVisible) {
        filter.classList.add('filter-item--hidden');
      } else {
        filter.classList.remove('filter-item--hidden');
      }
    });

    if (filterGroup) {
      filterGroup.classList.toggle('kk-facet__list--expanded', !siblingsVisible);
    }

    toggle.textContent = siblingsVisible ? seeMoreText : seeLessText;
    toggle.setAttribute('data-filter-toggle', siblingsVisible ? 'false' : 'true');
    toggle.setAttribute('aria-expanded', siblingsVisible ? 'false' : 'true');
  }

  document.addEventListener('click', handleFilterToggleClick, true);

  window.kkContextualPriceMax = {
    applyToScope: applyContextualPriceMaxToScope,
    primeForUrl: primeContextualPriceMaxForUrl
  };

  function syncPriceSliderFromUrl(root) {
    if (!root || !root.hasAttribute || !root.hasAttribute('data-kk-price-range')) return;

    var parts = getRangeParts(root);
    var params = new URLSearchParams(window.location.search);
    var gteName = (parts.minInput && parts.minInput.name) || 'filter.v.price.gte';
    var lteName = (parts.maxInput && parts.maxInput.name) || 'filter.v.price.lte';
    var gte = params.get(gteName);
    var lte = params.get(lteName);
    var lowerVal = (gte !== null && gte !== '') ? clamp(toNumber(gte, parts.min), parts.min, parts.max) : parts.min;
    var upperVal = (lte !== null && lte !== '') ? clamp(toNumber(lte, parts.max), parts.min, parts.max) : parts.max;

    if (parts.lower) setFieldValue(parts.lower, lowerVal);
    if (parts.upper) setFieldValue(parts.upper, upperVal);

    if (parts.minInput) {
      if (gte === null || gte === '') {
        clearFieldValue(parts.minInput);
      } else {
        setFieldValue(parts.minInput, lowerVal);
      }
    }

    if (parts.maxInput) {
      if (lte === null || lte === '') {
        clearFieldValue(parts.maxInput);
      } else {
        setFieldValue(parts.maxInput, upperVal);
      }
    }

    paintRange(root);
  }

  function syncAllPriceSlidersFromUrl() {
    document.querySelectorAll('[data-kk-price-range]').forEach(syncPriceSliderFromUrl);
  }

  function syncPriceRangeMinFromVisibleProducts() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('filter.v.price.gte') || params.get('filter.v.price.lte')) {
      return;
    }

    var minCents = readMinProductPriceFromScope(document);
    var minEuros = Math.floor(toNumber(minCents, 0) / 100);

    if (minEuros <= 0) return;

    document.querySelectorAll('[data-kk-price-range]').forEach(function (root) {
      var parts = getRangeParts(root);
      var maxValue = parts.max;
      var clampedMin = Math.max(0, Math.min(minEuros, maxValue));
      var formatted = getFormattedRangeValue(clampedMin);

      root.dataset.kkRangeMin = formatted;

      if (parts.minInput) {
        parts.minInput.setAttribute('min', formatted);
        parts.minInput.placeholder = formatted;
        parts.minInput.setAttribute('placeholder', formatted);
      }
      if (parts.maxInput) parts.maxInput.setAttribute('min', formatted);
      if (parts.lower) parts.lower.setAttribute('min', formatted);
      if (parts.upper) parts.upper.setAttribute('min', formatted);

      var boundsFirst = root.querySelector('.kk-range-filter__bounds span:first-child');
      if (boundsFirst) {
        boundsFirst.textContent = formatted;
      }

      var params = new URLSearchParams(window.location.search);
      var gteName = (parts.minInput && parts.minInput.name) || 'filter.v.price.gte';
      var gte = params.get(gteName);
      if ((gte === null || gte === '') && parts.lower) {
        setFieldValue(parts.lower, clampedMin);
      }

      paintRange(root);
    });
  }

  function syncAfterUrlOrDomChange() {
    var currentQuery = window.location.search;
    var resolution;
    var changeTarget;

    if (!kkHasNativeRangeNoMatch(currentQuery)) {
      nativeNoMatchCanonicalizingQuery = '';
    }

    kkRestoreNativeRangeNoMatches(document, window.location.search, true);
    syncAllPriceSlidersFromUrl();
    syncPriceRangeMinFromVisibleProducts();

    resolution = kkResolveNativeRangeNoMatches(document, currentQuery);
    if (resolution.changed) {
      kkApplyNativeRangeResolutions(document, resolution.resolved);
      if (nativeNoMatchCanonicalizingQuery === currentQuery) return;

      changeTarget = document.querySelector(
        '[data-kk-native-range] [data-kk-native-range-option]:checked'
      );
      if (changeTarget) {
        nativeNoMatchCanonicalizingQuery = currentQuery;
        window.setTimeout(function () {
          var currentTarget;

          if (window.location.search !== currentQuery) return;
          currentTarget = changeTarget.isConnected === false ?
            document.querySelector('[data-kk-native-range] [data-kk-native-range-option]:checked') :
            changeTarget;
          if (currentTarget) {
            dispatchNativeChange(currentTarget);
          } else {
            nativeNoMatchCanonicalizingQuery = '';
            kkApplyNativeRangeNoMatchResponse(document, currentQuery);
          }
        }, 0);
        return;
      }
    }

    kkApplyNativeRangeNoMatchResponse(document, currentQuery);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initializeRanges(document);
    syncAfterUrlOrDomChange();

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            initializeRanges(node);
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.querySelectorAll('[data-results-container]').forEach(function (container) {
      var debounceTimer = null;
      new MutationObserver(function () {
        window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(syncAfterUrlOrDomChange, 50);
      }).observe(container, { childList: true });
    });

    document.querySelectorAll('[data-modal-container]').forEach(function (modalContainer) {
      var wasOpenForFilters = modalContainer.classList.contains('modal--productgrid-filters');
      new MutationObserver(function () {
        var isOpenForFilters = modalContainer.classList.contains('modal--productgrid-filters');
        if (isOpenForFilters && !wasOpenForFilters) {
          window.setTimeout(syncAfterUrlOrDomChange, 50);
        }
        wasOpenForFilters = isOpenForFilters;
      }).observe(modalContainer, { attributes: true, attributeFilter: ['class'] });
    });

    var originalPushState = window.history.pushState;
    var pushStateTimer = null;
    window.history.pushState = function () {
      var result = originalPushState.apply(this, arguments);
      nativeNoMatchHistoryState = kkHasNativeRangeNoMatch(window.location.search);
      window.clearTimeout(pushStateTimer);
      pushStateTimer = window.setTimeout(syncAfterUrlOrDomChange, 80);
      return result;
    };

    window.addEventListener('popstate', function () {
      var previousNoMatchState = nativeNoMatchHistoryState;

      nativeNoMatchHistoryState = kkHasNativeRangeNoMatch(window.location.search);
      if (previousNoMatchState || nativeNoMatchHistoryState) {
        window.location.reload();
        return;
      }
      window.setTimeout(syncAfterUrlOrDomChange, 80);
    });
  });
}());

(function () {
  var VENDOR_LOGO_VIEW = 'kk-vendor-logos';
  var vendorLogoPromise = null;
  var vendorLogos = new Map();
  var hydrationTimer = null;

  function normalizeVendorLogoKey(value) {
    var normalized = String(value || '').trim().toLowerCase();

    if (typeof normalized.normalize === 'function') {
      normalized = normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return normalized.replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '');
  }

  function normalizeVendorLogoUrl(value) {
    var url = String(value || '').trim();

    if (!url || (!/^(?:https?:)?\/\//i.test(url) && url.charAt(0) !== '/')) {
      return '';
    }

    return url;
  }

  function buildVendorLogoUrl() {
    var url;

    try {
      url = new URL(window.location.href);
      url.search = '';
      url.searchParams.set('view', VENDOR_LOGO_VIEW);
      return url.pathname + url.search;
    } catch (error) {
      return window.location.pathname + '?view=' + encodeURIComponent(VENDOR_LOGO_VIEW);
    }
  }

  function buildVendorLogoMap(payload) {
    var map = new Map();
    var vendors = payload && Array.isArray(payload.vendors) ? payload.vendors : [];

    vendors.forEach(function (vendor) {
      var logoUrl = normalizeVendorLogoUrl(vendor && vendor.logo);

      if (!logoUrl) {
        return;
      }

      [vendor.name, vendor.handle].forEach(function (value) {
        var key = normalizeVendorLogoKey(value);

        if (key && !map.has(key)) {
          map.set(key, { url: logoUrl });
        }
      });
    });

    return map;
  }

  function fetchVendorLogos() {
    if (vendorLogoPromise) {
      return vendorLogoPromise;
    }

    vendorLogoPromise = fetch(buildVendorLogoUrl(), {
      credentials: 'same-origin',
      priority: 'low'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Collection vendor logo view failed: ' + response.status);
      }

      return response.json();
    }).then(function (payload) {
      vendorLogos = buildVendorLogoMap(payload);
      return vendorLogos;
    }).catch(function () {
      // Logos are decorative. Missing metaobject data must not block filters.
      return vendorLogos;
    });

    return vendorLogoPromise;
  }

  function hydrateVendorLogoSlot(slot) {
    var key;
    var logo;
    var image;

    if (!slot || slot.querySelector('.kk-facet__vendor-logo')) {
      return;
    }

    key = normalizeVendorLogoKey(slot.getAttribute('data-kk-vendor-name'));
    logo = key ? vendorLogos.get(key) : null;

    if (!logo || !logo.url) {
      return;
    }

    image = document.createElement('img');
    image.className = 'kk-facet__vendor-logo';
    image.src = logo.url;
    image.alt = '';
    image.setAttribute('aria-hidden', 'true');
    image.width = 36;
    image.height = 24;
    image.loading = 'lazy';
    image.decoding = 'async';
    slot.appendChild(image);
  }

  function hydrateVendorLogoSlots(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var slots = [];

    if (scope.matches && scope.matches('[data-kk-vendor-logo-slot]')) {
      slots.push(scope);
    }

    scope.querySelectorAll('[data-kk-vendor-logo-slot]').forEach(function (slot) {
      slots.push(slot);
    });

    if (!slots.length) {
      return;
    }

    fetchVendorLogos().then(function () {
      slots.forEach(hydrateVendorLogoSlot);
    });
  }

  function queueVendorLogoHydration(root) {
    window.clearTimeout(hydrationTimer);
    hydrationTimer = window.setTimeout(function () {
      hydrationTimer = null;
      hydrateVendorLogoSlots(root || document);
    }, 0);
  }

  function initVendorLogos() {
    hydrateVendorLogoSlots(document);

    if (!window.MutationObserver) {
      return;
    }

    new MutationObserver(function (mutations) {
      var shouldHydrate = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 && (
            (node.matches && node.matches('[data-kk-vendor-logo-slot]')) ||
            (node.querySelector && node.querySelector('[data-kk-vendor-logo-slot]'))
          );
        });
      });

      if (shouldHydrate) {
        queueVendorLogoHydration(document);
      }
    }).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVendorLogos);
  } else {
    initVendorLogos();
  }
}());

(function () {
  var suppressThemeScrollUntil = 0;

  function isHtmlBodyCollection(collection) {
    var matches = false;

    collection.each(function () {
      var tagName = this.tagName ? this.tagName.toLowerCase() : '';

      if (tagName === 'html' || tagName === 'body') {
        matches = true;
      }
    });

    return matches;
  }

  function patchJQueryAnimate(jQueryInstance) {
    if (!jQueryInstance || !jQueryInstance.fn || jQueryInstance.fn.kkFilterScrollPatched) {
      return;
    }

    var originalAnimate = jQueryInstance.fn.animate;

    jQueryInstance.fn.animate = function (properties) {
      var isThemeScrollToTop = properties &&
        Object.prototype.hasOwnProperty.call(properties, 'scrollTop') &&
        isHtmlBodyCollection(this);

      if (isThemeScrollToTop && Date.now() < suppressThemeScrollUntil) {
        return this;
      }

      return originalAnimate.apply(this, arguments);
    };

    jQueryInstance.fn.kkFilterScrollPatched = true;
  }

  function patchAvailableJQuery() {
    patchJQueryAnimate(window.jQuery);
    patchJQueryAnimate(window.$);
  }

  function suppressThemeScrollToTop() {
    suppressThemeScrollUntil = Date.now() + 4000;
    patchAvailableJQuery();
  }

  function isFilterChangeTarget(target) {
    return Boolean(target.closest(
      '[data-filter-checkbox], [data-filter-range], [data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]'
    ));
  }

  document.addEventListener('change', function (event) {
    if (isFilterChangeTarget(event.target)) {
      suppressThemeScrollToTop();
    }
  }, true);

  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Tab' && event.target.closest('[data-filter-range]')) {
      suppressThemeScrollToTop();
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-filter-remove]')) {
      suppressThemeScrollToTop();
    }
  }, true);

  document.addEventListener('DOMContentLoaded', patchAvailableJQuery);
}());

(function () {
  var pendingSnapshot = null;
  var replayingPendingSnapshot = false;
  var pendingFlushTimer = null;

  function toNumber(value, fallback) {
    var parsed = parseFloat(String(value).replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function getFilterForm() {
    var modal = document.querySelector('[data-modal-container]');
    var modalForm = modal && modal.querySelector('[data-filter-form]');

    if (modalForm && document.body.classList.contains('modal-visible')) {
      return modalForm;
    }

    return document.querySelector('[data-filter-form]');
  }

  function getResultsContainer() {
    return document.querySelector('[data-results-container]');
  }

  function getSidebarContainer() {
    return document.querySelector('[data-product-grid-sidebar]');
  }

  function isFilterProcessing() {
    var results = getResultsContainer();
    var sidebar = getSidebarContainer();

    return Boolean(
      results && results.classList.contains('processing--filter') ||
      sidebar && sidebar.classList.contains('processing--filter')
    );
  }

  function setFilterProcessing(isProcessing) {
    var sidebar = getSidebarContainer();

    if (sidebar) {
      sidebar.classList.toggle('processing--filter', isProcessing);
    }

    syncFilterLoadingIcons();
  }

  function isMobileFilterSpinnerUi() {
    return window.matchMedia ?
      window.matchMedia('(max-width: 859px)').matches :
      window.innerWidth < 860;
  }

  function clearFilterLoadingIconPosition(icon) {
    if (!icon) {
      return;
    }

    icon.style.removeProperty('position');
    icon.style.removeProperty('left');
    icon.style.removeProperty('top');
    icon.style.removeProperty('right');
    icon.style.removeProperty('bottom');
    icon.style.removeProperty('margin-left');
  }

  function getPrimaryFilterLoadingIcon(container) {
    var children;
    var index;

    if (!container || !container.children) {
      return null;
    }

    children = container.children;

    for (index = 0; index < children.length; index += 1) {
      if (
        children[index].classList &&
        children[index].classList.contains('kk-primary-grid-loader')
      ) {
        return children[index];
      }
    }

    return null;
  }

  function positionFilterLoadingIcon(container) {
    var icon = getPrimaryFilterLoadingIcon(container);
    var viewport = window.visualViewport;
    var centerLeft;
    var centerTop;
    var width;
    var height;

    if (!icon) {
      return;
    }

    if (!isMobileFilterSpinnerUi()) {
      clearFilterLoadingIconPosition(icon);
      return;
    }

    centerLeft = viewport ? viewport.offsetLeft + viewport.width / 2 : window.innerWidth / 2;
    centerTop = viewport ? viewport.offsetTop + viewport.height / 2 : window.innerHeight / 2;
    width = icon.getBoundingClientRect().width || icon.offsetWidth || 64;
    height = icon.getBoundingClientRect().height || icon.offsetHeight || 64;

    icon.style.setProperty('position', 'fixed', 'important');
    icon.style.setProperty('left', centerLeft - width / 2 + 'px', 'important');
    icon.style.setProperty('top', centerTop - height / 2 + 'px', 'important');
    icon.style.setProperty('right', 'auto', 'important');
    icon.style.setProperty('bottom', 'auto', 'important');
    icon.style.setProperty('margin-left', '0', 'important');
  }

  function syncFilterLoadingIcons() {
    return;
  }

  function getFieldKey(field) {
    return field.name + '\u0000' + (field.value || '');
  }

  function getRangeKey(root) {
    var option = root.querySelector('[data-kk-native-range-option]');
    var minInput = root.querySelector('[data-kk-range-min-input]');
    var maxInput = root.querySelector('[data-kk-range-max-input]');

    if (option && option.name) {
      return option.name;
    }

    if (minInput && maxInput && minInput.name && maxInput.name) {
      return minInput.name + '|' + maxInput.name;
    }

    return '';
  }

  function getFormQuery(form) {
    return form ? new URLSearchParams(new FormData(form)).toString() : '';
  }

  function snapshotRange(root) {
    var min = toNumber(root.dataset.kkRangeMin, 0);
    var max = toNumber(root.dataset.kkRangeMax, min);
    var lower = root.querySelector('[data-kk-range-lower]');
    var upper = root.querySelector('[data-kk-range-upper]');
    var minInput = root.querySelector('[data-kk-range-min-input]');
    var maxInput = root.querySelector('[data-kk-range-max-input]');
    var rangeLower = toNumber(lower && lower.value, toNumber(minInput && minInput.value, min));
    var rangeUpper = toNumber(upper && upper.value, toNumber(maxInput && maxInput.value, max));
    var noMatch = kkGetNativeRangeNoMatch(root);

    rangeLower = clamp(rangeLower, min, max);
    rangeUpper = clamp(rangeUpper, min, max);

    if (rangeLower > rangeUpper) {
      rangeUpper = rangeLower;
    }

    return {
      key: getRangeKey(root),
      lower: rangeLower,
      upper: rangeUpper,
      noMatch: Boolean(noMatch)
    };
  }

  function snapshotFilterState() {
    var form = getFilterForm();
    var checkboxes = {};
    var fields = {};
    var ranges = [];

    if (!form) {
      return null;
    }

    Array.prototype.forEach.call(form.elements, function (field) {
      if (!field.name) {
        return;
      }

      if (field.type === 'checkbox' || field.type === 'radio') {
        checkboxes[getFieldKey(field)] = field.checked;
      } else {
        fields[field.name] = field.value;
      }
    });

    form.querySelectorAll('[data-kk-native-range], [data-kk-price-range]').forEach(function (root) {
      var range = snapshotRange(root);

      if (range.key) {
        ranges.push(range);
      }
    });

    return {
      checkboxes: checkboxes,
      fields: fields,
      ranges: ranges,
      query: getFormQuery(form)
    };
  }

  function setFieldValue(input, value) {
    if (!input) return;
    input.value = Number.isInteger(value) ? String(value) : String(value).replace(/\.0$/, '');
  }

  function getFieldKey(field) {
    return field && field.name ? field.name + '\u0000' + (field.value || '') : '';
  }

  function getModalFilterForm(instance) {
    var selector = instance && instance.filterFormSelector ? instance.filterFormSelector : '[data-filter-form]';

    return document.querySelector('[data-modal-container].modal--productgrid-filters ' + selector);
  }

  function setLiveFacetBusy(form, busy) {
    if (!form || !form.setAttribute) {
      return;
    }

    if (busy) {
      form.setAttribute('aria-busy', 'true');
    } else {
      form.removeAttribute('aria-busy');
    }
  }

  function getShowResultsLabel(count) {
    var language = String(document.documentElement.lang || '').toLowerCase();

    if (language.indexOf('fi') === 0) {
      return count === 1 ? 'Näytä 1 tulos' : 'Näytä ' + count + ' tulosta';
    }

    if (language.indexOf('sv') === 0) {
      return 'Visa ' + count + ' resultat';
    }

    return count === 1 ? 'Show 1 result' : 'Show ' + count + ' results';
  }

  function getFilterUiScope(form) {
    return form && (
      form.closest('[data-productgrid-filters-content]') ||
      form.closest('[data-modal-content]')
    );
  }

  function getFacetTitle(facet) {
    var title = facet && facet.querySelector('.kk-facet__title');

    return title ? title.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function ensureMobileStagedFilters(form) {
    var root = getFilterUiScope(form);
    var container = root && root.querySelector('[data-kk-mobile-staged-filters]');
    var scroller;
    var nav;

    if (!root) {
      return null;
    }

    if (!container) {
      container = document.createElement('div');
      container.className = 'kk-mobile-staged-filters';
      container.setAttribute('data-kk-mobile-staged-filters', '');
      if (String(document.documentElement.lang || '').toLowerCase().indexOf('fi') === 0) {
        container.setAttribute('aria-label', 'Valitut suodattimet');
      } else if (String(document.documentElement.lang || '').toLowerCase().indexOf('sv') === 0) {
        container.setAttribute('aria-label', 'Valda filter');
      } else {
        container.setAttribute('aria-label', 'Selected filters');
      }
      container.hidden = true;

      scroller = document.createElement('div');
      scroller.className = 'kk-mobile-staged-filters__scroller';
      container.appendChild(scroller);

      nav = form.closest('nav') || root.querySelector('nav');
      (nav ? nav.parentNode : root).insertBefore(container, nav || root.firstChild);
    }

    return container;
  }

  function appendMobileStagedFilter(filters, label, type, facetIndex, name, value) {
    filters.push({
      key: JSON.stringify([type, facetIndex, name || '', value === undefined || value === null ? '' : value]),
      label: label,
      type: type,
      facetIndex: facetIndex,
      name: name || '',
      value: value === undefined || value === null ? '' : value
    });
  }

  function updateMobileStagedFilterButton(button, filter) {
    var language = String(document.documentElement.lang || '').toLowerCase();
    var removeLabel = language.indexOf('fi') === 0 ?
      'Poista suodatin ' :
      (language.indexOf('sv') === 0 ? 'Ta bort filter ' : 'Remove filter ');
    var text = button.querySelector('.kk-mobile-staged-filter__text');
    var remove = button.querySelector('.kk-mobile-staged-filter__remove');

    button.setAttribute('data-kk-staged-key', filter.key);
    button.setAttribute('data-kk-staged-filter-remove', '');
    button.setAttribute('data-kk-remove-type', filter.type);
    button.setAttribute('data-kk-facet-index', String(filter.facetIndex));
    button.setAttribute('aria-label', removeLabel + filter.label);

    if (filter.name) {
      button.setAttribute('data-kk-filter-name', filter.name);
    } else {
      button.removeAttribute('data-kk-filter-name');
    }
    if (filter.value !== '') {
      button.setAttribute('data-kk-filter-value', filter.value);
    } else {
      button.removeAttribute('data-kk-filter-value');
    }

    if (text && text.textContent !== filter.label) {
      text.textContent = filter.label;
    }
    if (remove) {
      remove.setAttribute('aria-hidden', 'true');
    }
  }

  function createMobileStagedFilterButton(filter) {
    var button = document.createElement('button');
    var text = document.createElement('span');
    var remove = document.createElement('span');

    button.type = 'button';
    button.className = 'kk-mobile-staged-filter';
    text.className = 'kk-mobile-staged-filter__text';
    remove.className = 'kk-mobile-staged-filter__remove';
    button.appendChild(text);
    button.appendChild(remove);
    updateMobileStagedFilterButton(button, filter);
    return button;
  }

  function reconcileMobileStagedFilters(scroller, filters) {
    var existing = new Map();

    scroller.querySelectorAll('[data-kk-staged-filter-remove]').forEach(function (button) {
      var key = button.getAttribute('data-kk-staged-key');

      if (!key || existing.has(key)) {
        button.remove();
        return;
      }
      existing.set(key, button);
    });

    filters.forEach(function (filter, index) {
      var button = existing.get(filter.key) || createMobileStagedFilterButton(filter);
      var current = scroller.children[index];

      updateMobileStagedFilterButton(button, filter);
      if (current !== button) {
        scroller.insertBefore(button, current || null);
      }
      existing.delete(filter.key);
    });

    existing.forEach(function (button) {
      button.remove();
    });
  }

  function renderMobileStagedFilters(form) {
    var container;
    var scroller;
    var filters = [];
    var count = 0;

    if (!form || !isMobileFilterModalOpen()) {
      return;
    }

    container = ensureMobileStagedFilters(form);
    scroller = container && container.querySelector('.kk-mobile-staged-filters__scroller');
    if (!scroller) {
      return;
    }

    Array.prototype.forEach.call(form.querySelectorAll('[data-kk-facet]'), function (facet, facetIndex) {
      var title = getFacetTitle(facet);
      var nativeRange = facet.querySelector('[data-kk-native-range]');
      var priceRange = facet.querySelector('[data-kk-price-range]');
      var checked;
      var values;
      var minInput;
      var maxInput;
      var minValue;
      var maxValue;
      var noMatch;

      if (nativeRange) {
        noMatch = kkGetNativeRangeNoMatch(nativeRange);
        checked = Array.prototype.slice.call(
          nativeRange.querySelectorAll('[data-kk-native-range-option]:checked')
        );

        if (noMatch) {
          appendMobileStagedFilter(
            filters,
            title + ': ' + kkNativeRangeValue(noMatch.lower) + '–' + kkNativeRangeValue(noMatch.upper),
            'native-range',
            facetIndex
          );
          count += 1;
        } else if (checked.length) {
          values = checked.map(function (input) {
            return toNumber(input.getAttribute('data-kk-range-value'), 0);
          }).sort(function (a, b) {
            return a - b;
          });
          appendMobileStagedFilter(
            filters,
            title + ': ' + values[0] + (values.length > 1 ? '–' + values[values.length - 1] : ''),
            'native-range',
            facetIndex
          );
          count += 1;
        }
        return;
      }

      if (priceRange) {
        minInput = priceRange.querySelector('[data-kk-range-min-input]');
        maxInput = priceRange.querySelector('[data-kk-range-max-input]');
        minValue = minInput ? minInput.value.trim() : '';
        maxValue = maxInput ? maxInput.value.trim() : '';

        if (minValue || maxValue) {
          appendMobileStagedFilter(
            filters,
            title + ': ' +
              (minValue || priceRange.getAttribute('data-kk-range-min') || '0') +
              '–' +
              (maxValue || priceRange.getAttribute('data-kk-range-max') || ''),
            'price',
            facetIndex
          );
          count += 1;
        }
        return;
      }

      facet.querySelectorAll('[data-filter-checkbox]:checked').forEach(function (input) {
        var item = input.closest('[data-filter-item]');
        var valueNode = item && item.querySelector('.kk-facet__value');
        var valueLabel = valueNode ? valueNode.textContent.trim() : input.value;

        appendMobileStagedFilter(
          filters,
          title + ': ' + valueLabel,
          'option',
          facetIndex,
          input.name,
          input.value
        );
        count += 1;
      });
    });

    reconcileMobileStagedFilters(scroller, filters);
    container.hidden = count === 0;
    container.setAttribute('data-kk-staged-filter-count', String(count));
  }

  function removeMobileStagedFilter(button) {
    var instance = getDeferredInstance();
    var form = getModalFilterForm(instance);
    var facets = form && form.querySelectorAll('[data-kk-facet]');
    var facetIndex = parseInt(button.getAttribute('data-kk-facet-index'), 10);
    var facet = facets && facets[facetIndex];
    var type = button.getAttribute('data-kk-remove-type');
    var chipIndex = Array.prototype.indexOf.call(
      button.parentNode.querySelectorAll('[data-kk-staged-filter-remove]'),
      button
    );

    if (!instance || !form || !facet) {
      return;
    }

    if (type === 'option') {
      Array.prototype.forEach.call(facet.querySelectorAll('[data-filter-checkbox]'), function (input) {
        var item;

        if (
          input.name !== button.getAttribute('data-kk-filter-name') ||
          input.value !== button.getAttribute('data-kk-filter-value')
        ) {
          return;
        }

        input.checked = false;
        item = input.closest('[data-filter-item]');
        if (item) {
          item.classList.remove('filter-item--active');
          item.classList.add('filter-item--inactive');
        }
      });
    } else if (type === 'native-range') {
      var nativeRoot = facet.querySelector('[data-kk-native-range]');
      facet.querySelectorAll('[data-kk-native-range-option]').forEach(function (input) {
        input.checked = false;
      });
      kkClearNativeRangeNoMatch(nativeRoot);
      syncNativeRangeUi(nativeRoot);
    } else if (type === 'price') {
      var priceRoot = facet.querySelector('[data-kk-price-range]');
      var min = toNumber(priceRoot && priceRoot.getAttribute('data-kk-range-min'), 0);
      var max = toNumber(priceRoot && priceRoot.getAttribute('data-kk-range-max'), min);
      var lower = priceRoot && priceRoot.querySelector('[data-kk-range-lower]');
      var upper = priceRoot && priceRoot.querySelector('[data-kk-range-upper]');
      var minField = priceRoot && priceRoot.querySelector('[data-kk-range-min-input]');
      var maxField = priceRoot && priceRoot.querySelector('[data-kk-range-max-input]');

      if (minField) minField.value = '';
      if (maxField) maxField.value = '';
      if (lower) lower.value = String(min);
      if (upper) upper.value = String(max);
      if (priceRoot) priceRoot.dispatchEvent(new Event('kk:sync-native-range-ui', { bubbles: true }));
    }

    renderMobileStagedFilters(form);
    markDeferredDirty(instance);

    window.requestAnimationFrame(function () {
      var scope = getFilterUiScope(form);
      var remaining = scope.querySelectorAll(
        '[data-kk-staged-filter-remove]'
      );
      var target = remaining[Math.min(chipIndex, Math.max(remaining.length - 1, 0))] ||
        scope.querySelector('[data-kk-filter-results-button]');

      if (target && typeof target.focus === 'function') {
        target.focus();
      }
    });
  }

  function updateLiveFacetResultCount(form, count) {
    var root = getFilterUiScope(form);
    var button = root && root.querySelector('[data-kk-filter-results-button]');
    var status = root && root.querySelector('[data-kk-live-facet-status]');
    var buttonLabel;

    if (!Number.isFinite(count) || count < 0 || !root) {
      return;
    }

    root.setAttribute('data-kk-live-result-count', String(count));
    root.removeAttribute('data-kk-live-facets-stale');

    if (button) {
      button.setAttribute('data-kk-result-count', String(count));
      button.textContent = getShowResultsLabel(count);
    }

    if (status) {
      buttonLabel = button ? button.textContent.trim() : '';
      status.textContent = buttonLabel || String(count);
    }
  }

  function getLiveFacetMessage(type, count) {
    var isFinnish = String(document.documentElement.lang || '').toLowerCase().indexOf('fi') === 0;

    if (type === 'rollback') {
      return isFinnish ?
        'Tällä yhdistelmällä ei ole tuotteita. Viimeisin valinta poistettiin. ' + count + ' tulosta.' :
        'No products match this combination. The latest selection was removed. ' + count + ' results.';
    }

    if (type === 'limit') {
      return isFinnish ?
        'Suodatinvaihtoehtoja ei voida päivittää tälle tulosmäärälle.' :
        'Filter options cannot be updated for this number of results.';
    }

    return isFinnish ?
      'Suodatinvaihtoehtoja ei voitu päivittää. Voit silti näyttää tulokset.' :
      'Filter options could not be updated. You can still show the results.';
  }

  function announceLiveFacetState(form, type, count) {
    var root = getFilterUiScope(form);
    var status = root && root.querySelector('[data-kk-live-facet-status]');

    if (status) {
      status.textContent = getLiveFacetMessage(type, count);
    }
  }

  function markLiveFacetStateStale(form, reason) {
    var root = getFilterUiScope(form);
    var status = root && root.querySelector('[data-kk-live-facet-status]');

    if (root) {
      root.setAttribute('data-kk-live-facets-stale', 'true');
    }

    if (status) {
      status.textContent = getLiveFacetMessage(reason === 'limit' ? 'limit' : 'error');
    }
  }

  function setOptionDisabled(input, disabled) {
    var item = input && input.closest('[data-filter-item]');
    var label = item && item.querySelector('[data-filter-label], .filter-item__label');
    var facet = input && input.closest('[data-kk-facet]');
    var focusTarget = null;

    if (!input) {
      return;
    }

    if (disabled && document.activeElement === input && facet) {
      focusTarget = Array.prototype.find.call(
        facet.querySelectorAll('[data-filter-checkbox]:not(:disabled)'),
        function (candidate) { return candidate !== input; }
      ) || facet.querySelector('summary');
    }

    input.disabled = Boolean(disabled);

    if (item) {
      item.classList.toggle('filter-item--disabled', Boolean(disabled));
      item.classList.toggle('filter-item--active', Boolean(input.checked));
      item.classList.toggle('filter-item--inactive', !input.checked);
    }

    if (label) {
      label.classList.toggle('filter-item__label--disabled', Boolean(disabled));
    }

    if (focusTarget && typeof focusTarget.focus === 'function') {
      try {
        focusTarget.focus({ preventScroll: true });
      } catch (error) {
        focusTarget.focus();
      }
    }
  }

  function rebalanceMobileFacetOptions(form) {
    if (!form || !isMobile() || !form.closest('[data-modal-container].modal--productgrid-filters')) {
      return;
    }

    form.querySelectorAll('[data-kk-filter-list]').forEach(function (list) {
      var facet = list.closest('[data-kk-facet]');
      var search = facet && facet.querySelector('[data-kk-filter-search]');
      var term = search ? search.value.trim() : '';
      var toggle = list.querySelector('[data-filter-toggle]');
      var toggleItem = toggle && toggle.closest('.filter-item');
      var limit = parseInt(list.getAttribute('data-kk-mobile-filter-limit'), 10) || 5;
      var options = Array.prototype.slice.call(list.querySelectorAll('[data-kk-filter-option]'));
      var eligible = [];
      var defaultVisible = new Set();
      var expanded = Boolean(toggle && toggle.getAttribute('data-filter-toggle') === 'true');
      var hasOverflow;

      rememberMobileFacetOptionOrder(list);

      options.forEach(function (item) {
        var input = item.querySelector('[data-filter-checkbox]');
        var selected = Boolean(input && input.checked);

        if (!input || (!selected && input.disabled)) {
          return;
        }

        eligible.push(item);
        if (selected) {
          defaultVisible.add(item);
        }
      });

      eligible.forEach(function (item) {
        if (defaultVisible.size < limit) {
          defaultVisible.add(item);
        }
      });

      options.forEach(function (item) {
        var input = item.querySelector('[data-filter-checkbox]');
        var usable = Boolean(input && (input.checked || !input.disabled));
        var hiddenByDefault = usable && !defaultVisible.has(item);

        if (!item.hasAttribute('data-kk-desktop-hidden-default')) {
          item.setAttribute(
            'data-kk-desktop-hidden-default',
            item.hasAttribute('data-hidden-default') ? 'true' : 'false'
          );
        }

        item.toggleAttribute('data-hidden-default', hiddenByDefault);

        if (!term) {
          item.classList.toggle('filter-item--hidden', hiddenByDefault && expanded === false);
        }
      });

      hasOverflow = eligible.some(function (item) {
        return !defaultVisible.has(item);
      });

      if (!hasOverflow && toggle) {
        expanded = false;
        toggle.setAttribute('data-filter-toggle', 'false');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent =
          toggle.getAttribute('data-kk-see-more-text') ||
          (window.Theme && window.Theme.language && window.Theme.language.see_more) ||
          'See more';
        list.classList.remove('kk-facet__list--expanded');
      }

      if (toggleItem) {
        toggleItem.toggleAttribute('data-kk-no-eligible-overflow', !hasOverflow);
        toggleItem.hidden = Boolean(term) || !hasOverflow;
      }
    });
  }

  function restoreDesktopFacetOptions() {
    if (isMobile()) {
      return;
    }

    document.querySelectorAll('[data-kk-filter-list]').forEach(function (list) {
      var options = list.querySelectorAll('[data-kk-filter-option][data-kk-desktop-hidden-default]');
      var originalOrder = getDirectFacetOptions(list);
      var toggle = list.querySelector('[data-filter-toggle]');
      var toggleItem = toggle && toggle.closest('.filter-item');
      var facet = list.closest('[data-kk-facet]');
      var search = facet && facet.querySelector('[data-kk-filter-search]');

      if (originalOrder.some(function (item) {
        return item.hasAttribute('data-kk-mobile-original-order');
      })) {
        originalOrder.sort(function (a, b) {
          var aIndex = parseInt(a.getAttribute('data-kk-mobile-original-order'), 10);
          var bIndex = parseInt(b.getAttribute('data-kk-mobile-original-order'), 10);
          return (Number.isFinite(aIndex) ? aIndex : Number.MAX_SAFE_INTEGER) -
            (Number.isFinite(bIndex) ? bIndex : Number.MAX_SAFE_INTEGER);
        });
        applyFacetOptionOrder(list, originalOrder);
      }

      if (!options.length) {
        return;
      }

      options.forEach(function (item) {
        var hiddenByDefault = item.getAttribute('data-kk-desktop-hidden-default') === 'true';

        item.toggleAttribute('data-hidden-default', hiddenByDefault);
        item.classList.toggle('filter-item--hidden', hiddenByDefault);
        item.classList.remove('kk-filter-option--search-hidden');
        item.hidden = item.hasAttribute('data-kk-scoped-zero-option');
        item.removeAttribute('data-kk-desktop-hidden-default');
        item.removeAttribute('data-kk-mobile-original-order');
      });

      if (search) {
        search.value = '';
      }

      list.classList.remove('kk-facet__list--expanded');

      if (toggle) {
        toggle.setAttribute('data-filter-toggle', 'false');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent =
          toggle.getAttribute('data-kk-see-more-text') ||
          (window.Theme && window.Theme.language && window.Theme.language.see_more) ||
          'See more';
      }

      if (toggleItem) {
        toggleItem.hidden = false;
        toggleItem.removeAttribute('data-kk-no-eligible-overflow');
        toggleItem.classList.remove('kk-filter-option--search-hidden');
      }
    });
  }

  function syncFacetOptionsForBreakpoint() {
    var instance;
    var form;
    var scrollState;

    if (!isMobile()) {
      restoreDesktopFacetOptions();
      return;
    }

    if (isMobileFilterModalOpen()) {
      instance = getDeferredInstance();
      form = getModalFilterForm(instance);
      scrollState = captureLiveFacetScrollState(form);
      applyLatestLiveFacetOrders(form);
      rebalanceMobileFacetOptions(form);
      restoreLiveFacetScrollState(scrollState);
    }
  }

  function getOptionCountNode(input) {
    var item = input && input.closest('[data-filter-item]');
    return item ? item.querySelector('.kk-facet__count') : null;
  }

  function buildFreshOptionMap(freshForm) {
    var map = new Map();

    if (!freshForm) {
      return map;
    }

    freshForm.querySelectorAll('[data-filter-checkbox][name]').forEach(function (input) {
      var key = getFieldKey(input);
      if (key) {
        map.set(key, input);
      }
    });

    return map;
  }

  function getFacetParamName(input) {
    var facet = input && input.closest('[data-kk-facet]');
    var firstInput = facet && facet.querySelector('[data-filter-checkbox][name]');
    return firstInput ? firstInput.name : '';
  }

  function buildFreshFacetGroupMap(freshForm) {
    var groups = new Map();

    if (!freshForm) {
      return groups;
    }

    freshForm.querySelectorAll('[data-kk-facet]').forEach(function (facet) {
      var options = facet.querySelectorAll('[data-filter-checkbox][name]');
      var name = options[0] ? options[0].name : '';

      if (name) {
        groups.set(name, options.length);
      }
    });

    return groups;
  }

  function getDirectFacetOptions(list) {
    return Array.prototype.filter.call(list ? list.children : [], function (item) {
      return item.matches && item.matches('[data-kk-filter-option]');
    });
  }

  function rememberMobileFacetOptionOrder(list) {
    getDirectFacetOptions(list).forEach(function (item, index) {
      if (!item.hasAttribute('data-kk-mobile-original-order')) {
        item.setAttribute('data-kk-mobile-original-order', String(index));
      }
    });
  }

  function buildFreshFacetOrderMap(freshForm) {
    var orders = new Map();

    if (!freshForm) {
      return orders;
    }

    freshForm.querySelectorAll('[data-kk-filter-list]').forEach(function (list) {
      var inputs = list.querySelectorAll('[data-kk-filter-option] [data-filter-checkbox][name]');
      var name = inputs[0] ? inputs[0].name : '';
      var keys = [];

      inputs.forEach(function (input) {
        var key = getFieldKey(input);
        if (key) {
          keys.push(key);
        }
      });

      if (name) {
        orders.set(name, keys);
      }
    });

    return orders;
  }

  function orderCurrentFacetOptions(list, desiredKeys) {
    var options = getDirectFacetOptions(list);
    var optionsByKey = new Map();
    var included = new Set();
    var ordered = [];

    options.forEach(function (item) {
      var input = item.querySelector('[data-filter-checkbox][name]');
      var key = getFieldKey(input);
      if (key && !optionsByKey.has(key)) {
        optionsByKey.set(key, item);
      }
    });

    desiredKeys.forEach(function (key) {
      var item = optionsByKey.get(key);
      if (item && !included.has(item)) {
        ordered.push(item);
        included.add(item);
      }
    });

    options.forEach(function (item) {
      if (!included.has(item)) {
        ordered.push(item);
      }
    });

    return ordered;
  }

  function applyFacetOptionOrder(list, orderedOptions) {
    var nonOptions = Array.prototype.filter.call(list.children, function (item) {
      return !item.matches || !item.matches('[data-kk-filter-option]');
    });
    var orderedChildren = orderedOptions.concat(nonOptions);
    var currentChildren = Array.prototype.slice.call(list.children);
    var changed = currentChildren.length !== orderedChildren.length || orderedChildren.some(function (item, index) {
      return currentChildren[index] !== item;
    });
    var activeElement;
    var activeChild;
    var activeIndex;
    var beforeFragment;
    var afterFragment;

    if (!changed) {
      return false;
    }

    activeElement = document.activeElement;
    activeChild = activeElement && list.contains(activeElement) && activeElement.closest ?
      activeElement.closest('[data-kk-filter-option], .filter-item--toggle-more') :
      null;
    activeIndex = activeChild && activeChild.parentNode === list ? orderedChildren.indexOf(activeChild) : -1;

    if (activeIndex !== -1) {
      beforeFragment = document.createDocumentFragment();
      afterFragment = document.createDocumentFragment();
      orderedChildren.slice(0, activeIndex).forEach(function (item) {
        beforeFragment.appendChild(item);
      });
      orderedChildren.slice(activeIndex + 1).forEach(function (item) {
        afterFragment.appendChild(item);
      });
      list.insertBefore(beforeFragment, activeChild);
      list.insertBefore(afterFragment, activeChild.nextSibling);
    } else if (typeof list.replaceChildren === 'function') {
      list.replaceChildren.apply(list, orderedChildren);
    } else {
      orderedChildren.forEach(function (item) {
        list.appendChild(item);
      });
    }

    return true;
  }

  function captureLiveFacetScrollState(form) {
    var modalInner = form && (form.closest('.modal-inner') || form.closest('[data-modal-inner]'));
    var lists = [];

    if (form) {
      form.querySelectorAll('[data-kk-filter-list]').forEach(function (list) {
        lists.push({ element: list, scrollTop: list.scrollTop });
      });
    }

    return {
      modalInner: modalInner,
      modalScrollTop: modalInner ? modalInner.scrollTop : 0,
      lists: lists
    };
  }

  function restoreLiveFacetScrollState(state) {
    if (!state) {
      return;
    }

    state.lists.forEach(function (entry) {
      if (entry.element && entry.element.isConnected) {
        entry.element.scrollTop = entry.scrollTop;
      }
    });

    if (state.modalInner && state.modalInner.isConnected) {
      state.modalInner.scrollTop = state.modalScrollTop;
    }
  }

  function reorderLiveFacetOptions(form, freshForm, expectedQuery) {
    var orders = buildFreshFacetOrderMap(freshForm);
    var querySignature = getLiveFacetQuerySignature(
      expectedQuery || buildLiveFacetUrl(getDeferredInstance())
    );

    form.querySelectorAll('[data-kk-filter-list]').forEach(function (list) {
      var firstInput = list.querySelector('[data-filter-checkbox][name]');
      var desiredKeys = firstInput ? orders.get(firstInput.name) : null;

      if (!desiredKeys) {
        return;
      }

      rememberMobileFacetOptionOrder(list);
      liveFacetLatestOrders.set(list, desiredKeys.slice());

      if (isLiveFacetPointerActive(list)) {
        liveFacetPendingOrders.set(list, {
          desiredKeys: desiredKeys.slice(),
          expectedQuerySignature: querySignature
        });
        return;
      }

      liveFacetPendingOrders.delete(list);
      applyFacetOptionOrder(list, orderCurrentFacetOptions(list, desiredKeys));
    });
  }

  function applyLatestLiveFacetOrders(form) {
    if (!form) {
      return;
    }

    form.querySelectorAll('[data-kk-filter-list]').forEach(function (list) {
      var desiredKeys = liveFacetLatestOrders.get(list);

      if (!desiredKeys) {
        return;
      }

      rememberMobileFacetOptionOrder(list);
      applyFacetOptionOrder(list, orderCurrentFacetOptions(list, desiredKeys));
    });
  }

  function reconcileLiveFacetOptions(form, freshForm, zeroResults, expectedQuery) {
    var freshOptions = buildFreshOptionMap(freshForm);
    var freshGroups = buildFreshFacetGroupMap(freshForm);
    var scrollState = captureLiveFacetScrollState(form);

    if (freshForm) {
      reorderLiveFacetOptions(form, freshForm, expectedQuery || '');
    }

    form.querySelectorAll('[data-filter-checkbox][name]').forEach(function (input) {
      var freshInput = freshOptions.get(getFieldKey(input));
      var freshCount = getOptionCountNode(freshInput);
      var liveCount = getOptionCountNode(input);
      var facetParamName = getFacetParamName(input);
      var freshGroupSize = freshGroups.get(facetParamName);
      var disabled;

      if (freshInput) {
        disabled = !input.checked && freshInput.disabled;
        if (liveCount && freshCount) {
          liveCount.textContent = freshCount.textContent;
        }
        setOptionDisabled(input, disabled);
        return;
      }

      if (zeroResults) {
        if (liveCount) {
          liveCount.textContent = '(0)';
        }
        setOptionDisabled(input, !input.checked);
        return;
      }

      if (!input.checked && freshGroupSize > 0 && freshGroupSize < 100) {
        if (liveCount) {
          liveCount.textContent = '(0)';
        }
        setOptionDisabled(input, true);
      }
    });

    rebalanceMobileFacetOptions(form);
    restoreLiveFacetScrollState(scrollState);
  }

  function captureLiveFacetSelection(form) {
    var state = new Map();

    if (!form) {
      return state;
    }

    Array.prototype.forEach.call(form.elements, function (field) {
      var key;

      if (!field || !field.name) {
        return;
      }

      if (field.type === 'checkbox' || field.type === 'radio') {
        key = getFieldKey(field);
        state.set(key, {
          checked: Boolean(field.checked),
          type: field.type
        });
      } else {
        key = field.name + '\u0000__field';
        state.set(key, {
          value: field.value,
          type: field.type
        });
      }
    });

    return state;
  }

  function restoreLiveFacetSelection(form, state) {
    if (!form || !state) {
      return;
    }

    Array.prototype.forEach.call(form.elements, function (field) {
      var key;
      var saved;

      if (!field || !field.name) {
        return;
      }

      key = field.type === 'checkbox' || field.type === 'radio' ?
        getFieldKey(field) :
        field.name + '\u0000__field';
      saved = state.get(key);

      if (!saved) {
        return;
      }

      if (field.type === 'checkbox' || field.type === 'radio') {
        field.checked = Boolean(saved.checked);
      } else {
        field.value = saved.value;
      }
    });

    syncDeferredRangeUi(form);

    Array.prototype.forEach.call(form.elements, function (field) {
      var saved;

      if (!field || !field.name || field.type === 'checkbox' || field.type === 'radio') {
        return;
      }

      saved = state.get(field.name + '\u0000__field');
      if (saved) {
        field.value = saved.value;
      }
    });
  }

  function isAtRangeStart(value, min) {
    return value <= min || Math.abs(value - min) < 0.0001;
  }

  function isAtRangeEnd(value, max) {
    return value >= max || Math.abs(value - max) < 0.0001;
  }

  function setRangeFieldValues(root, minInput, maxInput, lower, upper, min, max) {
    var isPriceRange = root.hasAttribute('data-kk-price-range');

    if (!isPriceRange) {
      setFieldValue(minInput, lower);
      setFieldValue(maxInput, upper);
      return;
    }

    if (minInput) {
      if (isAtRangeStart(lower, min)) {
        minInput.value = '';
      } else {
        setFieldValue(minInput, lower);
      }
    }

    if (maxInput) {
      if (isAtRangeEnd(upper, max)) {
        maxInput.value = '';
      } else {
        setFieldValue(maxInput, upper);
      }
    }
  }

  function applyRangeState(root, state) {
    var min = toNumber(root.dataset.kkRangeMin, 0);
    var max = toNumber(root.dataset.kkRangeMax, min);
    var lower = clamp(toNumber(state.lower, min), min, max);
    var upper = clamp(toNumber(state.upper, max), min, max);
    var lowerSlider = root.querySelector('[data-kk-range-lower]');
    var upperSlider = root.querySelector('[data-kk-range-upper]');
    var minInput = root.querySelector('[data-kk-range-min-input]');
    var maxInput = root.querySelector('[data-kk-range-max-input]');

    if (lower > upper) {
      upper = lower;
    }

    if (lowerSlider) lowerSlider.value = lower;
    if (upperSlider) upperSlider.value = upper;
    setRangeFieldValues(root, minInput, maxInput, lower, upper, min, max);

    if (root.hasAttribute('data-kk-native-range')) {
      var fullRange = lower <= min && upper >= max;

      root.querySelectorAll('[data-kk-native-range-option]').forEach(function (option) {
        var value = toNumber(option.dataset.kkRangeValue, min);
        option.checked = !fullRange && value >= lower && value <= upper && !option.disabled;
      });

      if (state.noMatch && !fullRange) {
        root.querySelectorAll('[data-kk-native-range-option]').forEach(function (option) {
          option.checked = false;
        });
        kkSetNativeRangeNoMatch(root, lower, upper);
      } else {
        kkClearNativeRangeNoMatch(root);
      }
    }

    root.dispatchEvent(new Event('kk:sync-native-range-ui', { bubbles: true }));
  }

  function applySnapshot(snapshot) {
    var form = getFilterForm();
    var rangesByKey = {};

    if (!form || !snapshot) {
      return false;
    }

    Array.prototype.forEach.call(form.elements, function (field) {
      if (!field.name) {
        return;
      }

      if (field.type === 'checkbox' || field.type === 'radio') {
        field.checked = Boolean(snapshot.checkboxes[getFieldKey(field)]);
      } else if (Object.prototype.hasOwnProperty.call(snapshot.fields, field.name)) {
        field.value = snapshot.fields[field.name];
      }
    });

    snapshot.ranges.forEach(function (range) {
      rangesByKey[range.key] = range;
    });

    form.querySelectorAll('[data-kk-native-range], [data-kk-price-range]').forEach(function (root) {
      var key = getRangeKey(root);

      if (key && rangesByKey[key]) {
        applyRangeState(root, rangesByKey[key]);
      }
    });

    return true;
  }

  function findSyntheticChangeTarget(form) {
    return form.querySelector('[data-filter-checkbox]') ||
      form.querySelector('[data-filter-range]') ||
      form.querySelector('[name]');
  }

  function dispatchCombinedFilterChange(snapshot) {
    var form = getFilterForm();
    var target;

    if (!form || !snapshot) {
      setFilterProcessing(false);
      return;
    }

    if (!applySnapshot(snapshot)) {
      setFilterProcessing(false);
      return;
    }

    if (getFormQuery(form) === snapshot.query && window.location.search.indexOf(snapshot.query) !== -1) {
      setFilterProcessing(false);
      return;
    }

    target = findSyntheticChangeTarget(form);

    if (!target) {
      setFilterProcessing(false);
      return;
    }

    replayingPendingSnapshot = true;
    setFilterProcessing(true);
    target.dispatchEvent(new Event('change', { bubbles: true }));

    window.setTimeout(function () {
      replayingPendingSnapshot = false;
    }, 0);
  }

  function flushPendingSnapshot() {
    var snapshot;

    window.clearTimeout(pendingFlushTimer);

    if (!pendingSnapshot || isFilterProcessing()) {
      return;
    }

    snapshot = pendingSnapshot;
    pendingSnapshot = null;
    dispatchCombinedFilterChange(snapshot);
  }

  function queuePendingSnapshot() {
    if (replayingPendingSnapshot) {
      return;
    }

    window.setTimeout(function () {
      if (!isFilterProcessing()) {
        return;
      }

      pendingSnapshot = snapshotFilterState() || pendingSnapshot;
      setFilterProcessing(true);
    }, 0);
  }

  function isNativeFilterTarget(target) {
    return Boolean(target.closest(
      '[data-filter-checkbox], [data-filter-range], [data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]'
    ));
  }

  document.addEventListener('change', function (event) {
    if (isNativeFilterTarget(event.target)) {
      queuePendingSnapshot();
    }
  }, true);

  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Tab' && isNativeFilterTarget(event.target)) {
      queuePendingSnapshot();
    }
  }, true);

  if (window.MutationObserver) {
    new MutationObserver(function () {
      syncFilterLoadingIcons();

      if (!pendingSnapshot) {
        return;
      }

      window.clearTimeout(pendingFlushTimer);
      pendingFlushTimer = window.setTimeout(flushPendingSnapshot, 30);
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', syncFilterLoadingIcons);
    window.visualViewport.addEventListener('scroll', syncFilterLoadingIcons);
  }

  window.addEventListener('resize', syncFilterLoadingIcons);
  syncFilterLoadingIcons();

  var activeDeferredInstance = null;
  var pendingDeferredApplyInstance = null;
  var liveFacetTimer = null;
  var liveFacetController = null;
  var liveFacetRequestId = 0;
  var liveFacetSessionId = 0;
  var liveFacetSessionOpen = false;
  var liveFacetActiveQuery = '';
  var liveFacetActiveForm = null;
  var liveFacetCache = new Map();
  var liveFacetCacheOrder = [];
  var liveFacetLastValidSelection = null;
  var liveFacetLastValidForm = null;
  var liveFacetLastValidCount = null;
  var liveFacetPointerTargets = new Map();
  var liveFacetPointerCounts = new WeakMap();
  var liveFacetPendingOrders = new WeakMap();
  var liveFacetLatestOrders = new WeakMap();
  var LIVE_FACET_DEBOUNCE_MS = 200;
  var LIVE_FACET_CACHE_LIMIT = 12;

  function isLiveFacetPointerActive(list) {
    return Boolean(list && (liveFacetPointerCounts.get(list) || 0) > 0);
  }

  function getLiveFacetQuerySignature(query) {
    var url;
    var pairs = [];

    if (!query) {
      return '';
    }

    try {
      url = new URL(query, window.location.origin);
      url.searchParams.forEach(function (value, name) {
        pairs.push(JSON.stringify([name, value]));
      });
      pairs.sort();
      return url.pathname + '?' + pairs.join('&');
    } catch (error) {
      return String(query);
    }
  }

  function flushPendingLiveFacetOrder(list) {
    var pending = list && liveFacetPendingOrders.get(list);
    var instance;
    var form;
    var scrollState;

    if (!pending || isLiveFacetPointerActive(list)) {
      return;
    }

    liveFacetPendingOrders.delete(list);
    instance = getDeferredInstance();
    form = list.closest('form');

    if (
      !list.isConnected ||
      !form ||
      !isMobileFilterModalOpen() ||
      (
        pending.expectedQuerySignature &&
        getLiveFacetQuerySignature(buildLiveFacetUrl(instance)) !== pending.expectedQuerySignature
      )
    ) {
      return;
    }

    scrollState = captureLiveFacetScrollState(form);
    applyFacetOptionOrder(list, orderCurrentFacetOptions(list, pending.desiredKeys));
    rebalanceMobileFacetOptions(form);
    restoreLiveFacetScrollState(scrollState);
  }

  function trackLiveFacetPointer(event) {
    var list = event.target && event.target.closest ? event.target.closest('[data-kk-filter-list]') : null;
    var previousList = liveFacetPointerTargets.get(event.pointerId);

    if (!list || !isMobileFilterModalOpen()) {
      return;
    }

    if (previousList && previousList !== list) {
      liveFacetPointerCounts.set(previousList, Math.max(0, (liveFacetPointerCounts.get(previousList) || 1) - 1));
    }

    if (previousList !== list) {
      liveFacetPointerTargets.set(event.pointerId, list);
      liveFacetPointerCounts.set(list, (liveFacetPointerCounts.get(list) || 0) + 1);
    }
  }

  function releaseLiveFacetPointer(event) {
    var list = liveFacetPointerTargets.get(event.pointerId);
    var remaining;

    if (!list) {
      return;
    }

    liveFacetPointerTargets.delete(event.pointerId);
    remaining = Math.max(0, (liveFacetPointerCounts.get(list) || 1) - 1);
    liveFacetPointerCounts.set(list, remaining);

    if (remaining === 0) {
      window.setTimeout(function () {
        flushPendingLiveFacetOrder(list);
      }, 0);
    }
  }

  function isMobile() {
    return window.matchMedia ?
      window.matchMedia('(max-width: 859px)').matches :
      window.innerWidth < 860;
  }

  function isMobileFilterModalOpen() {
    var modal = document.querySelector('[data-modal-container]');

    return Boolean(
      modal &&
      modal.classList.contains('modal--productgrid-filters') &&
      document.body.classList.contains('modal-visible') &&
      isMobile()
    );
  }

  function getDeferredInstance() {
    var instances = window.bcSections && window.bcSections.instances;
    var found = null;

    if (
      activeDeferredInstance &&
      activeDeferredInstance.el &&
      document.body.contains(activeDeferredInstance.el)
    ) {
      return activeDeferredInstance;
    }

    if (!instances) {
      return null;
    }

    Object.keys(instances).some(function (key) {
      var instance = instances[key];

      if (window.bcStaticSearch && instance instanceof window.bcStaticSearch) {
        found = instance;
        return true;
      }

      if (window.bcStaticCollection && instance instanceof window.bcStaticCollection) {
        found = instance;
        return true;
      }

      return false;
    });

    return found;
  }

  function toNumber(value, fallback) {
    var parsed = parseFloat(String(value).replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function setFieldValue(input, value) {
    if (!input) return;
    input.value = Number.isInteger(value) ? String(value) : String(value).replace(/\.0$/, '');
  }

  function syncPriceRangeUi(root) {
    var min = toNumber(root.dataset.kkRangeMin, 0);
    var max = toNumber(root.dataset.kkRangeMax, min);
    var lower = root.querySelector('[data-kk-range-lower]');
    var upper = root.querySelector('[data-kk-range-upper]');
    var minInput = root.querySelector('[data-kk-range-min-input]');
    var maxInput = root.querySelector('[data-kk-range-max-input]');
    var lowerValue = clamp(toNumber(minInput && minInput.value, min), min, max);
    var upperValue = clamp(toNumber(maxInput && maxInput.value, max), min, max);

    if (lowerValue > upperValue) {
      upperValue = lowerValue;
    }

    if (lower) lower.value = lowerValue;
    if (upper) upper.value = upperValue;
    setFieldValue(minInput, lowerValue);
    setFieldValue(maxInput, upperValue);
    root.dispatchEvent(new Event('kk:sync-native-range-ui', { bubbles: true }));
  }

  function syncNativeRangeUi(root) {
    var min = toNumber(root.dataset.kkRangeMin, 0);
    var max = toNumber(root.dataset.kkRangeMax, min);
    var values = [];
    var lower = root.querySelector('[data-kk-range-lower]');
    var upper = root.querySelector('[data-kk-range-upper]');
    var minInput = root.querySelector('[data-kk-range-min-input]');
    var maxInput = root.querySelector('[data-kk-range-max-input]');
    var noMatch = kkGetNativeRangeNoMatch(root);

    if (noMatch) {
      values = [noMatch.lower, noMatch.upper];
    } else {
      root.querySelectorAll('[data-kk-native-range-option]').forEach(function (option) {
        if (option.checked) {
          values.push(toNumber(option.dataset.kkRangeValue, min));
        }
      });
    }

    if (!values.length) {
      values = [min, max];
    }

    values.sort(function (a, b) {
      return a - b;
    });

    if (lower) lower.value = values[0];
    if (upper) upper.value = values[values.length - 1];
    setFieldValue(minInput, values[0]);
    setFieldValue(maxInput, values[values.length - 1]);
    root.dispatchEvent(new Event('kk:sync-native-range-ui', { bubbles: true }));
  }

  function syncDeferredRangeUi(form) {
    form.querySelectorAll('[data-kk-price-range]').forEach(syncPriceRangeUi);
    form.querySelectorAll('[data-kk-native-range]').forEach(syncNativeRangeUi);
  }

  function rememberLastValidLiveFacetState(form, count, freshForm) {
    if (!form || !Number.isFinite(count) || count < 1) {
      return;
    }

    liveFacetLastValidSelection = captureLiveFacetSelection(form);
    liveFacetLastValidForm = (freshForm || form).cloneNode(true);
    liveFacetLastValidCount = count;
  }

  function captureInitialLiveFacetState(instance, preferredForm) {
    var sourceForm;
    var results;
    var count;

    if (liveFacetLastValidSelection || !instance || !instance.el) {
      return;
    }

    sourceForm = preferredForm ||
      getModalFilterForm(instance) ||
      instance.el.querySelector(instance.filterFormSelector || '[data-filter-form]');
    results = instance.el.querySelector('[data-results-container]');
    count = Number.isFinite(liveFacetLastValidCount) ?
      liveFacetLastValidCount :
      parseInt(results && results.getAttribute('data-product-count'), 10);

    if (sourceForm && Number.isFinite(count) && count > 0) {
      rememberLastValidLiveFacetState(sourceForm, count);
    }
  }

  function primeLiveFacetSession(instance) {
    var form;
    var results;
    var count;

    if (!isMobileFilterModalOpen()) {
      return;
    }

    instance = instance || getDeferredInstance();
    form = getModalFilterForm(instance);

    if (!instance || !form || !form.querySelector('[data-kk-facet]')) {
      return;
    }

    if (!liveFacetSessionOpen) {
      liveFacetSessionOpen = true;
      liveFacetSessionId += 1;
    }

    rebalanceMobileFacetOptions(form);
    captureInitialLiveFacetState(instance, form);
    results = instance.el.querySelector('[data-results-container]');
    count = parseInt(results && results.getAttribute('data-product-count'), 10);
    if (Number.isFinite(count) && count >= 0) {
      updateLiveFacetResultCount(form, count);
    }
    renderMobileStagedFilters(form);
  }

  function restoreLastValidLiveFacetState(form) {
    if (!form || !liveFacetLastValidSelection || !liveFacetLastValidForm) {
      return false;
    }

    restoreLiveFacetSelection(form, liveFacetLastValidSelection);
    reconcileLiveFacetOptions(form, liveFacetLastValidForm, false);
    reconcileNativeRanges(form, liveFacetLastValidForm);
    repaintNativeRanges(form);
    updateLiveFacetResultCount(form, liveFacetLastValidCount);
    renderMobileStagedFilters(form);
    announceLiveFacetState(form, 'rollback', liveFacetLastValidCount);
    return true;
  }

  function reconcileNativeRanges(form, freshForm) {
    var freshRanges = new Map();

    if (!form || !freshForm) {
      return;
    }

    freshForm.querySelectorAll('[data-kk-native-range]').forEach(function (range) {
      var option = range.querySelector('[data-kk-native-range-option][name]');

      if (option) {
        freshRanges.set(option.name, range);
      }
    });

    form.querySelectorAll('[data-kk-native-range]').forEach(function (current) {
      var option = current.querySelector('[data-kk-native-range-option][name]');
      var fresh = option && freshRanges.get(option.name);
      var newMin;
      var newMax;
      var bounds;
      var freshBounds;
      var unit;

      if (!fresh) {
        return;
      }

      newMin = toNumber(fresh.dataset.kkRangeMin, NaN);
      newMax = toNumber(fresh.dataset.kkRangeMax, NaN);

      if (!Number.isFinite(newMin) || !Number.isFinite(newMax) || newMax < newMin) {
        return;
      }

      current.dataset.kkRangeMin = String(newMin);
      current.dataset.kkRangeMax = String(newMax);

      current.querySelectorAll(
        '[data-kk-range-min-input], [data-kk-range-max-input], [data-kk-range-lower], [data-kk-range-upper]'
      ).forEach(function (input) {
        input.setAttribute('min', String(newMin));
        input.setAttribute('max', String(newMax));
      });

      current.querySelectorAll('[data-kk-native-range-option]').forEach(function (input) {
        var value = toNumber(input.dataset.kkRangeValue, NaN);

        // An active value outside the new contextual domain cannot contribute
        // to the preview result. Drop it so the staged form, fields and chips
        // all describe the same effective range.
        if (input.checked && Number.isFinite(value) && (value < newMin || value > newMax)) {
          input.checked = false;
        }
      });

      bounds = current.querySelectorAll('.kk-range-filter__bounds span');
      freshBounds = fresh.querySelectorAll('.kk-range-filter__bounds span');
      unit = current.getAttribute('data-kk-range-unit') || '';
      if (bounds[0]) bounds[0].textContent = freshBounds[0] ? freshBounds[0].textContent : String(newMin) + (unit ? ' ' + unit : '');
      if (bounds[1]) bounds[1].textContent = freshBounds[1] ? freshBounds[1].textContent : String(newMax) + (unit ? ' ' + unit : '');

      syncNativeRangeUi(current);
    });
  }

  function reconcilePriceRange(form, freshForm) {
    var current = form.querySelector('[data-kk-price-range]');
    var fresh = freshForm && freshForm.querySelector('[data-kk-price-range]');
    var minInput;
    var maxInput;
    var lower;
    var upper;
    var bounds;
    var freshBounds;
    var newMin;
    var newMax;
    var oldMin;
    var oldMax;
    var currentLower;
    var currentUpper;
    var explicitMin;
    var explicitMax;

    if (!current || !fresh) {
      return;
    }

    newMin = toNumber(fresh.dataset.kkRangeMin, NaN);
    newMax = toNumber(fresh.dataset.kkRangeMax, NaN);

    if (!Number.isFinite(newMin) || !Number.isFinite(newMax) || newMax < newMin) {
      return;
    }

    oldMin = toNumber(current.dataset.kkRangeMin, newMin);
    oldMax = toNumber(current.dataset.kkRangeMax, newMax);
    minInput = current.querySelector('[data-kk-range-min-input]');
    maxInput = current.querySelector('[data-kk-range-max-input]');
    lower = current.querySelector('[data-kk-range-lower]');
    upper = current.querySelector('[data-kk-range-upper]');
    explicitMin = Boolean(minInput && minInput.value !== '');
    explicitMax = Boolean(maxInput && maxInput.value !== '');

    if (explicitMin || explicitMax) {
      return;
    }

    currentLower = clamp(toNumber(lower && lower.value, oldMin), newMin, newMax);
    currentUpper = clamp(toNumber(upper && upper.value, oldMax), newMin, newMax);

    if (!explicitMin) {
      currentLower = newMin;
    }
    if (!explicitMax) {
      currentUpper = newMax;
    }
    if (currentLower > currentUpper) {
      if (explicitMin && !explicitMax) {
        currentUpper = currentLower;
      } else {
        currentLower = currentUpper;
      }
    }

    current.dataset.kkRangeMin = String(newMin);
    current.dataset.kkRangeMax = String(newMax);

    [minInput, maxInput, lower, upper].forEach(function (input) {
      if (!input) return;
      input.setAttribute('min', String(newMin));
      input.setAttribute('max', String(newMax));
    });

    if (maxInput) {
      maxInput.placeholder = String(newMax);
      maxInput.setAttribute('placeholder', String(newMax));
    }

    if (lower) setFieldValue(lower, currentLower);
    if (upper) setFieldValue(upper, currentUpper);
    if (explicitMin && minInput) setFieldValue(minInput, currentLower);
    if (explicitMax && maxInput) setFieldValue(maxInput, currentUpper);

    bounds = current.querySelectorAll('.kk-range-filter__bounds span');
    freshBounds = fresh.querySelectorAll('.kk-range-filter__bounds span');
    if (bounds[0] && freshBounds[0]) bounds[0].textContent = freshBounds[0].textContent;
    if (bounds[1] && freshBounds[1]) bounds[1].textContent = freshBounds[1].textContent;

    current.dispatchEvent(new Event('kk:sync-native-range-ui', { bubbles: true }));
  }

  function repaintNativeRanges(form) {
    form.querySelectorAll('[data-kk-native-range]').forEach(function (range) {
      range.dispatchEvent(new Event('kk:sync-native-range-ui', { bubbles: true }));
    });
  }

  function decodeLiveSearchTerm(value) {
    try {
      return decodeURIComponent(String(value || '').replace(/\+/g, '%20')).trim();
    } catch (error) {
      return String(value || '').replace(/\+/g, ' ').trim();
    }
  }

  function isEmbeddedCollectionSearch(instance) {
    return Boolean(
      instance &&
      instance.queryParams &&
      decodeLiveSearchTerm(instance.queryParams.q)
    );
  }

  function getLiveSearchBaseUrl() {
    return window.Theme && window.Theme.routes && window.Theme.routes.search_url ?
      window.Theme.routes.search_url :
      '/search';
  }

  function isNativeCollectionLiveFacetInstance(instance) {
    var root;

    if (!instance || !instance.el) {
      return false;
    }

    root = instance.el.matches && instance.el.matches('[data-kk-headless-collection]') ?
      instance.el :
      instance.el.querySelector('[data-kk-headless-collection]');

    return !root;
  }

  function buildLiveFacetUrl(instance) {
    var form = getModalFilterForm(instance);
    var embeddedSearch = isEmbeddedCollectionSearch(instance);
    var currentUrl;
    var currentSort;
    var url;
    var formData;

    if (!form || !isNativeCollectionLiveFacetInstance(instance)) {
      return '';
    }

    // The regular search endpoint is store-wide. Embedded collection search
    // is reconciled from the collection's local index instead, so never let a
    // mobile native-facet refresh escape to /search.
    if (embeddedSearch) {
      return '';
    }

    try {
      url = new URL(window.location.pathname, window.location.origin);
    } catch (error) {
      return '';
    }

    try {
      currentUrl = new URL(window.location.href);
      currentSort = currentUrl.searchParams.get('sort_by');
    } catch (error) {
      currentSort = '';
    }

    if (currentSort) {
      url.searchParams.set('sort_by', currentSort);
    }

    formData = new FormData(form);
    new URLSearchParams(formData).forEach(function (value, name) {
      if (
        name === 'page' ||
        name === 'view' ||
        name === 'grid_list' ||
        name === 'sort_by' ||
        name === 'type' ||
        name === 'section_id' ||
        name === 'sections' ||
        name === 'q'
      ) {
        return;
      }

      url.searchParams.append(name, value);
    });

    url.searchParams.delete('page');
    url.searchParams.delete('grid_list');
    url.searchParams.set('view', 'kk-facets');

    return url.pathname + url.search;
  }

  function applyNativeRangeNoMatchLiveFacetState(form, expectedQuery) {
    var scope = getFilterUiScope(form);

    if (!form || !kkHasNativeRangeNoMatch(expectedQuery)) return false;

    updateLiveFacetResultCount(form, 0);
    repaintNativeRanges(form);
    renderMobileStagedFilters(form);
    if (scope) scope.setAttribute('data-kk-live-facets-query', expectedQuery);
    document.dispatchEvent(new CustomEvent('kk:collection-live-facets-updated', {
      detail: {
        count: 0,
        url: expectedQuery,
        search: false,
        noMatchRange: true
      }
    }));
    return true;
  }

  function markActiveNativeRangesNoMatch(form) {
    var changed = false;

    if (!form) return false;

    form.querySelectorAll('[data-kk-native-range]').forEach(function (root) {
      var checked = root.querySelectorAll('[data-kk-native-range-option]:checked');
      var range;
      var fullRange;

      if (!checked.length || kkGetNativeRangeNoMatch(root)) return;

      range = readRange(root);
      fullRange = range.lower <= range.parts.min && range.upper >= range.parts.max;
      if (fullRange) return;

      root.querySelectorAll('[data-kk-native-range-option]').forEach(function (option) {
        option.checked = false;
      });
      changed = kkSetNativeRangeNoMatch(root, range.lower, range.upper) || changed;
      root.dispatchEvent(new Event('kk:sync-native-range-ui', { bubbles: true }));
    });

    return changed;
  }

  function applyLiveFacetMarkup(instance, markup, expectedQuery, requestId, sessionId) {
    var doc;
    var preview;
    var filterCount;
    var resultCount;
    var freshForm;
    var noMatchResolution;
    var embeddedSearch = isEmbeddedCollectionSearch(instance);
    var form = getModalFilterForm(instance);

    if (
      requestId !== liveFacetRequestId ||
      sessionId !== liveFacetSessionId ||
      !isMobileFilterModalOpen() ||
      !isNativeCollectionLiveFacetInstance(instance) ||
      !form ||
      form !== liveFacetActiveForm ||
      buildLiveFacetUrl(instance) !== expectedQuery
    ) {
      return false;
    }

    try {
      doc = parseCollectionResponseHtml(markup);
    } catch (error) {
      return false;
    }

    preview = doc.querySelector(
      embeddedSearch ?
        '[data-kk-search-facet-preview]' :
        '[data-kk-collection-facet-preview]'
    );
    if (!preview) {
      return false;
    }

    filterCount = parseInt(preview.getAttribute('data-kk-filter-count'), 10);
    resultCount = parseInt(preview.getAttribute(
      embeddedSearch ? 'data-kk-search-count' : 'data-kk-collection-count'
    ), 10);

    if (!Number.isFinite(filterCount) || !Number.isFinite(resultCount)) {
      return false;
    }

    freshForm = preview.querySelector(
      embeddedSearch ? '[data-search-filter-form]' : '[data-filter-form]'
    );

    if (kkHasNativeRangeNoMatch(expectedQuery)) {
      if (freshForm) {
        reconcileLiveFacetOptions(form, freshForm, resultCount === 0, expectedQuery);
        noMatchResolution = kkResolveNativeRangeNoMatches(freshForm, expectedQuery);
      }

      if (noMatchResolution && noMatchResolution.changed) {
        kkApplyNativeRangeResolutions(form, noMatchResolution.resolved);
        instance.kkMobileDeferredDirty = true;
        renderMobileStagedFilters(form);
        window.setTimeout(function () {
          if (isMobileFilterModalOpen() && form.isConnected) {
            queueLiveFacetRefresh(instance);
          }
        }, 0);
        return false;
      }

      applyNativeRangeNoMatchLiveFacetState(form, expectedQuery);
      return true;
    }

    if (resultCount === 0) {
      if (markActiveNativeRangesNoMatch(form)) {
        instance.kkMobileDeferredDirty = true;
        renderMobileStagedFilters(form);
        window.setTimeout(function () {
          if (isMobileFilterModalOpen() && form.isConnected) {
            queueLiveFacetRefresh(instance);
          }
        }, 0);
        return false;
      }

      if (!restoreLastValidLiveFacetState(form)) {
        reconcileLiveFacetOptions(form, null, true);
        repaintNativeRanges(form);
      }
      return false;
    }

    if (filterCount < 1) {
      markLiveFacetStateStale(form, 'limit');
      return false;
    }

    if (!freshForm) {
      markLiveFacetStateStale(form);
      return false;
    }

    updateLiveFacetResultCount(form, resultCount);
    reconcileLiveFacetOptions(form, freshForm, false, expectedQuery);
    reconcileNativeRanges(form, freshForm);
    reconcilePriceRange(form, freshForm);
    repaintNativeRanges(form);
    renderMobileStagedFilters(form);
    if (getFilterUiScope(form)) {
      getFilterUiScope(form).setAttribute(
        'data-kk-live-facets-query',
        expectedQuery
      );
    }
    rememberLastValidLiveFacetState(form, resultCount, freshForm);
    document.dispatchEvent(new CustomEvent('kk:collection-live-facets-updated', {
      detail: {
        count: resultCount,
        url: expectedQuery,
        search: embeddedSearch
      }
    }));

    return true;
  }

  function rememberLiveFacetMarkup(query, markup) {
    if (liveFacetCache.has(query)) {
      liveFacetCache.set(query, markup);
      return;
    }

    liveFacetCache.set(query, markup);
    liveFacetCacheOrder.push(query);

    while (liveFacetCacheOrder.length > LIVE_FACET_CACHE_LIMIT) {
      liveFacetCache.delete(liveFacetCacheOrder.shift());
    }
  }

  function finishLiveFacetRequest(form, requestId, sessionId) {
    if (requestId !== liveFacetRequestId || sessionId !== liveFacetSessionId) {
      return;
    }

    liveFacetController = null;
    liveFacetActiveQuery = '';
    setLiveFacetBusy(form, false);
  }

  function startLiveFacetRequest(instance, query, requestId, sessionId, form) {
    var cachedMarkup = liveFacetCache.get(query);
    var requestQuery = kkNativeRangeRequestUrl(query);

    if (cachedMarkup) {
      applyLiveFacetMarkup(instance, cachedMarkup, query, requestId, sessionId);
      finishLiveFacetRequest(form, requestId, sessionId);
      return;
    }

    liveFacetController = new AbortController();

    fetch(requestQuery, {
      credentials: 'same-origin',
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      signal: liveFacetController.signal
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Collection live facet request failed');
      }
      return response.text();
    }).then(function (markup) {
      var applied;

      if (requestId !== liveFacetRequestId || sessionId !== liveFacetSessionId) {
        return;
      }

      applied = applyLiveFacetMarkup(instance, markup, query, requestId, sessionId);
      if (applied) {
        rememberLiveFacetMarkup(query, markup);
      }
    }).catch(function (error) {
      if (error && error.name === 'AbortError') {
        return;
      }

      if (requestId === liveFacetRequestId && sessionId === liveFacetSessionId) {
        markLiveFacetStateStale(form, 'error');
      }
    }).then(function () {
      finishLiveFacetRequest(form, requestId, sessionId);
    });
  }

  function queueLiveFacetRefresh(instance) {
    var form;
    var query;
    var requestId;
    var sessionId;

    if (
      !instance ||
      !isMobileFilterModalOpen() ||
      !isNativeCollectionLiveFacetInstance(instance)
    ) {
      return;
    }

    form = getModalFilterForm(instance);
    if (!form || !form.querySelector('[data-kk-facet]')) {
      return;
    }

    query = buildLiveFacetUrl(instance);
    if (!query) {
      return;
    }

    if (liveFacetActiveQuery === query && (liveFacetTimer || liveFacetController)) {
      return;
    }

    primeLiveFacetSession(instance);

    window.clearTimeout(liveFacetTimer);
    liveFacetTimer = null;

    if (liveFacetController) {
      liveFacetController.abort();
      liveFacetController = null;
    }

    liveFacetRequestId += 1;
    requestId = liveFacetRequestId;
    sessionId = liveFacetSessionId;
    liveFacetActiveQuery = query;
    liveFacetActiveForm = form;
    setLiveFacetBusy(form, true);

    liveFacetTimer = window.setTimeout(function () {
      liveFacetTimer = null;
      startLiveFacetRequest(instance, query, requestId, sessionId, form);
    }, LIVE_FACET_DEBOUNCE_MS);
  }

  function cancelLiveFacetRefresh() {
    window.clearTimeout(liveFacetTimer);
    liveFacetTimer = null;
    liveFacetRequestId += 1;
    liveFacetSessionId += 1;
    liveFacetSessionOpen = false;
    liveFacetActiveQuery = '';
    liveFacetLastValidSelection = null;
    liveFacetLastValidForm = null;
    liveFacetLastValidCount = null;
    liveFacetPointerTargets.clear();
    liveFacetPointerCounts = new WeakMap();
    liveFacetPendingOrders = new WeakMap();
    liveFacetLatestOrders = new WeakMap();

    if (liveFacetController) {
      liveFacetController.abort();
      liveFacetController = null;
    }

    setLiveFacetBusy(liveFacetActiveForm, false);
    liveFacetActiveForm = null;
  }

  function getQueryStringFromHref(href) {
    try {
      return new URL(href || '', window.location.origin).search.replace(/^\?/, '');
    } catch (error) {
      return '';
    }
  }

  function applyQueryToFilterForm(queryString) {
    var form = document.querySelector('[data-filter-form]');
    var params = new URLSearchParams(queryString || '');
    var appliedTextFields = {};

    if (!form) {
      return false;
    }

    Array.prototype.forEach.call(form.elements, function (field) {
      if (!field.name) {
        return;
      }

      if (field.type === 'checkbox' || field.type === 'radio') {
        field.checked = false;
      } else {
        field.value = '';
      }
    });

    params.forEach(function (value, name) {
      Array.prototype.forEach.call(form.elements, function (field) {
        if (field.name !== name) {
          return;
        }

        if (field.type === 'checkbox' || field.type === 'radio') {
          if (field.value === value) {
            field.checked = true;
          }
        } else if (!appliedTextFields[name]) {
          field.value = value;
          appliedTextFields[name] = true;
        }
      });
    });

    syncDeferredRangeUi(form);

    return true;
  }

  function updateDeferredRemoveUi(link) {
    var currentFilters = link.closest('.productgrid--sidebar-filters--current');
    var listItem = link.closest('li');

    if (!currentFilters) {
      return;
    }

    if (link.closest('.filter-item--grid-simple')) {
      currentFilters.remove();
      return;
    }

    if (listItem) {
      listItem.remove();
    }

    if (!currentFilters.querySelector('li')) {
      currentFilters.remove();
    }
  }

  function markDeferredDirty(instance) {
    if (!instance) {
      return;
    }

    if (instance.timeout !== null) {
      clearTimeout(instance.timeout);
      instance.timeout = null;
    }

    instance.kkMobileDeferredDirty = true;
    activeDeferredInstance = instance;
    renderMobileStagedFilters(getModalFilterForm(instance));

    if (
      isEmbeddedCollectionSearch(instance) &&
      window.kkScopedNativeFacets &&
      typeof window.kkScopedNativeFacets.refresh === 'function'
    ) {
      window.kkScopedNativeFacets.refresh(instance, getModalFilterForm(instance));
    } else {
      queueLiveFacetRefresh(instance);
    }
  }

  function queueDeferredApply(instance) {
    if (!instance || !instance.kkMobileDeferredDirty) {
      return;
    }

    pendingDeferredApplyInstance = instance;
  }

  function flushDeferredApply() {
    var instance = pendingDeferredApplyInstance;

    if (!instance || document.body.classList.contains('modal-visible')) {
      return;
    }

    pendingDeferredApplyInstance = null;

    if (!instance.kkMobileDeferredDirty) {
      return;
    }

    cancelLiveFacetRefresh();

    instance.kkMobileDeferredDirty = false;

    if (typeof instance._fetchResults === 'function') {
      instance.kkUseModalFilterFormForNextFetch = true;

      try {
        instance._fetchResults();
      } finally {
        instance.kkUseModalFilterFormForNextFetch = false;
      }
    }
  }

  function refreshOpenFilterModal(instance) {
    var modalWrapper = instance && instance.modal;
    var vanillaModal = modalWrapper && modalWrapper.modal;
    var modalContent = document.querySelector('[data-modal-container] [data-modal-content]');
    var freshSource = instance && instance.el ? instance.el.querySelector(instance.filterContentSelector) : null;

    if (!modalWrapper || !vanillaModal || !modalContent || !freshSource) {
      if (modalWrapper && modalWrapper.isOpen && modalWrapper.isOpen()) {
        modalWrapper.close();
      }

      return;
    }

    while (modalContent.firstChild) {
      modalContent.removeChild(modalContent.firstChild);
    }

    while (freshSource.firstChild) {
      modalContent.appendChild(freshSource.firstChild);
    }

    vanillaModal.current = freshSource;
    modalWrapper.position();
  }

  function patchStaticCollectionFaceted() {
    var proto = window.bcStaticCollection && window.bcStaticCollection.prototype;
    var originalHandleFilterClick;
    var originalHandleFilterRange;

    if (!proto || proto.kkNativeFilterFetchPatched) {
      return;
    }

    originalHandleFilterClick = proto._handleFilterClick;
    originalHandleFilterRange = proto._handleFilterRange;

    proto._getFilterParams = function () {
      var modalForm = this.kkUseModalFilterFormForNextFetch || isMobileFilterModalOpen() ?
        document.querySelector('[data-modal-container] ' + this.filterFormSelector) :
        null;
      var form = modalForm || (this.el && this.el.querySelector(this.filterFormSelector)) || document.querySelector(this.filterFormSelector);

      if (this.kkUsePendingFilterQueryForHistory && typeof this.kkPendingFilterQueryForHistory === 'string') {
        return this.kkPendingFilterQueryForHistory;
      }

      if (!form) {
        return '';
      }

      return new URLSearchParams(new FormData(form)).toString();
    };

    proto._handleFilterClick = function (targetEl) {
      var filterItem;

      if (isMobileFilterModalOpen()) {
        filterItem = targetEl && targetEl.closest('[data-filter-item]');

        if (filterItem) {
          filterItem.classList.toggle('filter-item--active', Boolean(targetEl.checked));
          filterItem.classList.toggle('filter-item--inactive', !targetEl.checked);
        }

        markDeferredDirty(this);
        return;
      }

      return originalHandleFilterClick.call(this, targetEl);
    };

    proto._handleFilterRange = function () {
      if (isMobileFilterModalOpen()) {
        markDeferredDirty(this);
        return;
      }

      return originalHandleFilterRange.apply(this, arguments);
    };

    proto._fetchResults = function (append, filterParams) {
      var processingType;
      var urlPath;
      var filterQuery;
      var requestFilterQuery;
      var hasNoMatchRange;
      var queryString;
      var url;
      var priceMaxPromise;
      var loadResolvedResponse;

      append = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      filterParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      processingType = append ? 'pagination' : 'filter';
      urlPath = window.location.pathname;
      filterQuery = filterParams === null ? this._getFilterParams() : filterParams;
      hasNoMatchRange = kkHasNativeRangeNoMatch(filterQuery);
      requestFilterQuery = kkStripNativeRangeNoMatches(filterQuery);

      if (hasNoMatchRange) append = false;

      if (!append) {
        this.queryParams.page = 1;
      }

      delete this.queryParams.view;
      this.kkMobileDeferredDirty = false;
      queryString = this._stringifyQueryParams(this.queryParams);
      url = ''.concat(urlPath, '?').concat(queryString, '&').concat(requestFilterQuery);
      priceMaxPromise = !append && window.kkContextualPriceMax ?
        window.kkContextualPriceMax.primeForUrl(url) :
        Promise.resolve(0);

      this._setProcessing(true, processingType);
      this._unbindEvents();

      loadResolvedResponse = function (responses, activeFilterQuery, activeUrl, depth) {
        var doc = parseCollectionResponseHtml(responses[0]);
        var resolution;
        var nextFilterQuery;
        var nextRequestFilterQuery;
        var nextUrl;
        var nextPriceMaxPromise;

        if (!kkHasNativeRangeNoMatch(activeFilterQuery)) {
          return Promise.resolve({
            doc: doc,
            filterQuery: activeFilterQuery,
            maxPriceCents: responses[1],
            url: activeUrl
          });
        }

        resolution = kkResolveNativeRangeNoMatches(doc.body, activeFilterQuery);
        if (!resolution.changed || depth >= 4) {
          kkApplyNativeRangeNoMatchResponse(doc.body, activeFilterQuery);
          return Promise.resolve({
            doc: doc,
            filterQuery: activeFilterQuery,
            maxPriceCents: responses[1],
            url: activeUrl
          });
        }

        nextFilterQuery = resolution.query;
        nextRequestFilterQuery = kkStripNativeRangeNoMatches(nextFilterQuery);
        nextUrl = ''.concat(urlPath, '?').concat(queryString, '&').concat(nextRequestFilterQuery);
        nextPriceMaxPromise = !append && window.kkContextualPriceMax ?
          window.kkContextualPriceMax.primeForUrl(nextUrl) :
          Promise.resolve(0);

        return Promise.all([
          fetch(nextUrl).then(function (response) {
            if (!response.ok) {
              throw new Error('Native collection filtering failed with status ' + response.status);
            }
            return response.text();
          }),
          nextPriceMaxPromise
        ]).then(function (nextResponses) {
          return loadResolvedResponse(nextResponses, nextFilterQuery, nextUrl, depth + 1);
        });
      };

      Promise.all([
        fetch(url).then(function (response) {
          if (!response.ok) {
            throw new Error('Native collection filtering failed with status ' + response.status);
          }

          return response.text();
        }),
        priceMaxPromise
      ]).then(function (responses) {
        return loadResolvedResponse(responses, filterQuery, url, 0);
      }).then(function (payload) {
        var doc = payload.doc;
        var maxPriceCents = payload.maxPriceCents;

        filterQuery = payload.filterQuery;
        url = payload.url;

        if (!append && window.kkContextualPriceMax && maxPriceCents > 0) {
          window.kkContextualPriceMax.applyToScope(doc.body, maxPriceCents, url);
        }

        if (append) {
          this._appendResults(doc.body);
        } else {
          this._replaceResults(doc.body);
        }

        this.kkPendingFilterQueryForHistory = filterQuery;
        this.kkUsePendingFilterQueryForHistory = true;
        this._updateHistory();
        this.kkUsePendingFilterQueryForHistory = false;
        this._bindEvents();
        this._handleViewToggle(null);
        this._setProcessing(false, processingType);

        if (this.modal.isOpen()) {
          if (!append && isMobileFilterModalOpen()) {
            refreshOpenFilterModal(this);
          } else {
            this.modal.close();
          }
        }

        document.dispatchEvent(new CustomEvent('kk:collection-search-complete', {
          detail: {
            source: 'native-collection',
            resultCount: parseInt(
              this.el.querySelector('[data-results-container]') &&
              this.el.querySelector('[data-results-container]').getAttribute('data-product-count'),
              10
            ) || 0
          }
        }));
      }.bind(this)).catch(function (error) {
        console.error(error);
        this.kkUsePendingFilterQueryForHistory = false;
        if (this.processing) {
          this._bindEvents();
          this._setProcessing(false, processingType);
        }
        document.dispatchEvent(new CustomEvent('kk:collection-search-error'));
      }.bind(this));
    };

    proto.kkNativeFilterFetchPatched = true;
  }

  function handleDeferredNativeChange(event) {
    var instance;

    if (!isMobileFilterModalOpen()) {
      return;
    }

    if (event.type === 'keyup' && event.key === 'Tab') {
      return;
    }

    if (!event.target.closest(
      '[data-filter-checkbox], [data-filter-range], [data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]'
    )) {
      return;
    }

    instance = getDeferredInstance();

    if (instance) {
      markDeferredDirty(instance);
    }
  }

  document.addEventListener('change', handleDeferredNativeChange, true);
  document.addEventListener('keyup', handleDeferredNativeChange, true);

  function primeLiveFacetSessionFromInteraction(event) {
    if (
      isMobileFilterModalOpen() &&
      event.target &&
      event.target.closest &&
      event.target.closest(
        '[data-filter-checkbox], [data-filter-range], [data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]'
      )
    ) {
      primeLiveFacetSession();
    }
  }

  document.addEventListener('pointerdown', primeLiveFacetSessionFromInteraction, true);
  document.addEventListener('pointerdown', trackLiveFacetPointer, true);
  document.addEventListener('pointerup', releaseLiveFacetPointer, true);
  document.addEventListener('pointercancel', releaseLiveFacetPointer, true);
  document.addEventListener('keydown', primeLiveFacetSessionFromInteraction, true);

  document.addEventListener('click', function (event) {
    var instance;
    var removeLink;
    var stagedRemove;
    var insideModal = event.target.closest('[data-modal-inner]');

    if (!isMobileFilterModalOpen()) {
      return;
    }

    stagedRemove = event.target.closest('[data-kk-staged-filter-remove]');

    if (stagedRemove) {
      event.preventDefault();
      window.setTimeout(function () {
        if (stagedRemove.isConnected) {
          removeMobileStagedFilter(stagedRemove);
        }
      }, 0);
      return;
    }

    removeLink = event.target.closest('[data-filter-remove]');

    if (removeLink) {
      instance = getDeferredInstance();

      if (!instance) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();

      applyQueryToFilterForm(getQueryStringFromHref(removeLink.getAttribute('href')));
      updateDeferredRemoveUi(removeLink);
      markDeferredDirty(instance);
      return;
    }

    if (event.target.closest('[data-modal-close]') || !insideModal) {
      cancelLiveFacetRefresh();
      queueDeferredApply(getDeferredInstance());
      window.setTimeout(flushDeferredApply, 0);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isMobileFilterModalOpen()) {
      cancelLiveFacetRefresh();
      queueDeferredApply(getDeferredInstance());
      window.setTimeout(flushDeferredApply, 0);
    }
  }, true);

  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (isMobileFilterModalOpen() && !liveFacetSessionOpen) {
        window.setTimeout(function () {
          primeLiveFacetSession();
        }, 0);
      } else if (!document.body.classList.contains('modal-visible') && liveFacetSessionOpen) {
        cancelLiveFacetRefresh();
      }
      flushDeferredApply();
    }).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  document.addEventListener('kk:close-productgrid-filters', cancelLiveFacetRefresh);
  window.addEventListener('pagehide', cancelLiveFacetRefresh);
  window.addEventListener('popstate', cancelLiveFacetRefresh);
  window.addEventListener('resize', syncFacetOptionsForBreakpoint);

  window.kkNativeFacetUi = {
    captureScrollState: captureLiveFacetScrollState,
    reconcileOptions: reconcileLiveFacetOptions,
    reconcileNativeRanges: reconcileNativeRanges,
    reconcilePriceRange: reconcilePriceRange,
    repaintNativeRanges: repaintNativeRanges,
    renderMobileStagedFilters: renderMobileStagedFilters,
    restoreScrollState: restoreLiveFacetScrollState,
    setBusy: setLiveFacetBusy,
    updateResultCount: updateLiveFacetResultCount
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      patchStaticCollectionFaceted();
      primeLiveFacetSession();
    });
  } else {
    patchStaticCollectionFaceted();
    primeLiveFacetSession();
  }
}());

(function () {
  var SCOPED_INDEX_VIEW = 'kk-index';
  var SCOPED_CARD_VIEW = '_ajax-search';
  var SCOPED_INDEX_PAGE_SIZE = 250;
  var SCOPED_FETCH_CONCURRENCY = 3;
  var SCOPED_CACHE_LIMIT = 8;
  var SEARCH_PAGINATION = 'click_to_load';
  var scopedSearchStates = new WeakMap();
  var SCOPED_FACET_KEYS = [
    'vendor',
    'tag',
    'my_fields.muovi',
    'custom.profile',
    'my_fields.kunto',
    'my_fields.paino',
    'shopify.color-pattern',
    'custom.nopeus',
    'custom.liito',
    'custom.vakaus',
    'custom.feidi'
  ];
  var SCOPED_COUNT_SORT_FACETS = {
    vendor: true,
    'my_fields.muovi': true,
    'shopify.color-pattern': true
  };
  var SCOPED_VENDOR_GROUP_LABELS = {
    streamline: 'Streamline Discs',
    streamlinediscs: 'Streamline Discs',
    latitude64: 'Latitude 64\u00b0',
    mvp: 'MVP Disc Sports',
    mvpdiscsports: 'MVP Disc Sports'
  };
  var SCOPED_COLOR_GROUPS = [
    { key: 'beige', aliases: ['beige'] },
    { key: 'gray', aliases: ['harmaa', 'harmaat', 'siniharmaa', 'gray', 'grey', 'gra', 'graa', 'blue gray', 'bluegray'] },
    { key: 'silver', aliases: ['hopea', 'silver'] },
    { key: 'yellow', aliases: ['keltainen', 'yellow', 'gul'] },
    { key: 'gold', aliases: ['kulta', 'gold', 'guld', 'oro'] },
    { key: 'transparent', aliases: ['lapinakyva', 'transparent', 'transparentti', 'clear', 'kirkas', 'genomskinlig'] },
    {
      key: 'multicolor',
      aliases: [
        'elain', 'animal', 'animal print', 'geometrinen', 'geometric', 'monivarinen',
        'multicolor', 'multi color', 'multi', 'flerfargad', 'naamiointi', 'camouflage',
        'camo', 'raidallinen', 'striped', 'stripe', 'raidat', 'kuvio', 'pattern',
        'print', 'random', 'sateenkaari', 'rainbow', 'tie dye', 'tiedye', 'marmori',
        'marble', 'swirl', 'splatter'
      ]
    },
    { key: 'black', aliases: ['musta', 'black', 'svart'] },
    { key: 'orange', aliases: ['oranssi', 'orange'] },
    { key: 'pink', aliases: ['pinkki', 'pink', 'vaaleanpunainen', 'rosa', 'light pink', 'lightpink'] },
    { key: 'bronze', aliases: ['pronssi', 'bronze', 'brons'] },
    { key: 'red', aliases: ['punainen', 'red', 'rod', 'punaviini', 'burgundy', 'wine red', 'winered'] },
    { key: 'brown', aliases: ['ruskea', 'brown', 'brun'] },
    { key: 'rose_gold', aliases: ['ruusukulta', 'rose gold', 'rosegold', 'roseguld'] },
    {
      key: 'blue',
      aliases: ['sininen', 'siniharmaa', 'tummansininen', 'turkoosi', 'turquoise', 'turkos', 'blue', 'dark blue', 'darkblue', 'navy', 'bla', 'blue gray', 'bluegray']
    },
    { key: 'white', aliases: ['valkoinen', 'white', 'vit', 'glow'] },
    { key: 'green', aliases: ['vihrea', 'green', 'gron'] },
    { key: 'violet', aliases: ['violetti', 'violet', 'violett', 'purple', 'lila'] }
  ];

  function decodeQueryValue(value) {
    try {
      return decodeURIComponent(String(value || '').replace(/\+/g, '%20'));
    } catch (error) {
      return String(value || '').replace(/\+/g, ' ');
    }
  }

  function trimSearchTerm(value) {
    return decodeQueryValue(value).trim();
  }

  function encodeQueryValue(value) {
    var params = new URLSearchParams();

    params.set('q', value);

    return params.toString().replace(/^q=/, '');
  }

  function isSearchMode(instance) {
    return Boolean(instance && instance.queryParams && trimSearchTerm(instance.queryParams.q));
  }

  function findCollectionInstance() {
    var instances = window.bcSections && window.bcSections.instances;
    var found = null;

    if (!instances || !window.bcStaticCollection) {
      return null;
    }

    Object.keys(instances).some(function (key) {
      var instance = instances[key];

      if (instance instanceof window.bcStaticCollection) {
        found = instance;
        return true;
      }

      return false;
    });

    return found;
  }

  function setSearchPagination(instance) {
    if (!instance) {
      return;
    }

    if (!instance.kkOriginalPagination) {
      instance.kkOriginalPagination = instance.pagination;
    }

    instance.pagination = SEARCH_PAGINATION;
  }

  function restorePagination(instance) {
    if (instance && instance.kkOriginalPagination) {
      instance.pagination = instance.kkOriginalPagination;
    }
  }

  function toNumber(value, fallback) {
    var parsed = parseFloat(String(value || '').replace(',', '.'));

    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function isDefaultPriceParam(instance, name, value) {
    var priceRange = instance && instance.el && instance.el.querySelector ?
      instance.el.querySelector('[data-kk-price-range]') :
      null;
    var min;
    var max;
    var numericValue;

    if (!priceRange || (name !== 'filter.v.price.gte' && name !== 'filter.v.price.lte')) {
      return false;
    }

    if (String(value || '') === '') {
      return true;
    }

    min = toNumber(priceRange.dataset.kkRangeMin, 0);
    max = toNumber(priceRange.dataset.kkRangeMax, null);
    numericValue = toNumber(value, null);

    if (numericValue === null || max === null) {
      return false;
    }

    if (name === 'filter.v.price.gte') {
      return numericValue <= min || Math.abs(numericValue - min) < 0.0001;
    }

    return numericValue >= max || Math.abs(numericValue - max) < 0.0001;
  }

  function sanitizeFilterQuery(instance, filterParams) {
    var params = new URLSearchParams(filterParams || '');
    var remaining = new URLSearchParams();

    delete instance.queryParams.view;

    params.forEach(function (value, name) {
      if (isDefaultPriceParam(instance, name, value)) {
        return;
      }

      if (name === 'q') {
        if (value) {
          instance.queryParams.q = encodeQueryValue(value);
        } else {
          delete instance.queryParams.q;
        }
        return;
      }

      if (name === 'sort_by') {
        if (value) {
          instance.queryParams.sort_by = value;
        } else {
          delete instance.queryParams.sort_by;
        }
        return;
      }

      if (name === 'page') {
        instance.queryParams.page = parseInt(value, 10) || 1;
        return;
      }

      if (name === 'grid_list') {
        if (value) {
          instance.queryParams.grid_list = value;
        }
        return;
      }

      if (name === 'type' || name === 'section_id' || name === 'sections' || name === 'view') {
        return;
      }

      remaining.append(name, value);
    });

    return remaining.toString();
  }

  function rememberScopedCache(cache, key, value) {
    if (cache.has(key)) {
      cache.delete(key);
    }

    cache.set(key, value);

    while (cache.size > SCOPED_CACHE_LIMIT) {
      cache.delete(cache.keys().next().value);
    }
  }

  function getScopedSearchRoot(instance) {
    return instance && instance.el && instance.el.querySelector ?
      instance.el.querySelector('[data-kk-collection-search]') :
      null;
  }

  function getScopedSearchOuter(instance) {
    var root = getScopedSearchRoot(instance);

    return root && root.closest ? root.closest('.productgrid--outer') : null;
  }

  function getScopedSearchState(instance) {
    var root;
    var outer;
    var grid;
    var pagination;
    var state;

    if (scopedSearchStates.has(instance)) {
      return scopedSearchStates.get(instance);
    }

    root = getScopedSearchRoot(instance);
    outer = getScopedSearchOuter(instance);
    grid = instance && instance.el ? instance.el.querySelector(instance.productGridSelector) : null;
    pagination = instance && instance.el ? instance.el.querySelector(instance.paginationWrapperSelector) : null;
    state = {
      root: root,
      outer: outer,
      requestId: 0,
      controller: null,
      baseProducts: null,
      activeQuery: '',
      lastFacetSnapshot: null,
      mobileFacetTimer: null,
      mobileFacetGeneration: 0,
      facetResizeTimer: null,
      indexCache: new Map(),
      cardCache: new Map(),
      gridClassName: grid ? grid.className : 'productgrid--items',
      paginationClassName: 'pagination__wrapper click-to-load',
      paginationTemplate: pagination && pagination.querySelector('[data-click-to-load]') ? pagination.innerHTML : '',
      productsPerPage: Math.max(1, parseInt(outer && outer.getAttribute('data-kk-products-per-page'), 10) || 36),
      loadMoreText: root && root.getAttribute('data-kk-collection-search-load-more') || 'Load more products',
      noResultsTemplate: root && root.getAttribute('data-kk-collection-search-no-results') || 'No products for “[[terms]]”.'
    };

    scopedSearchStates.set(instance, state);
    return state;
  }

  function cancelScopedSearch(instance) {
    var state = scopedSearchStates.get(instance);

    if (!state) return;

    state.requestId += 1;
    state.mobileFacetGeneration += 1;
    window.clearTimeout(state.mobileFacetTimer);
    state.mobileFacetTimer = null;
    window.clearTimeout(state.facetResizeTimer);
    state.facetResizeTimer = null;
    if (state.controller) {
      state.controller.abort();
      state.controller = null;
    }
  }

  function restoreScopedResponse(instance) {
    var response = instance && instance.el ? instance.el.querySelector(instance.responseContainerSelector) : null;

    if (!response) return;

    response.classList.remove('kk-collection-search-active');
    response.querySelectorAll('.kk-collection-search-hidden').forEach(function (node) {
      node.classList.remove('kk-collection-search-hidden');
    });
    response.querySelectorAll('[data-kk-scoped-pagination]').forEach(function (node) {
      node.remove();
    });
  }

  function activateScopedResponse(instance) {
    var response = instance && instance.el ? instance.el.querySelector(instance.responseContainerSelector) : null;

    if (!response) return;

    response.classList.add('kk-collection-search-active');
    response.querySelectorAll(instance.paginationWrapperSelector).forEach(function (node) {
      if (!node.hasAttribute('data-kk-scoped-pagination')) {
        node.classList.add('kk-collection-search-hidden');
      }
    });
  }

  function buildScopedViewUrl(instance, filterQuery, view, page) {
    var url = new URL(window.location.pathname, window.location.origin);
    var sortBy = trimSearchTerm(instance && instance.queryParams && instance.queryParams.sort_by);
    var params = new URLSearchParams(filterQuery || '');

    params.delete('q');
    params.delete('page');
    params.delete('view');
    params.delete('section_id');
    params.delete('sections');
    params.delete('type');
    params.delete('grid_list');

    if (sortBy && sortBy !== 'relevance') {
      params.set('sort_by', sortBy);
    } else {
      params.delete('sort_by');
    }

    params.set('view', view);
    params.set('page', String(page));
    url.search = params.toString();

    return url.pathname + url.search;
  }

  function getScopedContextKey(instance, filterQuery) {
    var url = new URL(buildScopedViewUrl(instance, filterQuery, SCOPED_INDEX_VIEW, 1), window.location.origin);

    url.searchParams.delete('view');
    url.searchParams.delete('page');
    url.searchParams.sort();
    return url.pathname + '?' + url.searchParams.toString();
  }

  function normalizeScopedProduct(raw) {
    return {
      sourceOrder: Number(raw && raw.so) || 0,
      handle: String(raw && raw.h || ''),
      title: String(raw && raw.t || ''),
      vendor: String(raw && raw.v || ''),
      tags: raw && Array.isArray(raw.tg) ? raw.tg : [],
      createdAtTimestamp: Number(raw && raw.cts) || 0,
      priceMin: Number(raw && raw.pmin) || 0,
      priceMax: Number(raw && (raw.pmax == null ? raw.pmin : raw.pmax)) || 0,
      muovi: raw && raw.mu,
      kunto: raw && raw.ku,
      paino: raw && raw.we,
      colorPattern: raw && raw.co,
      profile: raw && raw.pr,
      nopeus: raw && raw.sp,
      liito: raw && raw.gl,
      vakaus: raw && raw.tu,
      feidi: raw && raw.fa
    };
  }

  function scopedValueText(value) {
    if (value == null) return '';
    if (Array.isArray(value)) return value.map(scopedValueText).join(' ');
    if (typeof value === 'object') {
      return Object.keys(value).map(function (key) {
        return scopedValueText(value[key]);
      }).join(' ');
    }
    return String(value);
  }

  function matchesScopedQuery(product, query) {
    var parts = String(query || '').toLowerCase().split(/\s+/).filter(Boolean);
    var haystack;

    if (!parts.length) return true;

    haystack = [
      product.title,
      product.handle,
      product.vendor,
      product.tags.join(' '),
      scopedValueText(product.muovi),
      scopedValueText(product.kunto),
      scopedValueText(product.colorPattern),
      scopedValueText(product.profile)
    ].join(' ').toLowerCase();

    return parts.every(function (part) {
      return haystack.indexOf(part) !== -1;
    });
  }

  function normalizeScopedFacetText(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function normalizeScopedAlias(value) {
    var normalized = normalizeScopedFacetText(value);

    if (typeof normalized.normalize === 'function') {
      normalized = normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return normalized.replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
  }

  function canonicalizeScopedVendor(value) {
    var vendor = String(value == null ? '' : value).trim();
    var key = normalizeScopedAlias(vendor).replace(/\s+/g, '');

    return normalizeScopedFacetText(
      Object.prototype.hasOwnProperty.call(SCOPED_VENDOR_GROUP_LABELS, key) ?
        SCOPED_VENDOR_GROUP_LABELS[key] :
        vendor
    );
  }

  function scopedMetafieldValues(value) {
    var parsed;
    var result = [];

    if (value == null || value === '') return result;

    if (Array.isArray(value)) {
      value.forEach(function (item) {
        scopedMetafieldValues(item).forEach(function (entry) { result.push(entry); });
      });
      return result;
    }

    if (typeof value === 'object') {
      Object.keys(value).forEach(function (key) {
        scopedMetafieldValues(value[key]).forEach(function (entry) { result.push(entry); });
      });
      return result;
    }

    if (typeof value === 'string') {
      try {
        parsed = JSON.parse(value);
        if (Array.isArray(parsed) || (parsed && typeof parsed === 'object')) {
          return scopedMetafieldValues(parsed);
        }
        if (parsed != null && typeof parsed !== 'object') {
          return [String(parsed)];
        }
      } catch (error) {
        // Single-line metafields are plain strings.
      }
    }

    return [String(value)];
  }

  function scopedColorKeys(value) {
    var keys = [];
    var seen = Object.create(null);

    scopedMetafieldValues(value).forEach(function (entry) {
      String(entry || '').split(/\s*,\s*/).forEach(function (part) {
        var normalized = normalizeScopedAlias(part);
        var compact = normalized.replace(/\s+/g, '');
        var matched = false;

        if (!normalized) return;

        SCOPED_COLOR_GROUPS.forEach(function (group) {
          var groupMatches = group.aliases.some(function (alias) {
            var normalizedAlias = normalizeScopedAlias(alias);

            return normalized === normalizedAlias || compact === normalizedAlias.replace(/\s+/g, '');
          });

          if (groupMatches && !seen[group.key]) {
            seen[group.key] = true;
            keys.push(group.key);
            matched = true;
          }
        });

        if (!matched && !seen['raw:' + normalized]) {
          seen['raw:' + normalized] = true;
          keys.push('raw:' + normalized);
        }
      });
    });

    return keys;
  }

  function scopedFacetKeyFromName(name) {
    var key;

    if (name === 'filter.p.vendor') return 'vendor';
    if (name === 'filter.p.tag') return 'tag';
    if (String(name || '').indexOf('filter.p.m.') !== 0) return '';

    key = String(name).slice('filter.p.m.'.length);
    return SCOPED_FACET_KEYS.indexOf(key) > -1 ? key : '';
  }

  function isScopedNumericFacet(key) {
    return key === 'my_fields.paino' ||
      key === 'custom.nopeus' ||
      key === 'custom.liito' ||
      key === 'custom.vakaus' ||
      key === 'custom.feidi';
  }

  function scopedPrimitiveKey(value, facetKey) {
    var numeric;

    if (facetKey === 'vendor') return canonicalizeScopedVendor(value);
    if (isScopedNumericFacet(facetKey)) {
      numeric = toNumber(value, null);
      return numeric === null ? '' : String(numeric);
    }

    return normalizeScopedFacetText(value);
  }

  function uniqueScopedValues(values) {
    var seen = Object.create(null);

    return values.filter(function (value) {
      var key = String(value || '');

      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function scopedProductFacetValues(product, facetKey) {
    var raw;

    if (facetKey === 'vendor') return [canonicalizeScopedVendor(product.vendor)].filter(Boolean);
    if (facetKey === 'tag') {
      return uniqueScopedValues((product.tags || []).map(function (value) {
        return scopedPrimitiveKey(value, facetKey);
      }));
    }
    if (facetKey === 'shopify.color-pattern') return scopedColorKeys(product.colorPattern);

    if (facetKey === 'my_fields.muovi') raw = product.muovi;
    else if (facetKey === 'custom.profile') raw = product.profile;
    else if (facetKey === 'my_fields.kunto') raw = product.kunto;
    else if (facetKey === 'my_fields.paino') raw = product.paino;
    else if (facetKey === 'custom.nopeus') raw = product.nopeus;
    else if (facetKey === 'custom.liito') raw = product.liito;
    else if (facetKey === 'custom.vakaus') raw = product.vakaus;
    else if (facetKey === 'custom.feidi') raw = product.feidi;
    else return [];

    return uniqueScopedValues(scopedMetafieldValues(raw).map(function (value) {
      return scopedPrimitiveKey(value, facetKey);
    }));
  }

  function scopedInputValueKeys(input, facetKey) {
    var item;
    var label;

    if (!input) return [];

    if (facetKey === 'shopify.color-pattern') {
      item = input.closest('[data-filter-item]');
      label = item && item.querySelector('.kk-facet__value');
      return scopedColorKeys(label ? label.textContent : input.value);
    }

    if (isScopedNumericFacet(facetKey) && input.hasAttribute('data-kk-range-value')) {
      return [scopedPrimitiveKey(input.getAttribute('data-kk-range-value'), facetKey)].filter(Boolean);
    }

    return [scopedPrimitiveKey(input.value, facetKey)].filter(Boolean);
  }

  function getScopedFilterForm(instance, preferredForm) {
    var selector = instance && instance.filterFormSelector ? instance.filterFormSelector : '[data-filter-form]';
    var modalForm;

    if (preferredForm && preferredForm.isConnected) return preferredForm;

    modalForm = document.querySelector('[data-modal-container].modal--productgrid-filters ' + selector);
    if (modalForm) return modalForm;

    return instance && instance.el ? instance.el.querySelector(selector) : null;
  }

  function buildScopedFilterState(instance, form, filterQuery) {
    var grouped = new Map();
    var params = new URLSearchParams(filterQuery || '');
    var priceMin = toNumber(params.get('filter.v.price.gte'), null);
    var priceMax = toNumber(params.get('filter.v.price.lte'), null);

    function addValue(facetKey, value) {
      if (!facetKey || !value) return;
      if (!grouped.has(facetKey)) grouped.set(facetKey, new Set());
      grouped.get(facetKey).add(value);
    }

    params.forEach(function (value, name) {
      var facetKey = scopedFacetKeyFromName(name);
      var matchingInput = null;

      if (!facetKey) return;

      if (form) {
        Array.prototype.some.call(form.querySelectorAll('[data-filter-checkbox][name]'), function (input) {
          if (input.name === name && input.value === value) {
            matchingInput = input;
            return true;
          }
          return false;
        });
      }

      if (matchingInput) {
        scopedInputValueKeys(matchingInput, facetKey).forEach(function (inputValue) {
          addValue(facetKey, inputValue);
        });
      } else if (facetKey === 'shopify.color-pattern') {
        scopedColorKeys(value).forEach(function (colorKey) { addValue(facetKey, colorKey); });
      } else {
        addValue(facetKey, scopedPrimitiveKey(value, facetKey));
      }
    });

    return {
      grouped: grouped,
      priceMin: priceMin,
      priceMax: priceMax,
      forceNoMatch: kkHasNativeRangeNoMatch(filterQuery)
    };
  }

  function scopedProductMatchesPrice(product, filterState) {
    var min = filterState.priceMin === null ? 0 : filterState.priceMin;
    var max = filterState.priceMax === null ? Number.POSITIVE_INFINITY : filterState.priceMax;
    var productMin = product.priceMin / 100;
    var productMax = product.priceMax / 100;

    return productMax >= min && productMin <= max;
  }

  function buildScopedFacetSnapshot(products, query, filterState) {
    var counts = new Map();
    var groupedEntries = Array.from(filterState.grouped.entries());
    var resultProducts = [];
    var priceMin = null;
    var priceMax = 0;

    SCOPED_FACET_KEYS.forEach(function (key) { counts.set(key, new Map()); });

    products.forEach(function (product) {
      var unmatchedCount = 0;
      var unmatchedFacetKey = '';
      var priceMatches;

      if (!matchesScopedQuery(product, query)) return;

      groupedEntries.forEach(function (entry) {
        var selected = entry[1];
        var matches = scopedProductFacetValues(product, entry[0]).some(function (value) {
          return selected.has(value);
        });

        if (!matches) {
          unmatchedCount += 1;
          unmatchedFacetKey = entry[0];
        }
      });

      if (unmatchedCount === 0) {
        if (product.priceMin > 0) {
          priceMin = priceMin === null ? product.priceMin / 100 : Math.min(priceMin, product.priceMin / 100);
        }
        priceMax = Math.max(priceMax, product.priceMax / 100);
      }

      priceMatches = scopedProductMatchesPrice(product, filterState);
      if (priceMatches && unmatchedCount === 0) resultProducts.push(product);
      if (!priceMatches) return;

      SCOPED_FACET_KEYS.forEach(function (facetKey) {
        var facetCounts;

        if (unmatchedCount > 1 || (unmatchedCount === 1 && unmatchedFacetKey !== facetKey)) return;

        facetCounts = counts.get(facetKey);
        scopedProductFacetValues(product, facetKey).forEach(function (value) {
          facetCounts.set(value, (facetCounts.get(value) || 0) + 1);
        });
      });
    });

    if (filterState.forceNoMatch) {
      resultProducts = [];
    }

    return {
      facetCounts: counts,
      priceMin: priceMin,
      priceMax: priceMax,
      resultProducts: resultProducts
    };
  }

  function scopedCountForInput(snapshot, input, facetKey) {
    var facetCounts = snapshot.facetCounts.get(facetKey);
    var count = 0;

    if (!facetCounts) return 0;

    scopedInputValueKeys(input, facetKey).forEach(function (value) {
      count = Math.max(count, facetCounts.get(value) || 0);
    });

    return count;
  }

  function rememberScopedFacetOrder(form) {
    if (!form) return;

    form.querySelectorAll('[data-kk-filter-list]').forEach(function (list) {
      var index = 0;

      Array.prototype.forEach.call(list.children, function (item) {
        if (!item.matches || !item.matches('[data-kk-filter-option]')) return;
        if (!item.hasAttribute('data-kk-scoped-base-order')) {
          item.setAttribute('data-kk-scoped-base-order', String(index));
        }
        index += 1;
      });
    });
  }

  function formatScopedRangeBound(root, value) {
    var unit = root && root.getAttribute('data-kk-range-unit') || '';

    return String(value) + (unit ? ' ' + unit : '');
  }

  function updateScopedFreshRanges(freshForm, snapshot) {
    freshForm.querySelectorAll('[data-kk-native-range]').forEach(function (root) {
      var values = [];
      var firstInput = root.querySelector('[data-kk-native-range-option][name]');
      var facetKey = firstInput ? scopedFacetKeyFromName(firstInput.name) : '';
      var min;
      var max;
      var bounds;

      root.querySelectorAll('[data-kk-native-range-option][name]').forEach(function (input) {
        var count = scopedCountForInput(snapshot, input, facetKey);
        var value = toNumber(input.getAttribute('data-kk-range-value'), null);

        input.disabled = !input.checked && count === 0;
        if (value !== null && (count > 0 || input.checked)) values.push(value);
      });

      if (!values.length) return;

      min = Math.floor(Math.min.apply(Math, values));
      max = Math.ceil(Math.max.apply(Math, values));
      root.setAttribute('data-kk-range-min', String(min));
      root.setAttribute('data-kk-range-max', String(max));
      root.querySelectorAll(
        '[data-kk-range-min-input], [data-kk-range-max-input], [data-kk-range-lower], [data-kk-range-upper]'
      ).forEach(function (input) {
        input.setAttribute('min', String(min));
        input.setAttribute('max', String(max));
      });
      bounds = root.querySelectorAll('.kk-range-filter__bounds span');
      if (bounds[0]) bounds[0].textContent = formatScopedRangeBound(root, min);
      if (bounds[1]) bounds[1].textContent = formatScopedRangeBound(root, max);
    });

    freshForm.querySelectorAll('[data-kk-price-range]').forEach(function (root) {
      var min = 0;
      var max = Math.max(0, Math.ceil(snapshot.priceMax || 0));
      var bounds = root.querySelectorAll('.kk-range-filter__bounds span');
      var maxInput = root.querySelector('[data-kk-range-max-input]');

      root.setAttribute('data-kk-range-min', String(min));
      root.setAttribute('data-kk-range-max', String(max));
      root.querySelectorAll(
        '[data-kk-range-min-input], [data-kk-range-max-input], [data-kk-range-lower], [data-kk-range-upper]'
      ).forEach(function (input) {
        input.setAttribute('min', String(min));
        input.setAttribute('max', String(max));
      });
      if (maxInput) maxInput.setAttribute('placeholder', String(max));
      if (bounds[0]) bounds[0].textContent = String(min);
      if (bounds[1]) bounds[1].textContent = String(max);
    });
  }

  function buildScopedFreshFacetForm(form, snapshot) {
    var freshForm;

    rememberScopedFacetOrder(form);
    freshForm = form.cloneNode(true);

    freshForm.querySelectorAll('[data-kk-filter-option] [data-filter-checkbox][name]').forEach(function (input) {
      var facetKey = scopedFacetKeyFromName(input.name);
      var count = scopedCountForInput(snapshot, input, facetKey);
      var item = input.closest('[data-filter-item]');
      var label = item && item.querySelector('[data-filter-label]');
      var countNode = item && item.querySelector('.kk-facet__count');

      input.disabled = !input.checked && count === 0;
      if (item) {
        item.setAttribute('data-kk-scoped-count', String(count));
        item.classList.toggle('filter-item--disabled', input.disabled);
        item.classList.toggle('filter-item--active', input.checked);
        item.classList.toggle('filter-item--inactive', !input.checked);
      }
      if (label) label.classList.toggle('filter-item__label--disabled', input.disabled);
      if (countNode) countNode.textContent = '(' + count + ')';
    });

    freshForm.querySelectorAll('[data-kk-filter-list]').forEach(function (list) {
      var firstInput = list.querySelector('[data-kk-filter-option] [data-filter-checkbox][name]');
      var facetKey = firstInput ? scopedFacetKeyFromName(firstInput.name) : '';
      var toggleItem = list.querySelector('.filter-item--toggle-more');
      var options;

      if (!SCOPED_COUNT_SORT_FACETS[facetKey]) return;

      options = Array.prototype.filter.call(list.children, function (item) {
        return item.matches && item.matches('[data-kk-filter-option]');
      });
      options.sort(function (a, b) {
        var aCount = parseInt(a.getAttribute('data-kk-scoped-count'), 10) || 0;
        var bCount = parseInt(b.getAttribute('data-kk-scoped-count'), 10) || 0;
        var aOrder = parseInt(a.getAttribute('data-kk-scoped-base-order'), 10) || 0;
        var bOrder = parseInt(b.getAttribute('data-kk-scoped-base-order'), 10) || 0;

        return bCount - aCount || aOrder - bOrder;
      });
      options.forEach(function (item) { list.insertBefore(item, toggleItem || null); });
    });

    updateScopedFreshRanges(freshForm, snapshot);
    return freshForm;
  }

  function isScopedMobileViewport() {
    return window.matchMedia ? window.matchMedia('(max-width: 859px)').matches : window.innerWidth < 860;
  }

  function applyScopedListPresentation(instance, form) {
    var outer = getScopedSearchOuter(instance);
    var desktopLimit = Math.max(1, parseInt(outer && outer.getAttribute('data-kk-filter-limit'), 10) || 5);

    form.querySelectorAll('[data-kk-filter-list]').forEach(function (list) {
      var search = list.closest('[data-kk-facet]') && list.closest('[data-kk-facet]').querySelector('[data-kk-filter-search]');
      var term = search ? search.value.trim() : '';
      var toggle = list.querySelector('[data-filter-toggle]');
      var toggleItem = toggle && toggle.closest('.filter-item');
      var expanded = Boolean(toggle && toggle.getAttribute('data-filter-toggle') === 'true');
      var limit = isScopedMobileViewport() ?
        Math.max(1, parseInt(list.getAttribute('data-kk-mobile-filter-limit'), 10) || 5) :
        desktopLimit;
      var options = Array.prototype.filter.call(list.children, function (item) {
        return item.matches && item.matches('[data-kk-filter-option]');
      });
      var eligible = options.filter(function (item) {
        var input = item.querySelector('[data-filter-checkbox]');
        return Boolean(input && (input.checked || !input.disabled));
      });
      var defaultVisible = new Set();
      var hasOverflow;

      eligible.forEach(function (item) {
        var input = item.querySelector('[data-filter-checkbox]');
        if (input && input.checked) defaultVisible.add(item);
      });
      eligible.forEach(function (item) {
        if (defaultVisible.size < limit) defaultVisible.add(item);
      });

      options.forEach(function (item) {
        var input = item.querySelector('[data-filter-checkbox]');
        var zero = Boolean(input && !input.checked && input.disabled);
        var hiddenByDefault = !zero && !defaultVisible.has(item);

        item.toggleAttribute('data-kk-scoped-zero-option', zero);
        item.toggleAttribute('data-hidden-default', hiddenByDefault);
        item.classList.toggle('filter-item--hidden', !term && hiddenByDefault && !expanded);
        item.hidden = zero;
      });

      hasOverflow = eligible.some(function (item) { return !defaultVisible.has(item); });
      if (!hasOverflow && toggle) {
        expanded = false;
        toggle.setAttribute('data-filter-toggle', 'false');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent = toggle.getAttribute('data-kk-see-more-text') || 'See more';
        list.classList.remove('kk-facet__list--expanded');
      }
      if (toggleItem) {
        toggleItem.toggleAttribute('data-kk-no-eligible-overflow', !hasOverflow);
        toggleItem.hidden = Boolean(term) || !hasOverflow;
      }

      if (search) {
        search.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }

  function applyScopedFacetSnapshot(instance, form, snapshot, signature) {
    var ui = window.kkNativeFacetUi;
    var freshForm;
    var scrollState;

    if (!form || !form.isConnected || !snapshot) return false;

    freshForm = buildScopedFreshFacetForm(form, snapshot);
    scrollState = ui && ui.captureScrollState ? ui.captureScrollState(form) : null;

    if (ui && ui.reconcileOptions) {
      ui.reconcileOptions(form, freshForm, false, '');
      ui.reconcileNativeRanges(form, freshForm);
      ui.reconcilePriceRange(form, freshForm);
      ui.repaintNativeRanges(form);
    }

    applyScopedListPresentation(instance, form);

    if (ui && ui.updateResultCount) ui.updateResultCount(form, snapshot.resultProducts.length);
    if (ui && ui.renderMobileStagedFilters) ui.renderMobileStagedFilters(form);
    if (ui && ui.restoreScrollState) ui.restoreScrollState(scrollState);

    document.dispatchEvent(new CustomEvent('kk:collection-live-facets-updated', {
      detail: {
        count: snapshot.resultProducts.length,
        url: signature || '',
        search: true
      }
    }));
    return true;
  }

  function refreshScopedMobileFacets(instance, preferredForm) {
    var state = scopedSearchStates.get(instance);
    var form = getScopedFilterForm(instance, preferredForm);
    var ui = window.kkNativeFacetUi;
    var generation;

    if (!state || !state.baseProducts || !isSearchMode(instance) || !form) return false;

    state.mobileFacetGeneration += 1;
    generation = state.mobileFacetGeneration;
    window.clearTimeout(state.mobileFacetTimer);
    if (ui && ui.setBusy) ui.setBusy(form, true);

    state.mobileFacetTimer = window.setTimeout(function () {
      var filterQuery;
      var filterState;
      var snapshot;
      var freshForm;
      var noMatchResolution;

      state.mobileFacetTimer = null;
      if (generation !== state.mobileFacetGeneration || !isSearchMode(instance) || !form.isConnected) return;

      filterQuery = new URLSearchParams(new FormData(form)).toString();
      filterState = buildScopedFilterState(instance, form, filterQuery);
      snapshot = buildScopedFacetSnapshot(state.baseProducts, state.activeQuery, filterState);
      if (kkHasNativeRangeNoMatch(filterQuery)) {
        freshForm = buildScopedFreshFacetForm(form, snapshot);
        noMatchResolution = kkResolveNativeRangeNoMatches(freshForm, filterQuery);
        if (noMatchResolution.changed) {
          kkApplyNativeRangeResolutions(form, noMatchResolution.resolved);
          filterQuery = noMatchResolution.query;
          filterState = buildScopedFilterState(instance, form, filterQuery);
          snapshot = buildScopedFacetSnapshot(state.baseProducts, state.activeQuery, filterState);
        }
      }
      state.lastFacetSnapshot = snapshot;
      applyScopedFacetSnapshot(instance, form, snapshot, window.location.pathname + '?' + filterQuery);
      if (ui && ui.setBusy) ui.setBusy(form, false);
    }, 60);

    return true;
  }

  function sortScopedProducts(instance, products, query) {
    var sorted = products.slice();
    var sortBy = trimSearchTerm(instance && instance.queryParams && instance.queryParams.sort_by);
    var normalizedQuery = String(query || '').toLowerCase();

    function sourceOrder(a, b) {
      return a.sourceOrder - b.sourceOrder;
    }

    if (sortBy === 'relevance' || !sortBy) {
      sorted.sort(function (a, b) {
        var aTitle = a.title.toLowerCase();
        var bTitle = b.title.toLowerCase();
        var aScore = aTitle.indexOf(normalizedQuery) === 0 ? 0 : aTitle.indexOf(normalizedQuery) !== -1 ? 1 : 2;
        var bScore = bTitle.indexOf(normalizedQuery) === 0 ? 0 : bTitle.indexOf(normalizedQuery) !== -1 ? 1 : 2;

        return aScore - bScore || sourceOrder(a, b);
      });
    } else if (sortBy === 'price-ascending') {
      sorted.sort(function (a, b) { return a.priceMin - b.priceMin || sourceOrder(a, b); });
    } else if (sortBy === 'price-descending') {
      sorted.sort(function (a, b) { return b.priceMin - a.priceMin || sourceOrder(a, b); });
    } else if (sortBy === 'title-ascending' || sortBy === 'alpha-ascending') {
      sorted.sort(function (a, b) { return a.title.localeCompare(b.title, undefined, { sensitivity: 'base' }) || sourceOrder(a, b); });
    } else if (sortBy === 'title-descending' || sortBy === 'alpha-descending') {
      sorted.sort(function (a, b) { return b.title.localeCompare(a.title, undefined, { sensitivity: 'base' }) || sourceOrder(a, b); });
    } else if (sortBy === 'created-ascending' || sortBy === 'date-ascending') {
      sorted.sort(function (a, b) { return a.createdAtTimestamp - b.createdAtTimestamp || sourceOrder(a, b); });
    } else if (sortBy === 'created-descending' || sortBy === 'date-descending') {
      sorted.sort(function (a, b) { return b.createdAtTimestamp - a.createdAtTimestamp || sourceOrder(a, b); });
    } else {
      sorted.sort(sourceOrder);
    }

    return sorted;
  }

  function runScopedWorkers(items, worker) {
    var next = 0;
    var workers = [];
    var count = Math.min(SCOPED_FETCH_CONCURRENCY, items.length);

    function runNext() {
      var item;

      if (next >= items.length) return Promise.resolve();
      item = items[next];
      next += 1;
      return Promise.resolve(worker(item)).then(runNext);
    }

    while (count > 0) {
      workers.push(runNext());
      count -= 1;
    }

    return Promise.all(workers);
  }

  function fetchScopedJson(url, signal) {
    return fetch(url, { credentials: 'same-origin', signal: signal }).then(function (response) {
      if (!response.ok) {
        throw new Error('Scoped collection index failed with status ' + response.status);
      }
      return response.text();
    }).then(function (text) {
      return JSON.parse(text);
    });
  }

  function loadScopedIndex(instance, filterQuery, state, signal) {
    var contextKey = getScopedContextKey(instance, filterQuery);
    var cached = state.indexCache.get(contextKey);

    if (cached) return Promise.resolve(cached);

    return fetchScopedJson(buildScopedViewUrl(instance, filterQuery, SCOPED_INDEX_VIEW, 1), signal).then(function (first) {
      var pages = Math.max(1, parseInt(first && first.pages, 10) || 1);
      var products = (first && first.products || []).map(normalizeScopedProduct);
      var remaining = [];
      var page;

      for (page = 2; page <= pages; page += 1) remaining.push(page);

      return runScopedWorkers(remaining, function (pageNumber) {
        return fetchScopedJson(buildScopedViewUrl(instance, filterQuery, SCOPED_INDEX_VIEW, pageNumber), signal).then(function (payload) {
          (payload && payload.products || []).forEach(function (raw) {
            products.push(normalizeScopedProduct(raw));
          });
        });
      }).then(function () {
        var seen = Object.create(null);

        products = products.filter(function (product) {
          if (!product.handle || seen[product.handle]) return false;
          seen[product.handle] = true;
          return true;
        }).sort(function (a, b) {
          return a.sourceOrder - b.sourceOrder;
        });

        rememberScopedCache(state.indexCache, contextKey, products);
        return products;
      });
    });
  }

  function productHandleFromCard(card) {
    var link = card && card.querySelector('[data-product-page-link], a[href*="/products/"]');
    var href = link && link.getAttribute('href') || '';
    var match = href.match(/\/products\/([^/?#]+)/);

    return match ? decodeURIComponent(match[1]) : '';
  }

  function loadScopedCardPage(instance, filterQuery, state, page, signal) {
    var contextKey = getScopedContextKey(instance, filterQuery);
    var cacheKey = contextKey + '|page:' + page;
    var cached = state.cardCache.get(cacheKey);

    if (cached) return Promise.resolve(cached);

    return fetch(buildScopedViewUrl(instance, filterQuery, SCOPED_CARD_VIEW, page), {
      credentials: 'same-origin',
      signal: signal
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Scoped collection card page failed with status ' + response.status);
      }
      return response.text();
    }).then(function (html) {
      var doc = parseCollectionResponseHtml(html);
      var cards = new Map();

      doc.querySelectorAll('[data-kk-collection-search-items] [data-product-item]').forEach(function (card) {
        var handle = productHandleFromCard(card);

        if (handle && !cards.has(handle)) cards.set(handle, card.outerHTML);
      });

      rememberScopedCache(state.cardCache, cacheKey, cards);
      return cards;
    });
  }

  function loadScopedCards(instance, filterQuery, state, products, signal) {
    var pages = [];
    var seenPages = Object.create(null);
    var cards = new Map();

    products.forEach(function (product) {
      var page = Math.floor(product.sourceOrder / SCOPED_INDEX_PAGE_SIZE) + 1;

      if (!seenPages[page]) {
        seenPages[page] = true;
        pages.push(page);
      }
    });

    return runScopedWorkers(pages, function (page) {
      return loadScopedCardPage(instance, filterQuery, state, page, signal).then(function (pageCards) {
        pageCards.forEach(function (html, handle) {
          cards.set(handle, html);
        });
      });
    }).then(function () {
      var missingProduct = products.find(function (product) {
        return !cards.has(product.handle);
      });

      if (missingProduct) {
        throw new Error('Scoped collection card was not found for ' + missingProduct.handle);
      }

      return cards;
    });
  }

  function getScopedPagination(instance, state) {
    var pagination = instance.el.querySelector('[data-kk-scoped-pagination]');
    var response = instance.el.querySelector(instance.responseContainerSelector);
    var nativePagination;

    if (!pagination && response) {
      nativePagination = response.querySelector(instance.paginationWrapperSelector);
      pagination = document.createElement('div');
      pagination.className = state.paginationClassName;
      pagination.setAttribute('data-kk-scoped-pagination', '');
      pagination.setAttribute('data-pagination-wrapper', '');
      pagination.setAttribute('data-html', 'pagination');
      response.insertBefore(pagination, nativePagination || null);
    }

    return pagination;
  }

  function updateScopedPagination(instance, state, shown, total, currentPage) {
    var pagination = getScopedPagination(instance, state);
    var button;

    if (!pagination) return;

    pagination.className = state.paginationClassName;
    pagination.setAttribute('data-pagination-wrapper', '');
    pagination.setAttribute('data-html', 'pagination');

    if (shown >= total) {
      pagination.innerHTML = '';
      return;
    }

    pagination.innerHTML = state.paginationTemplate;
    button = pagination.querySelector('[data-click-to-load]');

    if (!button) {
      button = document.createElement('button');
      button.className = 'button-primary';
      button.setAttribute('data-click-to-load', '');
      button.textContent = state.loadMoreText;
      pagination.appendChild(button);
    }

    button.setAttribute('data-to-page', String(currentPage + 1));
  }

  function ensureScopedGrid(instance, state) {
    var response = instance.el.querySelector(instance.responseContainerSelector);
    var grid = response && response.querySelector(instance.productGridSelector);
    var pagination = getScopedPagination(instance, state);

    if (grid) return grid;
    if (!response) return null;

    response.querySelectorAll('.productgrid--no-results').forEach(function (empty) {
      empty.remove();
    });
    grid = document.createElement('ul');
    grid.className = state.gridClassName;
    grid.setAttribute('data-product-grid', '');
    grid.setAttribute('data-html', 'productgridItems');
    response.insertBefore(grid, pagination || null);
    return grid;
  }

  function renderScopedEmpty(instance, state, query) {
    var response = instance.el.querySelector(instance.responseContainerSelector);
    var grid = response && response.querySelector(instance.productGridSelector);
    var empty;

    if (!response) return;
    if (grid) grid.remove();
    response.querySelectorAll('.productgrid--no-results').forEach(function (node) { node.remove(); });

    empty = document.createElement('div');
    empty.className = 'productgrid--no-results';
    empty.setAttribute('data-kk-scoped-search-empty', '');
    empty.innerHTML = '<h2 class="productgrid--no-results-title"></h2>';
    empty.querySelector('h2').textContent = state.noResultsTemplate.replace(/\[\[terms\]\]/g, query);
    response.insertBefore(empty, getScopedPagination(instance, state) || null);
  }

  function renderScopedCards(instance, state, products, cardMap, append, total, currentPage, query) {
    var response = instance.el.querySelector(instance.responseContainerSelector);
    var grid;
    var fragment;
    var holder;
    var newCards;

    if (!response) return;

    activateScopedResponse(instance);

    if (!append) {
      instance.initializedProductCards.forEach(function (item) { item.unload(); });
      instance.initializedProductCards = [];
      response.querySelectorAll('[data-kk-scoped-search-empty]').forEach(function (node) { node.remove(); });
    }

    if (!total) {
      renderScopedEmpty(instance, state, query);
      updateScopedPagination(instance, state, 0, 0, currentPage);
      response.setAttribute('data-product-count', '0');
      return;
    }

    grid = ensureScopedGrid(instance, state);
    if (!grid) return;
    if (!append) grid.innerHTML = '';

    fragment = document.createDocumentFragment();
    holder = document.createElement('div');
    holder.innerHTML = products.map(function (product) {
      return cardMap.get(product.handle) || '';
    }).join('');

    while (holder.firstChild) fragment.appendChild(holder.firstChild);
    newCards = fragment.querySelectorAll(instance.productItemSelector);
    grid.appendChild(fragment);
    instance._initProductCards(newCards);
    response.setAttribute('data-product-count', String(total));
    updateScopedPagination(instance, state, Math.min(currentPage * state.productsPerPage, total), total, currentPage);
    response.dispatchEvent(new CustomEvent('theme:rimg:watch', { bubbles: true }));
  }

  function replaceSidebarFilters(instance, html) {
    var sidebarContainer = instance.el.querySelector(instance.sidebarContainerSelector);
    var currentFilters = sidebarContainer && sidebarContainer.querySelector('[data-productgrid-filters-content]');
    var nextFilters = html.querySelector('[data-kk-search-sidebar-filters]');

    if (!sidebarContainer) {
      return;
    }

    if (nextFilters && currentFilters) {
      currentFilters.outerHTML = nextFilters.outerHTML;
      return;
    }

    if (nextFilters && !currentFilters) {
      sidebarContainer.insertAdjacentHTML('afterbegin', nextFilters.outerHTML);
      return;
    }

    if (!nextFilters && currentFilters) {
      currentFilters.remove();
    }
  }

  function replaceSortModal(instance, html) {
    var currentSortModal = document.querySelector(instance.sortContentSelector);
    var nextSortModal = html.querySelector(instance.sortContentSelector);

    if (currentSortModal && nextSortModal) {
      currentSortModal.outerHTML = nextSortModal.outerHTML;
    } else if (!currentSortModal && nextSortModal) {
      instance.el.insertAdjacentHTML('beforeend', nextSortModal.outerHTML);
    }
  }

  function patchStaticCollectionSearchMode() {
    var proto = window.bcStaticCollection && window.bcStaticCollection.prototype;
    var originalFetchResults;
    var originalReplaceResults;
    var originalAppendResults;
    var originalSetProcessing;
    var rimgWatchEvent;

    if (!proto || proto.kkEmbeddedSearchPatched) {
      return;
    }

    originalFetchResults = proto._fetchResults;
    originalReplaceResults = proto._replaceResults;
    originalAppendResults = proto._appendResults;
    originalSetProcessing = proto._setProcessing;
    rimgWatchEvent = typeof CustomEvent === 'function' ?
      function (target) {
        target.dispatchEvent(new CustomEvent('theme:rimg:watch', { bubbles: true }));
      } :
      function () {};

    function getResponseProductCount(container) {
      var responseContainer = container && container.querySelector('[data-results-container][data-product-count]');
      var count = responseContainer ? parseInt(responseContainer.getAttribute('data-product-count'), 10) : null;

      return isNaN(count) ? null : count;
    }

    proto._setProcessing = function () {
      var processing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'filter';
      var sidebarContainer;
      var responseContainer;

      if (!isSearchMode(this) || type !== 'filter') {
        return originalSetProcessing.apply(this, arguments);
      }

      this.processing = processing;
      sidebarContainer = this.el.querySelector(this.sidebarContainerSelector);
      responseContainer = this.el.querySelector(this.responseContainerSelector);

      if (sidebarContainer) {
        sidebarContainer.classList.toggle('processing--' + type, processing);
      }

      if (responseContainer) {
        responseContainer.classList.toggle('processing--' + type, processing);
      }
    };

    proto._replaceResults = function (html) {
      var responseContainer;
      var nextResponseContainer;
      var originalResult;

      if (!isSearchMode(this)) {
        restorePagination(this);
        originalResult = originalReplaceResults.call(this, html);
        responseContainer = this.el.querySelector(this.responseContainerSelector);
        nextResponseContainer = html.querySelector(this.responseContainerSelector);

        if (responseContainer && nextResponseContainer) {
          if (nextResponseContainer.hasAttribute('data-product-count')) {
            responseContainer.setAttribute('data-product-count', nextResponseContainer.getAttribute('data-product-count'));
          } else {
            responseContainer.removeAttribute('data-product-count');
          }
        }

        return originalResult;
      }

      responseContainer = this.el.querySelector(this.responseContainerSelector);
      nextResponseContainer = html.querySelector(this.responseContainerSelector);

      if (!responseContainer || !nextResponseContainer) {
        return originalReplaceResults.call(this, html);
      }

      this.initializedProductCards.forEach(function (item) {
        item.unload();
      });
      this.initializedProductCards = [];
      this._unbindEvents();

      responseContainer.innerHTML = nextResponseContainer.innerHTML;
      if (nextResponseContainer.hasAttribute('data-product-count')) {
        responseContainer.setAttribute('data-product-count', nextResponseContainer.getAttribute('data-product-count'));
      } else {
        responseContainer.removeAttribute('data-product-count');
      }
      this._initProductCards(responseContainer.querySelectorAll(this.productItemSelector));
      rimgWatchEvent(responseContainer);

      replaceSidebarFilters(this, html);
      replaceSortModal(this, html);
    };

    proto._appendResults = function (html) {
      if (!isSearchMode(this)) {
        restorePagination(this);
        return originalAppendResults.call(this, html);
      }

      return originalAppendResults.call(this, html);
    };

    proto._fetchResults = function () {
      var append = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var filterParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var processingType = append ? 'pagination' : 'filter';
      var hasExplicitPage = filterParams !== null && /(^|&)page=/.test(filterParams);
      var filterQuery = sanitizeFilterQuery(this, filterParams === null ? this._getFilterParams() : filterParams);
      var state;
      var requestId;
      var controller;
      var query;
      var currentPage;

      if (!append && !hasExplicitPage) {
        this.queryParams.page = 1;
      }

      if (!isSearchMode(this)) {
        cancelScopedSearch(this);
        restoreScopedResponse(this);
        restorePagination(this);
        return originalFetchResults.call(this, append, filterQuery);
      }

      setSearchPagination(this);
      state = getScopedSearchState(this);
      state.requestId += 1;
      requestId = state.requestId;
      state.mobileFacetGeneration += 1;
      window.clearTimeout(state.mobileFacetTimer);
      state.mobileFacetTimer = null;
      if (window.kkNativeFacetUi && window.kkNativeFacetUi.setBusy) {
        window.kkNativeFacetUi.setBusy(getScopedFilterForm(this), false);
      }

      if (state.controller) state.controller.abort();
      controller = new AbortController();
      state.controller = controller;
      query = trimSearchTerm(this.queryParams.q);
      currentPage = Math.max(1, parseInt(this.queryParams.page, 10) || 1);
      this.queryParams.page = currentPage;

      this._setProcessing(true, processingType);
      this._unbindEvents();

      // Facet parity requires the complete collection index. Active native
      // filters are applied locally so each facet can be counted with its own
      // current selection excluded, exactly like the headless implementation.
      loadScopedIndex(this, '', state, controller.signal).then(function (products) {
        var matches;
        var filterForm;
        var filterState;
        var facetSnapshot;
        var freshForm;
        var noMatchResolution;
        var firstVisibleIndex;
        var lastVisibleIndex;
        var visibleProducts;

        if (requestId !== state.requestId || controller.signal.aborted) return null;

        filterForm = getScopedFilterForm(this);
        filterState = buildScopedFilterState(this, filterForm, filterQuery);
        facetSnapshot = buildScopedFacetSnapshot(products, query, filterState);
        if (kkHasNativeRangeNoMatch(filterQuery)) {
          freshForm = buildScopedFreshFacetForm(filterForm, facetSnapshot);
          noMatchResolution = kkResolveNativeRangeNoMatches(freshForm, filterQuery);
          if (noMatchResolution.changed) {
            kkApplyNativeRangeResolutions(filterForm, noMatchResolution.resolved);
            filterQuery = noMatchResolution.query;
            filterState = buildScopedFilterState(this, filterForm, filterQuery);
            facetSnapshot = buildScopedFacetSnapshot(products, query, filterState);
          }
        }
        state.baseProducts = products;
        state.activeQuery = query;
        state.lastFacetSnapshot = facetSnapshot;
        matches = sortScopedProducts(this, facetSnapshot.resultProducts, query);
        firstVisibleIndex = append ? (currentPage - 1) * state.productsPerPage : 0;
        lastVisibleIndex = currentPage * state.productsPerPage;
        visibleProducts = matches.slice(firstVisibleIndex, lastVisibleIndex);

        return loadScopedCards(this, '', state, visibleProducts, controller.signal).then(function (cardMap) {
          return {
            cardMap: cardMap,
            facetSnapshot: facetSnapshot,
            matches: matches,
            visibleProducts: visibleProducts
          };
        });
      }.bind(this)).then(function (result) {
        var resultCount;

        if (!result || requestId !== state.requestId || controller.signal.aborted) return;

        resultCount = result.matches.length;
        renderScopedCards(
          this,
          state,
          result.visibleProducts,
          result.cardMap,
          append,
          resultCount,
          currentPage,
          query
        );
        kkEnsureNativeRangeNoMatchChips(this.el, filterQuery);
        applyScopedFacetSnapshot(
          this,
          getScopedFilterForm(this),
          result.facetSnapshot,
          window.location.pathname + '?' + filterQuery
        );

        this.kkPendingFilterQueryForHistory = filterQuery;
        this.kkUsePendingFilterQueryForHistory = true;
        this._updateHistory();
        this.kkUsePendingFilterQueryForHistory = false;
        this._bindEvents();
        this._handleViewToggle(null);
        this._setProcessing(false, processingType);
        state.controller = null;
        document.dispatchEvent(new CustomEvent('kk:collection-search-complete', {
          detail: {
            resultCount: resultCount,
            source: 'native-collection-scoped'
          }
        }));

        if (this.modal.isOpen()) {
          this.modal.close();
        }
      }.bind(this)).catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (requestId !== state.requestId) return;

        console.error(error);
        state.controller = null;
        this.kkUsePendingFilterQueryForHistory = false;
        if (this.processing) {
          this._bindEvents();
          this._setProcessing(false, processingType);
        }
        document.dispatchEvent(new CustomEvent('kk:collection-search-error'));
      }.bind(this));
    };

    proto.kkEmbeddedSearchPatched = true;
  }

  window.kkScopedNativeFacets = {
    refresh: refreshScopedMobileFacets
  };

  window.addEventListener('resize', function () {
    var instance = findCollectionInstance();
    var state = instance && scopedSearchStates.get(instance);

    if (!state || !state.lastFacetSnapshot || !isSearchMode(instance)) return;

    window.clearTimeout(state.facetResizeTimer);
    state.facetResizeTimer = window.setTimeout(function () {
      state.facetResizeTimer = null;
      if (isSearchMode(instance)) {
        applyScopedFacetSnapshot(instance, getScopedFilterForm(instance), state.lastFacetSnapshot, 'resize');
      }
    }, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchStaticCollectionSearchMode);
  } else {
    patchStaticCollectionSearchMode();
  }
}());

(function () {
  var COLLECTION_AUTO_SEARCH_DELAY = 1000;

  function getScopedSearchHelpers() {
    return window.kkScopedSearch || null;
  }

  function isMobileSearchUi() {
    return window.matchMedia ?
      window.matchMedia('(max-width: 859px)').matches :
      window.innerWidth < 860;
  }

  function encodeSearchTerm(term) {
    var helpers = getScopedSearchHelpers();
    var params = new URLSearchParams();
    var query = helpers ? helpers.buildQuery(term) : term;

    params.set('q', query);

    return params.toString().replace(/^q=/, '');
  }

  function decodeSearchTerm(term) {
    try {
      return decodeURIComponent(String(term || '').replace(/\+/g, '%20'));
    } catch (error) {
      return String(term || '').replace(/\+/g, ' ');
    }
  }

  function getSearchUrl(term) {
    var helpers = getScopedSearchHelpers();
    var url = new URL(window.Theme && window.Theme.routes && window.Theme.routes.search_url ?
      window.Theme.routes.search_url :
      '/search', window.location.origin);

    url.searchParams.set('type', 'product');
    url.searchParams.set('q', helpers ? helpers.buildQuery(term) : term);

    return url.pathname + (url.search ? url.search : '');
  }

  function getPredictiveState(root) {
    if (!root._kkCollectionPredictiveState) {
      root._kkCollectionPredictiveState = {
        requestId: 0,
        timer: null
      };
    }

    return root._kkCollectionPredictiveState;
  }

  function getPredictiveQuery(term) {
    var helpers = getScopedSearchHelpers();

    return helpers ? helpers.buildQuery(term) : term;
  }

  function getPredictiveFlydown(root) {
    var flydown = root.querySelector('[data-kk-collection-search-predictive]');

    if (!flydown) {
      flydown = document.createElement('div');
      flydown.className = 'kk-collection-search__predictive';
      flydown.setAttribute('data-kk-collection-search-predictive', '');
      flydown.setAttribute('role', 'region');
      flydown.hidden = true;
      root.appendChild(flydown);
    }

    return flydown;
  }

  function getPredictiveSearchUrl(searchQuery) {
    var url = new URL(window.Theme && window.Theme.routes && window.Theme.routes.predictive_search_url ?
      window.Theme.routes.predictive_search_url :
      '/search/suggest', window.location.origin);

    url.searchParams.set('q', searchQuery);
    url.searchParams.set('section_id', 'predictive-search');
    url.searchParams.set('resources[limit]', '8');
    url.searchParams.set('resources[limit_scope]', 'each');

    return url.toString();
  }

  function getSearchCountUrl(searchQuery) {
    var url = new URL(window.Theme && window.Theme.routes && window.Theme.routes.search_url ?
      window.Theme.routes.search_url :
      '/search', window.location.origin);

    url.searchParams.set('view', 'kk-count');
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', searchQuery);

    return url.toString();
  }

  function showPredictivePending(root) {
    var flydown = getPredictiveFlydown(root);

    flydown.hidden = false;
    flydown.setAttribute('aria-busy', 'true');
    flydown.innerHTML = [
      '<div class="kk-predictive-search kk-predictive-search--pending visible" data-predictive-search>',
      '<div class="search-flydown__no-results kk-predictive-search__pending-body"></div>',
      '<div class="search-flydown__footer kk-predictive-search__footer kk-predictive-search__footer--pending">',
      '<span class="kk-predictive-search__continue kk-predictive-search__continue--pending" aria-hidden="true"></span>',
      '</div>',
      '</div>'
    ].join('');
  }

  function hidePredictiveSearch(root) {
    var state = getPredictiveState(root);
    var flydown = root.querySelector('[data-kk-collection-search-predictive]');

    state.requestId += 1;
    window.clearTimeout(state.timer);
    state.timer = null;

    if (!flydown) {
      return;
    }

    flydown.hidden = true;
    flydown.removeAttribute('aria-busy');
    flydown.innerHTML = '';
  }

  function updatePredictiveCount(flydown, searchQuery, requestId, state) {
    var countLabel = flydown.querySelector('[data-kk-predictive-search-count-label]');

    if (!countLabel) {
      return;
    }

    function updateCountLabel(count) {
      var numericCount = parseInt(count, 10);
      var displayCount;
      var template;

      if (isNaN(numericCount)) {
        return;
      }

      displayCount = numericCount >= 1000 ? '1000+' : numericCount;

      template = numericCount === 1 ?
        countLabel.getAttribute('data-kk-predictive-search-count-template-one') :
        countLabel.getAttribute('data-kk-predictive-search-count-template-other');

      if (!template) {
        return;
      }

      countLabel.textContent = template.replace(/\[\[count\]\]/g, displayCount);
    }

    fetch(getSearchCountUrl(searchQuery), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error(response.status);
      }

      return response.text();
    }).then(function (html) {
      var parsed;
      var countElement;
      var productCount;

      if (requestId !== state.requestId) {
        return;
      }

      parsed = parseCollectionResponseHtml(html);
      countElement = parsed.querySelector('[data-kk-search-count]');

      if (!countElement) {
        return;
      }

      productCount = countElement.getAttribute('data-kk-search-count');

      if (productCount !== null) {
        updateCountLabel(productCount);
      }
    }).catch(function () {});
  }

  function fetchPredictiveSearch(root, term) {
    var state = getPredictiveState(root);
    var requestId = state.requestId + 1;
    var searchQuery = getPredictiveQuery(term);

    state.requestId = requestId;

    fetch(getPredictiveSearchUrl(searchQuery)).then(function (response) {
      if (!response.ok) {
        throw new Error(response.status);
      }

      return response.text();
    }).then(function (html) {
      var flydown;

      if (requestId !== state.requestId) {
        return;
      }

      flydown = getPredictiveFlydown(root);
      flydown.innerHTML = html;
      flydown.hidden = false;
      flydown.setAttribute('aria-busy', 'false');
      updatePredictiveCount(flydown, searchQuery, requestId, state);
    }).catch(function () {
      if (requestId === state.requestId) {
        hidePredictiveSearch(root);
      }
    });
  }

  function queuePredictiveSearch(root) {
    var parts = getParts(root);
    var term = parts.input ? parts.input.value.trim() : '';
    var state = getPredictiveState(root);

    window.clearTimeout(state.timer);

    if (!term) {
      hidePredictiveSearch(root);
      return;
    }

    showPredictivePending(root);
    state.timer = window.setTimeout(function () {
      fetchPredictiveSearch(root, term);
    }, 220);
  }

  function getAutoSearchState(root) {
    if (!root._kkCollectionAutoSearchState) {
      root._kkCollectionAutoSearchState = {
        timer: null
      };
    }

    return root._kkCollectionAutoSearchState;
  }

  function clearQueuedAutoSearch(root) {
    var state = getAutoSearchState(root);

    window.clearTimeout(state.timer);
    state.timer = null;
  }

  function queueAutoSearch(root) {
    var state = getAutoSearchState(root);

    clearQueuedAutoSearch(root);

    state.timer = window.setTimeout(function () {
      var parts = getParts(root);
      var term = parts.input ? parts.input.value.trim() : '';

      if (term) {
        runEmbeddedSearch(root, { allowRedirect: true });
      } else {
        runEmbeddedSearch(root);
      }
    }, COLLECTION_AUTO_SEARCH_DELAY);
  }

  function getParts(root) {
    return {
      input: root.querySelector('[data-kk-collection-search-input]'),
      submit: root.querySelector('[data-kk-collection-search-submit]'),
      clear: root.querySelector('[data-kk-collection-search-clear]')
    };
  }

  function getStatus(root) {
    var status = root.querySelector('[data-kk-collection-search-status]');

    if (!status) {
      status = document.createElement('div');
      status.className = 'kk-collection-search__status';
      status.setAttribute('data-kk-collection-search-status', '');
      status.setAttribute('aria-live', 'polite');
      root.appendChild(status);
    }

    return status;
  }

  function updateStatus(root, message) {
    var status = getStatus(root);

    status.textContent = message || '';
    status.hidden = !message;
  }

  function getResultCount(root) {
    var instance = findCollectionInstance();
    var resultsContainer = null;
    var count = null;

    if (root && root.dataset && root.dataset.kkCollectionSearchCount) {
      count = parseInt(root.dataset.kkCollectionSearchCount, 10);
      return isNaN(count) ? null : count;
    }

    if (instance && instance.el && typeof instance.el.querySelector === 'function') {
      resultsContainer = instance.el.querySelector('[data-results-container][data-product-count]');
    }

    if (!resultsContainer && root && typeof root.closest === 'function') {
      var section = root.closest('.shopify-section');

      if (section) {
        resultsContainer = section.querySelector('[data-results-container][data-product-count]');
      }
    }

    if (!resultsContainer) {
      resultsContainer = document.querySelector('[data-results-container][data-product-count]');
    }

    if (resultsContainer) {
      count = parseInt(resultsContainer.getAttribute('data-product-count'), 10);
    }

    return isNaN(count) ? null : count;
  }

  function getLanguageString(key, fallback) {
    var language = window.Theme && window.Theme.language;

    if (language && typeof language[key] === 'string' && language[key] !== '') {
      return language[key];
    }

    return fallback;
  }

  function formatLanguageCount(oneKey, otherKey, count, fallbackOne, fallbackOther) {
    var template;

    if (count === null) {
      return '';
    }

    template = count === 1 ?
      getLanguageString(oneKey, fallbackOne) :
      getLanguageString(otherKey, fallbackOther);

    return String(template).replace(/\[\[count\]\]/g, count);
  }

  function formatResultCount(count) {
    return formatLanguageCount(
      'collection_search_result_count_one',
      'collection_search_result_count_other',
      count,
      '[[count]] tulos',
      '[[count]] tulosta'
    );
  }

  function updateClearButton(root) {
    var parts = getParts(root);

    if (parts.clear && parts.input) {
      parts.clear.hidden = parts.input.value.trim() === '';
    }
  }

  function findCollectionInstance() {
    var instances = window.bcSections && window.bcSections.instances;
    var found = null;

    if (!instances || !window.bcStaticCollection) {
      return null;
    }

    Object.keys(instances).some(function (key) {
      var instance = instances[key];

      if (instance instanceof window.bcStaticCollection) {
        found = instance;
        return true;
      }

      return false;
    });

    return found;
  }

  function getCurrentUrlTerm() {
    var helpers = getScopedSearchHelpers();
    var query = new URLSearchParams(window.location.search).get('q') || '';

    if (helpers) {
      return helpers.extractTerm(query);
    }

    return decodeSearchTerm(query);
  }

  function syncInputFromUrl(root) {
    var parts = getParts(root);

    if (!parts.input) {
      return '';
    }

    parts.input.value = getCurrentUrlTerm();
    updateClearButton(root);

    return parts.input.value;
  }

  function runEmbeddedSearch(root, options) {
    var parts = getParts(root);
    var instance = findCollectionInstance();
    var term = parts.input ? parts.input.value.trim() : '';

    updateClearButton(root);

    if (!instance || typeof instance._fetchResults !== 'function') {
      if (!term) {
        updateStatus(root, '');
        return;
      }

      updateStatus(root, getLanguageString('collection_search_error', 'Search failed.'));
      return;
    }

    if (term) {
      instance.queryParams.q = encodeSearchTerm(term);
      updateStatus(root, getLanguageString('collection_search_loading', 'Haetaan tuotteita...'));
    } else {
      delete instance.queryParams.q;
      updateStatus(root, '');
    }

    instance.queryParams.page = 1;
    instance._fetchResults(false);
  }

  function syncUi(root, options) {
    var parts = getParts(root);
    var draftTerm = parts.input ? parts.input.value.trim() : '';
    var activeTerm = getCurrentUrlTerm();
    var isDirty = draftTerm !== activeTerm;

    updateClearButton(root);

    if (options && Object.prototype.hasOwnProperty.call(options, 'status')) {
      updateStatus(root, options.status);
      return;
    }

    if (isDirty) {
      updateStatus(root, '');
      return;
    }

    if (activeTerm) {
      updateStatus(root, formatResultCount(getResultCount(root)));
    } else {
      updateStatus(root, '');
    }
  }

  function submitSearch(root) {
    var parts = getParts(root);
    var term = parts.input ? parts.input.value.trim() : '';

    updateClearButton(root);
    clearQueuedAutoSearch(root);
    hidePredictiveSearch(root);

    if (!term) {
      updateStatus(root, getLanguageString('collection_search_type_prompt', 'Kirjoita hakusana hakeaksesi.'));
      return;
    }

    runEmbeddedSearch(root, { allowRedirect: true });
  }

  function clearSearch(root) {
    var parts = getParts(root);

    if (parts.input) {
      parts.input.value = '';
      parts.input.focus();
    }

    clearQueuedAutoSearch(root);
    hidePredictiveSearch(root);
    runEmbeddedSearch(root);
  }

  function handleCollectionSearchInput(root) {
    syncUi(root);
    hidePredictiveSearch(root);
    queueAutoSearch(root);
  }

  function initCollectionSearch(root) {
    var parts = getParts(root);
    var hydrated = false;

    if (
      root &&
      root.closest &&
      root.closest('[data-kk-headless-collection]') &&
      window.KKHeadlessCollection &&
      window.KKHeadlessCollection.enabled &&
      window.KKHeadlessCollection.storefrontToken
    ) {
      return;
    }

    if (!parts.input) {
      return;
    }

    if (root.dataset.kkCollectionSearchReady === 'true') {
      syncInputFromUrl(root);
      syncUi(root);
      return;
    }

    root.dataset.kkCollectionSearchReady = 'true';
    syncInputFromUrl(root);
    syncUi(root);

    parts.input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        clearQueuedAutoSearch(root);
        submitSearch(root);
      } else if (event.key === 'Escape') {
        hidePredictiveSearch(root);
      }
    });

    if (parts.submit) {
      parts.submit.addEventListener('click', function () {
        clearQueuedAutoSearch(root);
        submitSearch(root);
      });
    }

    if (parts.clear) {
      parts.clear.addEventListener('click', function () {
        clearSearch(root);
      });
    }

    function hydrateFromUrl(attempt) {
      var termFromUrl = syncInputFromUrl(root);
      var instance = findCollectionInstance();

      if (instance && !termFromUrl && instance.queryParams && instance.queryParams.q) {
        delete instance.queryParams.q;
        hydrated = false;
        runEmbeddedSearch(root);
        return;
      }

      if (!hydrated && termFromUrl && instance) {
        hydrated = true;
        runEmbeddedSearch(root);
      } else if (!hydrated && termFromUrl && (attempt || 0) < 20) {
        window.setTimeout(function () {
          hydrateFromUrl((attempt || 0) + 1);
        }, 150);
      }
    }

    window.setTimeout(function () {
      hydrateFromUrl(0);
    }, 150);
    window.addEventListener('popstate', function () {
      hydrated = false;
      hydrateFromUrl(0);
    });

    document.addEventListener('kk:collection-search-complete', function (event) {
      if (event && event.detail && !isNaN(parseInt(event.detail.resultCount, 10))) {
        root.dataset.kkCollectionSearchCount = String(parseInt(event.detail.resultCount, 10));
      }

      syncUi(root);
    });

    document.addEventListener('kk:collection-search-error', function () {
      updateStatus(root, getLanguageString('collection_search_error', 'Search failed.'));
    });
  }

  function initAllCollectionSearches() {
    document.querySelectorAll('[data-kk-collection-search]').forEach(initCollectionSearch);
  }

  document.addEventListener('input', function (event) {
    var input = event.target && event.target.closest ?
      event.target.closest('[data-kk-collection-search-input]') :
      null;
    var root = input && input.closest ?
      input.closest('[data-kk-collection-search]') :
      null;

    if (
      root &&
      !(
        root.closest &&
        root.closest('[data-kk-headless-collection]') &&
        window.KKHeadlessCollection &&
        window.KKHeadlessCollection.enabled &&
        window.KKHeadlessCollection.storefrontToken
      )
    ) {
      handleCollectionSearchInput(root);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCollectionSearches);
  } else {
    initAllCollectionSearches();
  }
}());
}());
